module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 34);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = require("@cian/utils");

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var _a, _b;
var MVKPhase;
(function (MVKPhase) {
    MVKPhase["FLAT"] = "flat";
    MVKPhase["PREVIEW"] = "preview";
    MVKPhase["SECTION"] = "section";
})(MVKPhase = exports.MVKPhase || (exports.MVKPhase = {}));
var FlatType;
(function (FlatType) {
    FlatType[FlatType["ROOM"] = 0] = "ROOM";
    FlatType[FlatType["ONE_ROOM"] = 1] = "ONE_ROOM";
    FlatType[FlatType["TWO_ROOM"] = 2] = "TWO_ROOM";
    FlatType[FlatType["THREE_ROOM"] = 3] = "THREE_ROOM";
    FlatType[FlatType["FOUR_ROOM"] = 4] = "FOUR_ROOM";
    FlatType[FlatType["FIVE_ROOM"] = 5] = "FIVE_ROOM";
    FlatType[FlatType["LARGE"] = 6] = "LARGE";
    FlatType[FlatType["OPEN_PLAN"] = 7] = "OPEN_PLAN";
    FlatType[FlatType["SHARE"] = 8] = "SHARE";
    FlatType[FlatType["STUDIO"] = 9] = "STUDIO";
    FlatType[FlatType["BED"] = 10] = "BED";
})(FlatType = exports.FlatType || (exports.FlatType = {}));
exports.InfrastructureCategory = (_a = {},
    _a[0 /* Schools */] = 'school',
    _a[1 /* Kindergarden */] = 'nursery',
    _a[2 /* Polyclinics */] = 'clinic',
    _a[3 /* GroceryStores */] = 'grocery',
    _a[4 /* Cafes */] = 'cafe',
    _a);
exports.MAP_FLAT_TYPE_TO_FLAT_TYPE_FOR_FILTER = (_b = {},
    _b[FlatType.BED] = FlatType.ONE_ROOM,
    _b[FlatType.ROOM] = FlatType.ONE_ROOM,
    _b[FlatType.ONE_ROOM] = FlatType.ONE_ROOM,
    _b[FlatType.TWO_ROOM] = FlatType.TWO_ROOM,
    _b[FlatType.THREE_ROOM] = FlatType.THREE_ROOM,
    _b[FlatType.FOUR_ROOM] = FlatType.FOUR_ROOM,
    _b[FlatType.FIVE_ROOM] = FlatType.FOUR_ROOM,
    _b[FlatType.LARGE] = FlatType.FOUR_ROOM,
    _b[FlatType.OPEN_PLAN] = FlatType.STUDIO,
    _b[FlatType.SHARE] = FlatType.STUDIO,
    _b[FlatType.STUDIO] = FlatType.STUDIO,
    _b);
exports.FLAT_TYPES_FILTERS = [
    { type: FlatType.STUDIO, title: 'Студия' },
    { type: FlatType.ONE_ROOM, title: '1' },
    { type: FlatType.TWO_ROOM, title: '2' },
    { type: FlatType.THREE_ROOM, title: '3' },
    { type: FlatType.FOUR_ROOM, title: '4+' },
];


/***/ }),
/* 3 */
/***/ (function(module, exports) {

module.exports = require("react-redux");

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var bodyClass_1 = __webpack_require__(19);
var resize_1 = __webpack_require__(39);
var mvk_data_1 = __webpack_require__(9);
var flats_1 = __webpack_require__(5);
var sections_1 = __webpack_require__(6);
var url_1 = __webpack_require__(22);
function toggleRouteUpdateAction(isInitial) {
    resize_1.toggleResizeEvent();
    var queryString = window && window.history.state
        && window.history.state.uri
        ? url_1.getURIWithoutHash(window.history.state.uri.split('?').pop())
        : undefined;
    return {
        isInitial: isInitial,
        queryString: queryString,
        type: 'IToggleRouteUpdateAction',
    };
}
exports.toggleRouteUpdateAction = toggleRouteUpdateAction;
function setMVKPhaseAction(phase) {
    return {
        phase: phase,
        type: 'ISetMVKPhaseAction',
    };
}
exports.setMVKPhaseAction = setMVKPhaseAction;
function setHoveredHouseIdAction(houseId) {
    return {
        houseId: houseId,
        type: 'ISetHoveredHouseIdAction',
    };
}
exports.setHoveredHouseIdAction = setHoveredHouseIdAction;
function setHoveredSectionIdAction(sectionId, houseId, shouldIgnoreScroll) {
    return {
        houseId: houseId,
        sectionId: sectionId,
        shouldIgnoreScroll: shouldIgnoreScroll,
        type: 'ISetHoveredSectionIdAction',
    };
}
exports.setHoveredSectionIdAction = setHoveredSectionIdAction;
function setHoveredFlatIdAction(flatId) {
    return {
        flatId: flatId,
        type: 'ISetHoveredFlatIdAction',
    };
}
exports.setHoveredFlatIdAction = setHoveredFlatIdAction;
function toggleFullScreenAction(state) {
    resize_1.toggleResizeEvent();
    bodyClass_1.triggerBodyClass('mvk_full_screen', state);
    return {
        state: state,
        type: 'IToggleFullScreenAction',
    };
}
exports.toggleFullScreenAction = toggleFullScreenAction;
function changeFullScreenTipVisibilityAction(state) {
    return {
        state: state,
        type: 'IChangeFullScreenTipVisiblityAction',
    };
}
exports.changeFullScreenTipVisibilityAction = changeFullScreenTipVisibilityAction;
function setHouseIdAction(houseId) {
    return function (dispatch, getState) {
        var MVKData = getState().MVKData;
        dispatch({
            houseId: houseId,
            type: 'ISetHouseIdAction',
        });
        var selectedHouse = mvk_data_1.getMVKHouseById(MVKData, houseId);
        if (selectedHouse && selectedHouse.sections.length === 1) {
            dispatch(setSectionIdAction(selectedHouse.sections[0].id));
        }
    };
}
exports.setHouseIdAction = setHouseIdAction;
function setSectionIdAction(sectionId) {
    return function (dispatch, getState) {
        var _a = getState(), MVKData = _a.MVKData, house = _a.MVKState.house;
        dispatch({
            sectionId: sectionId,
            type: 'ISetSectionIdAction',
        });
        var floorsWithFlats = sections_1.getFloorsInSection(MVKData, house.id, sectionId)
            .filter(function (floor) { return flats_1.getFlatsInSectionFloor(MVKData, house.id, sectionId, floor).length; });
        if (floorsWithFlats[0]) {
            dispatch(setFloorFilterAction(floorsWithFlats[0]));
        }
    };
}
exports.setSectionIdAction = setSectionIdAction;
function setFlatIdAction(flatId) {
    return {
        flatId: flatId,
        type: 'ISetFlatIdAction',
    };
}
exports.setFlatIdAction = setFlatIdAction;
function toggleFlatFilterAction(flatType) {
    return {
        flatType: flatType,
        type: 'IToggleFlatFilterAction',
    };
}
exports.toggleFlatFilterAction = toggleFlatFilterAction;
function setFloorFilterAction(floor) {
    return {
        floor: floor,
        type: 'ISetFloorFilterAction',
    };
}
exports.setFloorFilterAction = setFloorFilterAction;


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var helpers_1 = __webpack_require__(11);
var mvk_state_1 = __webpack_require__(2);
var sorters_1 = __webpack_require__(14);
var mvk_data_1 = __webpack_require__(9);
var sections_1 = __webpack_require__(6);
function getSectionFlats(MVKData, houseId, sectionId) {
    if (!houseId || !sectionId) {
        return [];
    }
    var selectedHouse = mvk_data_1.getMVKHouseById(MVKData, houseId);
    var selectedSection = selectedHouse && selectedHouse.sections.find(function (section) { return section.id === sectionId; });
    var flats = selectedSection && MVKData.offers.filter(function (offer) {
        return offer.houseId === houseId && offer.sectionNumber === selectedSection.number;
    });
    return flats || [];
}
exports.getSectionFlats = getSectionFlats;
function getFlatsInSectionFloor(MVKData, houseId, sectionId, floor) {
    if (!houseId || !sectionId || !floor) {
        return [];
    }
    var sectionFlats = getSectionFlats(MVKData, houseId, sectionId);
    var floorFlats = sectionFlats.filter(function (flat) { return flat.floor === floor; });
    var floorScheme = sections_1.getFloorScheme(MVKData, houseId, sectionId, floor);
    var floorFlatsWithPolygons = floorFlats.filter(function (flat) {
        return floorScheme && floorScheme.floorPlanFlats.some(function (floorPlan) { return floorPlan.flatNumber === flat.flatNumber; });
    });
    return floorFlatsWithPolygons;
}
exports.getFlatsInSectionFloor = getFlatsInSectionFloor;
function getFlatTypesInFloor(MVKData, houseId, sectionId, floor) {
    if (!houseId || !sectionId || !floor) {
        return [];
    }
    var flatsInSectionFloor = getFlatsInSectionFloor(MVKData, houseId, sectionId, floor);
    var floorFlatTypes = flatsInSectionFloor.map(function (flat) { return flat.roomCount; });
    return __spread(new Set(floorFlatTypes));
}
exports.getFlatTypesInFloor = getFlatTypesInFloor;
// Простейший кэш, т.к. расчет similar offers довольно ресурсоемкий
var SIMILAR_OFFERS_CACHE = {};
function getSimilarOffers(MVKData, offerId) {
    if (!offerId) {
        return [];
    }
    if (SIMILAR_OFFERS_CACHE[offerId]) {
        return SIMILAR_OFFERS_CACHE[offerId];
    }
    var currentOffer = MVKData.offers.find(function (offer) { return offer.id === offerId; });
    if (!currentOffer) {
        return [];
    }
    var houseId = currentOffer ? currentOffer.houseId : -1;
    var selectedHouse = mvk_data_1.getMVKHouseById(MVKData, houseId);
    if (!selectedHouse) {
        return [];
    }
    var offers = getOffersConnectedToMVK(MVKData, selectedHouse.id).filter(function (ofr) {
        if (!currentOffer) {
            return false;
        }
        var offerRoomCount = currentOffer.roomCount;
        return ofr.houseId === houseId &&
            selectedHouse.sections.some(function (section) { return section.number === ofr.sectionNumber; }) &&
            ofr.roomCount === offerRoomCount &&
            ofr.id !== offerId;
    });
    var offersViewModel = [];
    offers.forEach(function (offer) {
        selectedHouse.sections.forEach(function (section) {
            if (offersViewModel.some(function (offerVm) { return offerVm.flatNumber === offer.flatNumber && offerVm.floor === offer.floor; })) {
                return;
            }
            var selectedSection = sections_1.getSectionInHouse(MVKData, houseId, section.id);
            var floorScheme = selectedSection && selectedSection.floorPlans.find(function (floorPlan) {
                return floorPlan.floors.includes(offer.floor);
            });
            if (!floorScheme || offer.sectionNumber !== section.number) {
                return;
            }
            var floorFlats = getFlatsInSectionFloor(MVKData, houseId, section.id, offer.floor);
            offersViewModel.push({
                analyticsData: offer.analyticsData,
                area: parseInt(offer.area, 10),
                flatNumber: offer.flatNumber,
                floor: offer.floor,
                houseId: offer.houseId,
                id: offer.id,
                polygons: helpers_1.getColoredPolygons(floorScheme.floorPlanFlats, floorFlats, undefined, offer.flatNumber),
                price: offer.price,
                roomCount: offer.roomCount,
                roomsTitle: offer.roomsTitle,
                sectionNumber: offer.sectionNumber,
            });
        });
    });
    if (Object.keys(SIMILAR_OFFERS_CACHE).length > 100) {
        SIMILAR_OFFERS_CACHE = {};
    }
    SIMILAR_OFFERS_CACHE[offerId] = offersViewModel;
    return offersViewModel;
}
exports.getSimilarOffers = getSimilarOffers;
function getOfferViewModels(MVKData, houseId, sectionId, filters) {
    var selectedFloor = filters.selectedFloor;
    var selectedSection = sections_1.getSectionInHouse(MVKData, houseId, sectionId);
    var floorScheme = selectedSection && selectedSection.floorPlans.find(function (floorPlan) {
        return !!selectedFloor && floorPlan.floors.includes(selectedFloor);
    });
    if (!floorScheme) {
        return [];
    }
    var floorFlats = getFlatsBySectionFilters(MVKData, filters, houseId, sectionId);
    var offersViewModel = floorFlats
        .sort(sorters_1.sortFlatsByRooms)
        .map(function (offer) {
        return {
            analyticsData: offer.analyticsData,
            area: parseInt(offer.area, 10),
            flatNumber: offer.flatNumber,
            id: offer.id,
            polygons: helpers_1.getColoredPolygons(floorScheme.floorPlanFlats, floorFlats, undefined, offer.flatNumber),
            price: offer.price,
            roomCount: offer.roomCount,
            roomsTitle: offer.roomsTitle,
        };
    });
    return offersViewModel.filter(Boolean);
}
exports.getOfferViewModels = getOfferViewModels;
function getFloorRangeForSection(section) {
    var min = 0;
    var max = 0;
    section.floorPlans.forEach(function (floorPlan) {
        var floorPlanMin = Math.min.apply(Math, __spread(floorPlan.floors));
        var floorPlanMax = Math.max.apply(Math, __spread(floorPlan.floors));
        if (floorPlanMin < min || min === 0) {
            min = floorPlanMin;
        }
        if (floorPlanMax > max) {
            max = floorPlanMax;
        }
    });
    return [min, max];
}
exports.getFloorRangeForSection = getFloorRangeForSection;
function getOffersConnectedToMVK(MVKData, houseId) {
    var house = mvk_data_1.getMVKHouseById(MVKData, houseId);
    if (!house) {
        return [];
    }
    return house.sections.reduce(function (result, section) {
        var _a = __read(getFloorRangeForSection(section), 2), min = _a[0], max = _a[1];
        var sectionFlats = [];
        for (var i = min; i <= max; i++) {
            sectionFlats = __spread(sectionFlats, getFlatsInSectionFloor(MVKData, houseId, section.id, i));
        }
        return result.concat(sectionFlats);
    }, []);
}
exports.getOffersConnectedToMVK = getOffersConnectedToMVK;
function getFlatsBySectionFilters(MVKData, filters, houseId, sectionId) {
    var _a = filters.selectedFlatTypes, selectedFlatTypes = _a === void 0 ? [] : _a, selectedFloor = filters.selectedFloor;
    var floorFlatTypes = getFlatTypesInFloor(MVKData, houseId, sectionId, selectedFloor);
    var flatTypesForFilter = selectedFlatTypes.filter(function (flatType) { return floorFlatTypes.includes(flatType); });
    var floorFlats = getFlatsInSectionFloor(MVKData, houseId, sectionId, selectedFloor);
    if (flatTypesForFilter.length) {
        floorFlats = floorFlats.filter(function (floorFlat) { return flatTypesForFilter.includes(mvk_state_1.MAP_FLAT_TYPE_TO_FLAT_TYPE_FOR_FILTER[floorFlat.roomCount]); });
    }
    return floorFlats;
}
exports.getFlatsBySectionFilters = getFlatsBySectionFilters;


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var sorters_1 = __webpack_require__(14);
var mvk_data_1 = __webpack_require__(9);
function getSectionInHouse(MVKData, houseId, sectionId) {
    if (!houseId || !sectionId) {
        return undefined;
    }
    var selectedHouse = mvk_data_1.getMVKHouseById(MVKData, houseId);
    return selectedHouse && selectedHouse.sections.find(function (section) { return section.id === sectionId; });
}
exports.getSectionInHouse = getSectionInHouse;
function getFloorScheme(MVKData, houseId, sectionId, floorFilter) {
    var selectedSection = getSectionInHouse(MVKData, houseId, sectionId);
    return selectedSection && selectedSection.floorPlans.find(function (floorPlan) {
        return !!floorFilter && floorPlan.floors.includes(floorFilter);
    });
}
exports.getFloorScheme = getFloorScheme;
function getFloorsInSection(MVKData, houseId, sectionId) {
    if (!houseId || !sectionId) {
        return [];
    }
    var selectedHouse = mvk_data_1.getMVKHouseById(MVKData, houseId);
    var selectedSection = selectedHouse && selectedHouse.sections.find(function (section) { return section.id === sectionId; });
    var floors = selectedSection && selectedSection.floorPlans.reduce(function (acc, floorPlan) {
        return acc.concat(floorPlan.floors);
    }, []);
    return __spread(new Set(floors)).sort(function (prev, next) { return prev - next; });
}
exports.getFloorsInSection = getFloorsInSection;
exports.getSectionViewModelsByStatus = function (array, label) {
    return array.filter(function (item) { return item.deadlineData.text === label; });
};
exports.getSectionViewModelsSortedByNames = function (source) {
    var types = __spread(new Set(source.map(function (item) { return item.deadlineData.text; })));
    return types.reduce(function (acc, type) {
        var sectionsGroup = exports.getSectionViewModelsByStatus(source, type)
            .sort(sorters_1.sortByNames);
        return acc.concat(sectionsGroup);
    }, []);
};
function getSectionByOfferId(MVKData, offerId) {
    var offer = MVKData.offers.find(function (o) { return o.id === offerId; });
    var house = offer && MVKData.houses.find(function (h) { return h.id === offer.houseId; });
    return offer && house && house.sections.find(function (s) {
        return Boolean(s.number && offer.sectionNumber && s.number === offer.sectionNumber);
    });
}
exports.getSectionByOfferId = getSectionByOfferId;
function getHouseBySectionId(MVKData, sectionId) {
    return MVKData.houses.find(function (h) { return h.sections.some(function (s) { return s.id === sectionId; }); });
}
exports.getHouseBySectionId = getHouseBySectionId;


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var _a;
var analytics_1 = __webpack_require__(52);
var helpers_1 = __webpack_require__(21);
exports.INFRASTRUCTURE_TYPE_MAP = (_a = {},
    _a[0 /* Schools */] = 'schools',
    _a[1 /* Kindergarden */] = 'kindergatens',
    _a[2 /* Polyclinics */] = 'polyclinics',
    _a[3 /* GroceryStores */] = 'shops',
    _a[4 /* Cafes */] = 'cafes',
    _a);
// Клик на секцию корпуса
exports.trackSectionClick = function (isOfferCard) {
    analytics_1.ca('event', {
        action: 'master_podbora_click',
        category: helpers_1.getTrackingCategory(isOfferCard),
        label: 'section',
        name: 'oldevent',
    });
};
// Изменение фильтра этажности
exports.trackFloorFilterChange = function (isOfferCard) {
    analytics_1.ca('event', {
        action: 'master_podbora_click',
        category: helpers_1.getTrackingCategory(isOfferCard),
        label: 'floor',
        name: 'oldevent',
    });
};
// Изменение фильтра комнатности
exports.trackRoomFilterChange = function (isOfferCard) {
    analytics_1.ca('event', {
        action: 'master_podbora_click',
        category: helpers_1.getTrackingCategory(isOfferCard),
        label: 'room_qty',
        name: 'oldevent',
    });
};
// Клик по комнате в поэтажном плане
exports.trackFlatInFloorPlanClick = function (isOfferCard) {
    analytics_1.ca('event', {
        action: 'master_podbora_click',
        category: helpers_1.getTrackingCategory(isOfferCard),
        label: 'flat',
        name: 'oldevent',
    });
};
// Раскрытие списка инфраструктуры на карте
exports.trackInfrastructureShow = function (isOfferCard) {
    analytics_1.ca('event', {
        action: 'infrastructure_show',
        category: helpers_1.getTrackingCategory(isOfferCard),
        label: '',
        name: 'oldevent',
    });
};
// Выбор типа инфраструктуры на карте
exports.trackInfrastructureChange = function (type, isOfferCard) {
    analytics_1.ca('event', {
        action: 'infrastructure_click',
        category: helpers_1.getTrackingCategory(isOfferCard),
        label: exports.INFRASTRUCTURE_TYPE_MAP[type] || '',
        name: 'oldevent',
    });
};
// Клик на "Предложения рядом" в сайдбаре
exports.trackSimilarSuggestionsClick = function (isOfferCard) {
    analytics_1.ca('event', {
        action: 'go_to_similar_on_map',
        category: helpers_1.getTrackingCategory(isOfferCard),
        label: '',
        name: 'oldevent',
    });
};
// Нажатие на избранное в квартире
exports.trackFlatFavoriteButtonClick = function (hasAddedToFavorites, customUrl) {
    analytics_1.ca('event', {
        action: hasAddedToFavorites ? 'add_master_podbora' : 'remove_master_podbora',
        category: 'favorite',
        label: customUrl,
        name: 'oldevent',
    });
};
// Клик на похожую квартиру
exports.trackSimilarFlatClick = function (customUrl) {
    analytics_1.ca('event', {
        action: 'click_similar_master_podbora',
        category: 'similar_objects',
        label: customUrl,
        name: 'oldevent',
    });
};
// Расхлоп телефона на уровне квартиры
exports.trackPhoneButtonClick = function (analyticsData, isOfferCard) {
    if (!analyticsData) {
        return;
    }
    var product = __assign({}, analyticsData, { customUrl: undefined });
    analytics_1.ca('eventSite', {
        action: isOfferCard ? 'Open_card_master_podbora' : 'Open_jk_card_master_podbora',
        category: 'Phones',
        label: analyticsData.customUrl,
        name: 'oldevent',
        products: [product],
    });
};


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var _a;
var utils_1 = __webpack_require__(1);
var section_hint_1 = __webpack_require__(40);
var mvk_map_1 = __webpack_require__(42);
var houses_1 = __webpack_require__(20);
var MIDDLE_POINT = '\u00B7';
// прозрачность для полигонов
exports.STYLE_PROPS = {
    hoveredOpacity: 0.8,
    opacity: 0.2,
};
// статусы строительства дома
exports.ConstructionStatus = {
    FINISHED: 'finished',
    IN_PROGRESS: 'inProgress',
    IN_PROJECT: 'inProject',
};
// цвета статусов строительства
exports.MapConstructionStatusToPolygonColorHex = (_a = {},
    _a[exports.ConstructionStatus.FINISHED] = '2e9e00',
    _a[exports.ConstructionStatus.IN_PROGRESS] = 'ff9d00',
    _a[exports.ConstructionStatus.IN_PROJECT] = '7a7a7a',
    _a);
function createSectionPolgonParams(section, house, offers, ymaps) {
    var hintData = getSectionHintData(section, house, offers);
    var hintSectionLayout = hintData && section_hint_1.getSectionHintLayout(hintData);
    return {
        points: section.polygon.coordinates[0][0],
        props: {
            cursor: 'pointer',
            fillColor: "#" + exports.MapConstructionStatusToPolygonColorHex[house.constructionStatus],
            fillOpacity: exports.STYLE_PROPS.opacity,
            hintCloseTimeout: 0,
            hintLayout: ymaps.templateLayoutFactory.createClass(hintSectionLayout),
            hintOffset: [-130, -120],
            hintOpenTimeout: 0,
            houseId: house.id,
            id: section.id,
            outline: false,
            type: mvk_map_1.MVKPolygonType.SECTION,
        },
    };
}
exports.createSectionPolgonParams = createSectionPolgonParams;
function getSectionHintData(section, house, offers) {
    var flats = offers.filter(function (_a) {
        var flatNumber = _a.flatNumber, sectionNumber = _a.sectionNumber, houseId = _a.houseId, floor = _a.floor;
        var isSectionFlat = houseId === house.id && sectionNumber === section.number;
        return isSectionFlat && section.floorPlans.some(function (plan) {
            return plan.floors.includes(floor) && plan.floorPlanFlats.some(function (planFlat) { return planFlat.flatNumber === flatNumber; });
        });
    });
    var deadLine;
    var constructionStatus = house.constructionStatus;
    if (constructionStatus === exports.ConstructionStatus.FINISHED) {
        deadLine = 'Сдан';
    }
    else {
        var year_1 = 0;
        var quarter_1 = 0;
        flats.forEach(function (flat) {
            if (flat.deadlineYear && flat.deadlineYear > year_1) {
                year_1 = flat.deadlineYear;
                if (flat.deadlineQuarter) {
                    quarter_1 = Math.max(quarter_1, houses_1.QUARTER_MAP[flat.deadlineQuarter]);
                }
            }
        });
        deadLine = "\u0421\u0434\u0430\u0447\u0430 \u0432 " + quarter_1 + " \u043A\u0432. " + year_1;
    }
    var flatTypeText = getFlatTypeText(flats);
    var minPrice = flats.reduce(function (price, flat) { return price && price < flat.price ? price : flat.price; }, 0);
    return {
        deadLine: deadLine,
        name: house.sections.length === 1 ? house.name : house.name + " " + MIDDLE_POINT + " \u0441\u0435\u043A\u0446\u0438\u044F " + section.number,
        pricingInfo: flats.length + " " + flatTypeText + " \u043E\u0442 " + utils_1.numberToPrettyString(minPrice) + " \u20BD",
    };
}
// возвращает стили и координаты точек для полигона ЖК
function getColoredNewbuildingPolygon(newbuildingPolygon) {
    return {
        points: newbuildingPolygon.coordinates[0][0],
        props: {
            cursor: 'default',
            fillColor: 'rgb(43, 135, 219)',
            fillOpacity: 0.15,
            fillStyleHex: '2b87db26',
            lineCap: 'round',
            strokeColor: 'rgb(37, 107, 165)',
            strokeOpacity: 0.6,
            strokeStyleHex: '256ba599',
            strokeWidth: 2,
            type: mvk_map_1.MVKPolygonType.NEWBUILDING,
            zIndex: 0,
        },
    };
}
exports.getColoredNewbuildingPolygon = getColoredNewbuildingPolygon;
// создает координаты точек для полигона на карте
function getCoordinatesFromPoints(points) {
    return [points.map(function (point) { return [point[0], point[1]]; })];
}
exports.getCoordinatesFromPoints = getCoordinatesFromPoints;
// опции для создания геообъекта карты
function getYmapsPolygonGeometryOptions(polygon) {
    return {
        geometry: {
            coordinates: getCoordinatesFromPoints(polygon.points),
            type: 'Polygon',
        },
    };
}
exports.getYmapsPolygonGeometryOptions = getYmapsPolygonGeometryOptions;
// фильтрует дома с полигонами и секциями
function getHousesWithSections(houses) {
    return houses.filter(function (_a) {
        var sections = _a.sections;
        return Array.isArray(sections) && sections.length;
    });
}
exports.getHousesWithSections = getHousesWithSections;
function setHoverOpacityToPolygon(target, isHovered) {
    target.options.set({ fillOpacity: isHovered ? exports.STYLE_PROPS.hoveredOpacity : exports.STYLE_PROPS.opacity });
}
exports.setHoverOpacityToPolygon = setHoverOpacityToPolygon;
function createPolygonParams(points) {
    return points.map(function (point) { return point[0] + "," + point[1]; }).join(',');
}
exports.createPolygonParams = createPolygonParams;
// ссылка на картинку карты яндекс, с расположением секции дома
function createStaticMapImageUrlOfferPhase(size, house, section) {
    if (!house || !section) {
        return '';
    }
    var color = exports.MapConstructionStatusToPolygonColorHex[house.constructionStatus];
    var houseColor = color + "88"; // цвет с прозрачностью
    var housePolygon = createPolygonParams((house.polygon || section.polygon).coordinates[0][0]);
    var sectionPolygon = createPolygonParams(section.polygon.coordinates[0][0]);
    return "https://static-maps.yandex.ru/1.x/?z=16&l=map" +
        ("&size=" + size[0] * 2 + "," + size[1]) +
        ("&pl=f:" + houseColor + ",w:0," + housePolygon + "~f:" + color + ",w:0," + sectionPolygon);
}
exports.createStaticMapImageUrlOfferPhase = createStaticMapImageUrlOfferPhase;
// Параметры для картинки расположения квартиры на этаже
function getFloorPlanPolygonParams(canvasSize, polygonPoints) {
    var round = Math.round, max = Math.max;
    var floorPlanImageSize = [2000, 2000];
    if (polygonPoints && polygonPoints.length > 0) {
        var points = polygonPoints
            .reduce(function (acc, point) { return acc.concat(point); }, []);
        var initValue = [
            [points[0][0], points[0][1]],
            [points[0][0], points[0][1]],
        ];
        var _a = __read(points.reduce(function (_a, point) {
            var _b = __read(_a, 2), _c = __read(_b[0], 2), mnX = _c[0], mnY = _c[1], _d = __read(_b[1], 2), mxX = _d[0], mxY = _d[1];
            return [
                [
                    point[0] < mnX ? point[0] : mnX,
                    point[1] < mnY ? point[1] : mnY,
                ],
                [
                    point[0] > mxX ? point[0] : mxX,
                    point[1] > mxY ? point[1] : mxY,
                ],
            ];
        }, initValue), 2), _b = __read(_a[0], 2), minX = _b[0], minY = _b[1], _c = __read(_a[1], 2), maxX = _c[0], maxY = _c[1];
        floorPlanImageSize = [round(maxX + minX), round(maxY + minY)];
    }
    var _d = __read(floorPlanImageSize, 2), drawnImageWidth = _d[0], drawnImageHeight = _d[1];
    var scale = max(drawnImageWidth / canvasSize[0], drawnImageHeight / canvasSize[1]);
    var _e = __read([0, 0].map(function (pad, index) {
        var imageSize = round(floorPlanImageSize[index] / scale);
        return imageSize < canvasSize[index]
            ? round(canvasSize[index] - imageSize) / 2
            : pad;
    }), 2), offsetLeft = _e[0], offsetTop = _e[1];
    return {
        drawnImageHeight: drawnImageHeight,
        drawnImageWidth: drawnImageWidth,
        imageContainerHeight: round(drawnImageHeight / scale),
        imageContainerWidth: round(drawnImageWidth / scale),
        offsetLeft: offsetLeft,
        offsetTop: offsetTop,
    };
}
exports.getFloorPlanPolygonParams = getFloorPlanPolygonParams;
function getFlatTypeText(flats) {
    var withApartments = false; // есть апартаменты
    var withFlats = false; // есть квартиры
    var result = '';
    flats.forEach(function (flat) {
        if (flat.isApartments) {
            withApartments = true;
        }
        else {
            withFlats = true;
        }
    });
    if (withApartments && withFlats) {
        result = 'кв. и апарт.';
    }
    else if (withApartments) {
        result = utils_1.plural(flats.length, ['апартамент', 'апартамента', 'апартаментов']);
    }
    else if (withFlats) {
        result = utils_1.plural(flats.length, ['квартира', 'квартиры', 'квартир']);
    }
    return result;
}
exports.getFlatTypeText = getFlatTypeText;


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var polygon_1 = __webpack_require__(8);
var sections_1 = __webpack_require__(6);
var flats_1 = __webpack_require__(5);
function getMVKHouseById(MVKData, houseId) {
    return MVKData.houses.find(function (h) { return h.id === houseId; });
}
exports.getMVKHouseById = getMVKHouseById;
var offersInfoSet = new Set();
function setOffersInfo(offers) {
    offers.forEach(function (offer) {
        if (offer.sectionNumber !== undefined) {
            offersInfoSet.add(createHashKey(offer.houseId, offer.sectionNumber, offer.flatNumber, offer.floor));
        }
    });
}
function createHashKey(houseId, sectionNumber, flatNumber, floor) {
    return houseId + "/" + sectionNumber + "/" + flatNumber + "/" + floor;
}
function floorPlanValid(floorPlan, houseId, sectionNumber) {
    return !!floorPlan.floors.length && floorPlan.floors.some(function (floor) {
        return floorPlan.floorPlanFlats.some(function (floorPlanFlat) {
            return offersInfoSet.has(createHashKey(houseId, sectionNumber, floorPlanFlat.flatNumber, floor));
        });
    });
}
function sectionValid(section, houseId) {
    return section.floorPlans && section.floorPlans.some(function (floorPlan) {
        return floorPlanValid(floorPlan, houseId, section.number);
    });
}
function housesValid(houses) {
    return houses.length && houses.some(function (house) {
        return house.sections.some(function (section) { return sectionValid(section, house.id); });
    });
}
// Если в ЖК есть как минимум один полигон корпус и один поэтажный план,
// с привязанным к нему одним опубликованным объявлением.
function MVKIsValid(MVKData) {
    setOffersInfo(MVKData.offers);
    return Boolean(MVKData.polygon &&
        MVKData.polygon.coordinates.length &&
        MVKData.offers.length &&
        housesValid(MVKData.houses));
}
exports.MVKIsValid = MVKIsValid;
// возвращает стили и координаты точек для полигонов секций с поэтажным планом и объявлениями
function getColoredSectionPolygons(MVKData, ymaps) {
    setOffersInfo(MVKData.offers);
    return MVKData.houses
        .reduce(function (acc, house) {
        var sections = house.sections
            .filter(function (section) { return sectionValid(section, house.id); })
            .map(function (section) { return polygon_1.createSectionPolgonParams(section, house, MVKData.offers, ymaps); });
        return acc.concat(sections);
    }, []);
}
exports.getColoredSectionPolygons = getColoredSectionPolygons;
// Проверяет что для объявления есть секция с поэтажным планом и полигоном на нем
function offerIsConnectedWithFloorPlan(MVKData, offerId) {
    var offer = MVKData.offers.find(function (o) { return o.id === offerId; });
    if (!offer) {
        return false;
    }
    var section = sections_1.getSectionByOfferId(MVKData, offerId);
    if (!section) {
        return false;
    }
    var offersInFloor = flats_1.getFlatsInSectionFloor(MVKData, offer.houseId, section.id, offer.floor);
    return offersInFloor.some(function (o) { return o.id === offerId; });
}
exports.offerIsConnectedWithFloorPlan = offerIsConnectedWithFloorPlan;


/***/ }),
/* 10 */
/***/ (function(module, exports) {

module.exports = require("redux");

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var _a;
var React = __webpack_require__(0);
var utils_1 = __webpack_require__(1);
var mvk_state_1 = __webpack_require__(2);
exports.DEFAULT_FLAT_POLYGON_FILL_STYLE = '#ffffff';
exports.DEFAULT_MINIATURE_FLAT_POLYGON_FILL_STYLE = '#e4e4e4';
exports.MAP_FLAT_TYPE_TO_POLYGON_COLOR = (_a = {},
    _a[mvk_state_1.FlatType.ROOM] = '210, 136, 255',
    _a[mvk_state_1.FlatType.ONE_ROOM] = '87, 200, 218',
    _a[mvk_state_1.FlatType.TWO_ROOM] = '225, 210, 0',
    _a[mvk_state_1.FlatType.THREE_ROOM] = '136, 227, 79',
    _a[mvk_state_1.FlatType.FOUR_ROOM] = '232, 171, 127',
    _a[mvk_state_1.FlatType.FIVE_ROOM] = '120, 122, 82',
    _a[mvk_state_1.FlatType.LARGE] = '1, 92, 1',
    _a[mvk_state_1.FlatType.OPEN_PLAN] = '0, 184, 0',
    _a[mvk_state_1.FlatType.SHARE] = '221, 21, 125',
    _a[mvk_state_1.FlatType.STUDIO] = '255, 153, 0',
    _a[mvk_state_1.FlatType.BED] = '86, 102, 206',
    _a);
exports.POLYGON_COLOR_OPACITY = {
    DEFAULT: 0.3,
    HOVER: 0.8,
    MINIATURE: 0.4,
};
exports.DEFAULT_DRAW_SETTINGS = {
    DEFAULT_FILL_STYLE: '#f40212',
    POLYGONS_OPACITY: 0.3,
};
exports.DEFAULT_CANVAS_SIZE = {
    HEIGHT: 100,
    WIDTH: 100,
};
function polygonCoordsOperator(x, y, imageDrawParams) {
    var xScale = imageDrawParams && imageDrawParams.drawnImageWidth / imageDrawParams.imageContainerWidth || 1;
    var yScale = imageDrawParams && imageDrawParams.drawnImageHeight / imageDrawParams.imageContainerHeight || 1;
    var scale = Math.max(xScale, yScale);
    var paddingLeft = imageDrawParams && imageDrawParams.offsetLeft || 0;
    var paddingTop = imageDrawParams && imageDrawParams.offsetTop || 0;
    return [
        (x / scale) + paddingTop,
        (y / scale) + paddingLeft,
    ];
}
exports.polygonCoordsOperator = polygonCoordsOperator;
function getColoredPolygons(floorPlanFlats, flats, coloredPolygonId, coloredFlatNumber) {
    var isMiniaturePolygons = coloredFlatNumber !== undefined;
    var coloredFlat = flats.find(function (flat) { return flat.flatNumber === coloredFlatNumber; });
    var defaultColor = isMiniaturePolygons
        ? exports.DEFAULT_MINIATURE_FLAT_POLYGON_FILL_STYLE
        : exports.DEFAULT_FLAT_POLYGON_FILL_STYLE;
    return floorPlanFlats.reduce(function (acc, planFlat) {
        if (!isFloorPlanFlatValid(planFlat)) {
            return acc;
        }
        var isColoredFlat = coloredFlat && coloredFlat.flatNumber === planFlat.flatNumber;
        var flat = flats.find(function (floorFlat) { return floorFlat.flatNumber === planFlat.flatNumber; });
        var fillColor = flat && (isMiniaturePolygons ? isColoredFlat : true)
            ? getPolygonColor(flat.roomCount, flat.id, isMiniaturePolygons, coloredPolygonId)
            : defaultColor;
        return acc.concat({
            id: flat ? flat.id : null,
            points: planFlat.polygon && planFlat.polygon.coordinates[0][0] || [],
            props: {
                fillColor: fillColor,
                fillOpacity: fillColor === exports.DEFAULT_FLAT_POLYGON_FILL_STYLE ? exports.POLYGON_COLOR_OPACITY.MINIATURE : undefined,
            },
            tooltipContent: flat && (React.createElement("div", null,
                flat.roomsTitle,
                " ",
                flat.area,
                " \u043C",
                React.createElement("sup", null, "2"),
                React.createElement("div", null,
                    "\u0437\u0430 ",
                    utils_1.numberToPrettyString(flat.price),
                    " \u20BD "))),
        });
    }, []);
}
exports.getColoredPolygons = getColoredPolygons;
function getPolygonColor(flatType, polygonId, isMiniaturePolygons, coloredPolygonId) {
    var flatTypeColor = exports.MAP_FLAT_TYPE_TO_POLYGON_COLOR[flatType];
    if (isMiniaturePolygons) {
        return flatTypeColor ? "rgb(" + flatTypeColor + ")" : exports.DEFAULT_MINIATURE_FLAT_POLYGON_FILL_STYLE;
    }
    var flatTypeColorOpacity = polygonId === coloredPolygonId
        ? exports.POLYGON_COLOR_OPACITY.HOVER
        : exports.POLYGON_COLOR_OPACITY.DEFAULT;
    return flatTypeColor
        ? "rgba(" + flatTypeColor + ", " + flatTypeColorOpacity + ")"
        : exports.DEFAULT_FLAT_POLYGON_FILL_STYLE;
}
function isFloorPlanFlatValid(floorPlanFlat) {
    return Boolean(floorPlanFlat.id &&
        floorPlanFlat.flatNumber &&
        floorPlanFlat.polygon &&
        Array.isArray(floorPlanFlat.polygon.coordinates[0][0]));
}
exports.isFloorPlanFlatValid = isFloorPlanFlatValid;
function pnpoly(nvert, vertx, verty, testx, testy) {
    var i;
    var j;
    var c = 0;
    for (i = 0, j = nvert - 1; i < nvert; j = i++) {
        if (((verty[i] > testy) !== (verty[j] > testy)) &&
            (testx < (vertx[j] - vertx[i]) * (testy - verty[i]) / (verty[j] - verty[i]) + vertx[i])) {
            c = Number(!c);
        }
    }
    return c;
}
exports.pnpoly = pnpoly;


/***/ }),
/* 12 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"icon":"mvk_widget-icon-wzuf3WgW5w","icon-cafe":"mvk_widget-icon-cafe-6UqCRJxkU8E mvk_widget-icon-wzuf3WgW5w"};

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var infrastructure_1 = __webpack_require__(54);
exports.infrastructureIcon = infrastructure_1.infrastructureIcon;
var cafe_1 = __webpack_require__(55);
exports.cafeIcon = cafe_1.cafeIcon;
var checked_checkbox_1 = __webpack_require__(56);
exports.checkedCheckboxIcon = checked_checkbox_1.checkedCheckboxIcon;
var grocery_stores_1 = __webpack_require__(57);
exports.groceryStoresIcon = grocery_stores_1.groceryStoresIcon;
var kindergarden_1 = __webpack_require__(58);
exports.kindergardenIcon = kindergarden_1.kindergardenIcon;
var polyclinics_1 = __webpack_require__(59);
exports.polyclinicsIcon = polyclinics_1.polyclinicsIcon;
var school_1 = __webpack_require__(60);
exports.schoolIcon = school_1.schoolIcon;
var minus_1 = __webpack_require__(23);
exports.minusIcon = minus_1.minusIcon;
var plus_1 = __webpack_require__(24);
exports.plusIcon = plus_1.plusIcon;
var ruler_1 = __webpack_require__(25);
exports.rulerIcon = ruler_1.rulerIcon;
var compass_1 = __webpack_require__(61);
exports.compassIcon = compass_1.compassIcon;
var panorama_1 = __webpack_require__(62);
exports.panoramaIcon = panorama_1.panoramaIcon;
var no_panorama_1 = __webpack_require__(63);
exports.noPanoramaIcon = no_panorama_1.noPanoramaIcon;


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var helpers_1 = __webpack_require__(21);
var CONSTRUCTION_STATUS_SORT_VALUES = {
    finished: 2,
    inProject: -1,
};
function sortByNames(prevSection, nextSection) {
    var prevValue = getSortStringBySection(prevSection);
    var nextValue = getSortStringBySection(nextSection);
    if (prevSection.deadlineData.text === nextSection.deadlineData.text) {
        return prevValue.localeCompare(nextValue, 'kn', { numeric: true });
    }
    return 0;
}
exports.sortByNames = sortByNames;
function sortByType(prevSection, nextSection) {
    var prevSortValue = CONSTRUCTION_STATUS_SORT_VALUES[prevSection.constructionStatus] || 1;
    var nextSortValue = CONSTRUCTION_STATUS_SORT_VALUES[nextSection.constructionStatus] || 1;
    // Если сортируются корпуса/секции разных видов, то сортируем их по важности статуса
    if (prevSortValue !== nextSortValue) {
        return nextSortValue - prevSortValue;
    }
    return 0;
}
exports.sortByType = sortByType;
function sortByDates(prevSection, nextSection) {
    if (prevSection.deadlineData.text === nextSection.deadlineData.text) {
        return 0;
    }
    [prevSection, nextSection].forEach(function (section) {
        if (section.deadlineData.text.includes('Сдан')) {
            section.deadlineData.year = 1970;
        }
    });
    var prevDate = new Date(prevSection.deadlineData.year || 2999, ((prevSection.deadlineData.quarter || 1) * 3) - 1, 1);
    var nextDate = new Date(nextSection.deadlineData.year || 2999, ((nextSection.deadlineData.quarter || 1) * 3) - 1, 1);
    return prevDate < nextDate ? -1 : prevDate > nextDate ? 1 : 0;
}
exports.sortByDates = sortByDates;
function sortFlatsByRooms(prevFlat, nextFlat) {
    return prevFlat.roomCount - nextFlat.roomCount;
}
exports.sortFlatsByRooms = sortFlatsByRooms;
function getSortStringBySection(section) {
    var sectionName = section.house.sections.length > 1 ? section.sectionData.number : '';
    var rawHouseName = section.house.name.replace(/\D/g, '');
    var formattedHouseName = helpers_1.getPaddedString(rawHouseName, 5, '0');
    return formattedHouseName + "_" + sectionName;
}
exports.getSortStringBySection = getSortStringBySection;


/***/ }),
/* 15 */
/***/ (function(module, exports) {

module.exports = require("@cian/button-component");

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
// tslint:disable:max-file-line-count
var React = __webpack_require__(0);
var preloader_component_1 = __webpack_require__(85);
var utils_1 = __webpack_require__(1);
var helpers_1 = __webpack_require__(11);
var styles = __webpack_require__(86);
var PolygonsDrawer = /** @class */ (function (_super) {
    __extends(PolygonsDrawer, _super);
    function PolygonsDrawer(props) {
        var _this = _super.call(this, props) || this;
        _this.containerElement = null;
        _this.canvas = null;
        _this.resizeCtx = function () {
            var _a = _this.state, width = _a.width, height = _a.height;
            _this.ctx.canvas.width = width;
            _this.ctx.canvas.height = height;
        };
        _this.draw = function () {
            var _a = _this.state, width = _a.width, height = _a.height;
            var backgroundDrawingAlgorythm = _this.props.backgroundDrawingAlgorythm;
            var drawingParams = backgroundDrawingAlgorythm && backgroundDrawingAlgorythm(width, height);
            _this.resizeCtx();
            _this.drawBackground(drawingParams);
            _this.drawPolygons(drawingParams);
        };
        _this.drawPolygons = function (imageDrawParams) {
            var ctx = _this.ctx;
            _this.props.polygons.forEach(function (polygon) {
                var points = polygon.points;
                if (!points || points.length <= 2) {
                    return;
                }
                ctx.beginPath();
                var firstPoint = helpers_1.polygonCoordsOperator(points[0][0], points[0][1], imageDrawParams);
                ctx.moveTo(firstPoint[1], firstPoint[0]);
                points.forEach(function (point) {
                    var coords = helpers_1.polygonCoordsOperator(point[0], point[1], imageDrawParams);
                    ctx.lineTo(coords[1], coords[0]);
                });
                ctx.closePath();
                ctx.save();
                _this.applyFillCtxSettings(ctx, polygon);
                ctx.fill();
                ctx.restore();
                if (polygon.props.strokeWidth) {
                    _this.applyStrokeCtxSettings(ctx, polygon);
                    ctx.stroke();
                    ctx.restore();
                }
            });
        };
        _this.applyFillCtxSettings = function (ctx, polygon) {
            ctx.fillStyle = polygon.props.fillColor || _this.props.defaultColor || helpers_1.DEFAULT_DRAW_SETTINGS.DEFAULT_FILL_STYLE;
            ctx.globalAlpha = _this.props.isSidebar ? 1 : polygon.props.fillOpacity || helpers_1.DEFAULT_DRAW_SETTINGS.POLYGONS_OPACITY;
        };
        _this.applyStrokeCtxSettings = function (ctx, polygon) {
            ctx.strokeStyle = polygon.props.strokeColor || ctx.strokeStyle;
            ctx.lineWidth = polygon.props.strokeWidth || ctx.lineWidth;
            ctx.globalAlpha = polygon.props.strokeOpacity || ctx.globalAlpha;
            ctx.lineCap = polygon.props.lineCap || ctx.lineCap;
        };
        _this.drawBackground = function (drawingParams) {
            if (_this.props.background) {
                if (!_this.state.isBackgroundLoaded) {
                    var img_1 = new Image();
                    img_1.onload = function () { return _this.onImageLoaded(img_1); };
                    img_1.src = _this.props.background;
                }
                else {
                    _this.drawImage(drawingParams);
                    _this.drawPolygons(drawingParams);
                }
            }
        };
        _this.onImageLoaded = function (img) {
            var _a = _this.props, container = _a.container, onBackgroundLoaded = _a.onBackgroundLoaded;
            _this.img = img;
            if (onBackgroundLoaded) {
                onBackgroundLoaded([img.width, img.height]);
            }
            _this.setState(function (state) { return ({
                height: container ? container.offsetHeight : state.height,
                isBackgroundLoaded: true,
                width: container ? container.offsetWidth : state.width,
            }); });
        };
        _this.drawImage = function (imageDrawParams) {
            _this.ctx.globalAlpha = 1;
            if (imageDrawParams) {
                _this.ctx.drawImage(_this.img, 0, 0, imageDrawParams.drawnImageWidth, imageDrawParams.drawnImageHeight, imageDrawParams.offsetLeft, imageDrawParams.offsetTop, imageDrawParams.imageContainerWidth, imageDrawParams.imageContainerHeight);
            }
            else {
                _this.ctx.drawImage(_this.img, 0, 0);
            }
        };
        _this.getCanvasPosition = function () {
            if (_this.containerElement) {
                var boundingClientRect = _this.containerElement.getBoundingClientRect();
                return [boundingClientRect.left, boundingClientRect.top];
            }
            return undefined;
        };
        _this.onResize = function () {
            if (_this.props.container) {
                _this.setState({
                    height: _this.props.container.offsetHeight,
                    width: _this.props.container.offsetWidth,
                });
            }
        };
        _this.getHoveredPolygonId = function (originAbsolutePoint) {
            var polygons = _this.props.polygons;
            var hoveredPolygonId = null;
            polygons.some(function (polygon) {
                if (helpers_1.pnpoly(polygon.points.length - 1, polygon.points.map(function (point) { return point[1]; }), polygon.points.map(function (point) { return point[0]; }), originAbsolutePoint[0], originAbsolutePoint[1])) {
                    hoveredPolygonId = polygon.id;
                    return true;
                }
                return false;
            });
            return hoveredPolygonId;
        };
        _this.onClick = function () {
            var onPolygonClick = _this.props.onPolygonClick;
            var hoveredPolygonId = _this.state.hoveredPolygonId;
            if (hoveredPolygonId && onPolygonClick) {
                onPolygonClick(hoveredPolygonId);
            }
        };
        _this.onMouseMove = function (event) {
            var _a = _this.props, drawParams = _a.drawParams, onPolygonHover = _a.onPolygonHover, background = _a.background;
            if (!drawParams || (background && !_this.state.isBackgroundLoaded)) {
                return;
            }
            var padding = drawParams.padding, scale = drawParams.scale;
            var clientX = event.clientX, clientY = event.clientY;
            var canvasPosition = _this.getCanvasPosition() || [0, 0];
            var hoveredPolygonId = _this.getHoveredPolygonId([
                (clientX - canvasPosition[0] - padding[0]) * scale,
                (clientY - canvasPosition[1] - padding[1]) * scale,
            ]);
            if (_this.state.hoveredPolygonId !== hoveredPolygonId) {
                _this.setState({
                    hoveredPolygonId: hoveredPolygonId,
                    tooltipPosition: undefined,
                });
                if (onPolygonHover) {
                    onPolygonHover(hoveredPolygonId || undefined);
                }
            }
            if (hoveredPolygonId) {
                _this.setState({
                    tooltipPosition: {
                        left: clientX - canvasPosition[0],
                        top: clientY - canvasPosition[1],
                    },
                });
            }
        };
        _this.state = {
            height: props.container && props.container.offsetHeight || props.height || helpers_1.DEFAULT_CANVAS_SIZE.HEIGHT,
            hoveredPolygonId: null,
            isBackgroundLoaded: false,
            width: props.container && props.container.offsetWidth || props.width || helpers_1.DEFAULT_CANVAS_SIZE.WIDTH,
        };
        return _this;
    }
    PolygonsDrawer.prototype.componentDidMount = function () {
        if (this.canvas) {
            this.ctx = this.canvas.getContext('2d');
            this.draw();
        }
        if (window) {
            window.addEventListener('resize', this.onResize);
        }
    };
    PolygonsDrawer.prototype.componentWillReceiveProps = function (nextProps) {
        if (this.props.background !== nextProps.background) {
            this.setState({ isBackgroundLoaded: false });
        }
        if (this.props.isFullScreen !== nextProps.isFullScreen) {
            this.onResize();
        }
    };
    PolygonsDrawer.prototype.componentWillUnmount = function () {
        if (window) {
            window.removeEventListener('resize', this.onResize);
        }
    };
    PolygonsDrawer.prototype.componentDidUpdate = function () {
        this.draw();
    };
    PolygonsDrawer.prototype.render = function () {
        var _this = this;
        var _a = this, props = _a.props, state = _a.state;
        var isCanvasVisible = props.background && state.isBackgroundLoaded || !props.background;
        var hoveredPolygon = state.hoveredPolygonId &&
            props.polygons.find(function (polygon) { return polygon.id === state.hoveredPolygonId; });
        return (React.createElement("div", __assign({}, utils_1.mergeStyles(styles['container'], props.containerStyle), { ref: function (container) { return _this.containerElement = container; }, onMouseMove: this.onMouseMove, onClick: this.onClick }),
            React.createElement("canvas", { ref: function (canvas) { return _this.canvas = canvas; }, className: isCanvasVisible ? '' : styles['hidden'], width: props.autoResize ? state.width : props.width, height: props.autoResize ? state.height : props.height }),
            !isCanvasVisible && React.createElement("div", { className: styles['preloader-container'] },
                React.createElement(preloader_component_1.Preloader, null)),
            hoveredPolygon && hoveredPolygon.tooltipContent && state.tooltipPosition &&
                React.createElement("div", __assign({}, utils_1.mergeStyles(styles['tooltip'], {
                    left: state.tooltipPosition.left - 24,
                    top: state.tooltipPosition.top - 60,
                })), hoveredPolygon.tooltipContent)));
    };
    PolygonsDrawer.defaultProps = {
        autoResize: true,
    };
    return PolygonsDrawer;
}(React.Component));
exports.PolygonsDrawer = PolygonsDrawer;


/***/ }),
/* 17 */
/***/ (function(module, exports) {

module.exports = require("@cian/event-bus");

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var get_infrastructure_1 = __webpack_require__(37);
function searchMapInfrastructureAction(bbox) {
    return function (dispatch, getState, _a) {
        var httpApi = _a.httpApi, logger = _a.logger;
        get_infrastructure_1.getMapInfrastructure(httpApi, bbox, logger)
            .then(function (response) {
            dispatch({
                infrastructureList: response.infrastructure,
                type: 'ISetInfrastructureListAction',
            });
        })
            .catch(function () {
            dispatch({
                infrastructureList: [],
                type: 'ISetInfrastructureListAction',
            });
        });
    };
}
exports.searchMapInfrastructureAction = searchMapInfrastructureAction;
function toggleSelectedInfrastructureTypeAction(type) {
    return {
        infrastructureType: type,
        type: 'IToggleSelectedInfrastructureTypeAction',
    };
}
exports.toggleSelectedInfrastructureTypeAction = toggleSelectedInfrastructureTypeAction;
function clearSelectedInfrastructureTypesAction() {
    return {
        type: 'IClearSelectedInfrastructureTypesAction',
    };
}
exports.clearSelectedInfrastructureTypesAction = clearSelectedInfrastructureTypesAction;
function setRulerActiveAction(isActive) {
    return {
        isRulerActive: isActive,
        type: 'ISetRulerActiveAction',
    };
}
exports.setRulerActiveAction = setRulerActiveAction;
function setPanoramaActiveAction(isActive) {
    return {
        isActive: isActive,
        type: 'ISetPanoramaActiveAction',
    };
}
exports.setPanoramaActiveAction = setPanoramaActiveAction;
function setNoPanoramaAction(state) {
    return {
        state: state,
        type: 'ISetNoPanoramaAction',
    };
}
exports.setNoPanoramaAction = setNoPanoramaAction;


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function triggerBodyClass(className, state) {
    if (window) {
        var bodyClassName = document.body.className;
        if (state) {
            if (!bodyClassName.includes(className)) {
                document.body.className += " " + className;
            }
        }
        else {
            document.body.className = document.body.className.replace(" " + className, '');
        }
    }
}
exports.triggerBodyClass = triggerBodyClass;


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var sorters_1 = __webpack_require__(14);
var polygon_1 = __webpack_require__(8);
var flats_1 = __webpack_require__(5);
var sections_1 = __webpack_require__(6);
exports.QUARTER_MAP = {
    first: 1,
    fourth: 4,
    second: 2,
    third: 3,
};
var HouseUtils = /** @class */ (function () {
    function HouseUtils(data) {
        var _this = this;
        this.houses = [];
        this.sections = [];
        // Функция возвращает ViewModel корпусов
        this.getHouses = function () {
            if (!_this.houses.length) {
                var _a = _this.state.houses, houses = _a === void 0 ? [] : _a;
                _this.houses = polygon_1.getHousesWithSections(houses).map(function (house) {
                    var offersInSaleCount = house.sections.reduce(function (acc, section) {
                        var floors = sections_1.getFloorsInSection(_this.state, house.id, section.id);
                        var offersCountByFloor = floors.reduce(function (floorAcc, floor) {
                            return floorAcc + flats_1.getFlatsInSectionFloor(_this.state, house.id, section.id, floor).length;
                        }, 0);
                        return acc + offersCountByFloor;
                    }, 0);
                    return {
                        constructionStatus: house.constructionStatus,
                        coordinates: house.polygon ? house.polygon.bbox.slice(0, 2) : undefined,
                        deadlineData: _this.getDeadlineData(house),
                        houseInfo: _this.getHouseInfo(house.id),
                        id: house.id,
                        name: house.name.replace(/ *\([^)]*\) */g, ''),
                        offersInSaleCount: offersInSaleCount,
                    };
                });
            }
            return _this.houses;
        };
        // Получить текст со сроком сдачи корпуса
        this.getDeadlineData = function (house, section) {
            var constructionStatus = section ? section.constructionStatus : house.constructionStatus;
            if (constructionStatus === 'finished') {
                return {
                    text: house.sections.length > 1 ? 'Сдана' : 'Сдан',
                };
            }
            var offers = _this.getOffersByHouse(house.id, section ? section.number : undefined);
            // Берем с максимальным годом
            var year = Number(Math.max.apply(Math, offers.map(function (offer) { return offer.deadlineYear; })));
            var offersWithMaxYear = offers.filter(function (offer) { return offer.deadlineYear === year; });
            // Берем с максимальным кварталом
            var quarter = Number(Math.max.apply(Math, offersWithMaxYear.map(function (offer) { return exports.QUARTER_MAP[offer.deadlineQuarter || -1]; })));
            // Есть ли в корпусе сданные офферы
            var hasCompletedOffers = offers.some(function (offer) { return !!offer.isComplete; });
            var hasCompletedOffersText = hasCompletedOffers ? ', сданные' : '';
            if (isFinite(year) && isFinite(quarter)) {
                return {
                    quarter: quarter,
                    text: quarter + " \u043A\u0432. " + year + hasCompletedOffersText,
                    year: year,
                };
            }
            return { text: "\u0421\u0442\u0440\u043E\u0438\u0442\u0441\u044F" + hasCompletedOffersText };
        };
        // Возвращает квартиры, относящиеся к корпусу и секции
        this.getOffersByHouse = function (houseId, sectionNumber) {
            // Получаем квартиры, которые привязаны к МВК, итерируя по секциям и этажам
            var offers = flats_1.getOffersConnectedToMVK(_this.state, houseId);
            return sectionNumber === undefined
                ? offers
                : offers.filter(function (offer) { return offer.sectionNumber === sectionNumber; });
        };
        // Возвращает статистику по корпусу: название, дата сдачи, кол-во квартир, минимумы по площадям и ценам
        this.getHouseInfo = function (houseId, sectionNumber) {
            var house = _this.state.houses.find(function (item) { return item.id === houseId; });
            if (!house) {
                return [];
            }
            var offers = _this.getOffersByHouse(houseId, sectionNumber).filter(function (offer) {
                return house.sections.some(function (section) { return section.number === offer.sectionNumber; });
            });
            if (!offers.length) {
                return [];
            }
            var maxRoomCount = Math.max.apply(Math, offers.map(function (offer) { return offer.roomCount; }));
            var result = [];
            var _loop_1 = function (i) {
                var offersByRoom = offers.filter(function (offer) { return offer.roomCount === i; });
                var item = __assign({ roomCount: i }, _this.getOfferInfoByRoomCount(offersByRoom));
                if (isFinite(item.minArea) && isFinite(item.minPrice)) {
                    result.push(item);
                }
            };
            for (var i = 0; i <= maxRoomCount; i++) {
                _loop_1(i);
            }
            return result.sort(function (_, nextItem) {
                return nextItem.roomCount === 9 ? 1 : 0;
            });
        };
        this.getOfferInfoByRoomCount = function (offers) {
            return {
                minArea: Number(Math.min.apply(Math, offers.map(function (offer) { return parseInt(offer.area, 10); }))),
                minPrice: Number(Math.min.apply(Math, offers.map(function (offer) { return offer.price; }))),
            };
        };
        // Функция возвращает ViewModel секций
        this.getSections = function (houseId) {
            var selectedHouse = _this.state.houses.find(function (house) { return house.id === houseId; });
            if (!selectedHouse) {
                return _this.sections;
            }
            if (!_this.sections.some(function (section) { return section.house.id === houseId; })) {
                var sectionsByHouse = selectedHouse.sections.map(function (section) {
                    var modernSection = __assign({}, section, { constructionStatus: _this.getConstructionStatusForSection(section, selectedHouse) });
                    var floors = sections_1.getFloorsInSection(_this.state, selectedHouse.id, section.id);
                    var sectionFlats = floors.reduce(function (acc, floor) {
                        return acc.concat(flats_1.getFlatsInSectionFloor(_this.state, selectedHouse.id, section.id, floor));
                    }, []);
                    var houseInfo = _this.getHouseInfo(selectedHouse.id, section.number);
                    if (!houseInfo.length) {
                        return undefined;
                    }
                    return {
                        constructionStatus: modernSection.constructionStatus,
                        deadlineData: _this.getDeadlineData(selectedHouse, modernSection),
                        house: selectedHouse,
                        houseInfo: houseInfo,
                        id: section.id,
                        offersInSaleCount: sectionFlats.length,
                        sectionData: section,
                        flatTypeText: polygon_1.getFlatTypeText(sectionFlats),
                    };
                }).filter(Boolean);
                _this.sections = sections_1.getSectionViewModelsSortedByNames(__spread(_this.sections, sectionsByHouse).sort(sorters_1.sortByType)
                    .sort(sorters_1.sortByDates));
            }
            return _this.sections.filter(function (section) { return section.house.id === houseId; });
        };
        this.getConstructionStatusForSection = function (section, house) {
            var offers = _this.getOffersByHouse(house.id, section.number);
            return offers.length && offers.every(function (offer) { return !!offer.isComplete; })
                ? 'finished'
                : house.constructionStatus;
        };
        this.state = data;
        // Инициализация всех секций в this.sections
        var houses = this.getHouses();
        houses.forEach(function (house) {
            if (house.houseInfo.length) {
                _this.getSections(house.id);
            }
        });
    }
    HouseUtils.getInstance = function (data) {
        var isDataTheSame = HouseUtils.instance && HouseUtils.instance.state === data;
        HouseUtils.instance = isDataTheSame && HouseUtils.instance || new HouseUtils(data);
        return HouseUtils.instance;
    };
    return HouseUtils;
}());
exports.HouseUtils = HouseUtils;


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function getPaddedString(sourceString, targetLength, padString) {
    var targetLen = targetLength >> 0;
    var padStr = padString;
    if (sourceString.length > targetLen) {
        return sourceString;
    }
    else {
        targetLen = targetLen - sourceString.length;
        if (targetLen > padStr.length) {
            padStr += padStr.repeat(targetLen / padStr.length);
        }
        return padStr.slice(0, targetLen) + sourceString;
    }
}
exports.getPaddedString = getPaddedString;
function getTrackingCategory(isOfferCard) {
    return isOfferCard ? 'card' : 'Card_JK';
}
exports.getTrackingCategory = getTrackingCategory;


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function getURIWithoutHash(uri) {
    if (!uri) {
        return '';
    }
    return uri.split('#')[0];
}
exports.getURIWithoutHash = getURIWithoutHash;


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable:max-line-length */
var React = __webpack_require__(0);
exports.minusIcon = (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "18", height: "4", viewBox: "0 0 18 4" },
    React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M1.936 3.01C1.38 3.01.926 2.562.926 2c0-.557.45-1.008 1.01-1.008h14.128c.557 0 1.01.447 1.01 1.009 0 .557-.45 1.009-1.01 1.009H1.936z" })));


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable:max-line-length */
var React = __webpack_require__(0);
exports.plusIcon = (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "18", height: "18", viewBox: "0 0 18 18" },
    React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M7.996 7.996H1.942c-.561 0-1.01.451-1.01 1.009 0 .56.452 1.009 1.01 1.009h6.054v6.053c0 .562.451 1.01 1.009 1.01.56 0 1.009-.452 1.009-1.01v-6.053h6.053c.562 0 1.01-.452 1.01-1.01 0-.56-.452-1.008-1.01-1.008h-6.053V1.942c0-.561-.452-1.01-1.01-1.01-.56 0-1.008.452-1.008 1.01v6.054z" })));


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable:max-line-length */
var React = __webpack_require__(0);
exports.rulerIcon = (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "20", height: "21", viewBox: "0 0 20 21" },
    React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M3.495 13.434l-1.241 1.241c-.033.033-.033.101.002.136l3.539 3.539c.038.038.1.038.136.002L17.96 6.323c.033-.033.033-.101-.002-.136l-3.539-3.539a.097.097 0 0 0-.136-.002l-1.241 1.241 2.192 2.192-1.061 1.061-2.192-2.192-1.768 1.768 1.131 1.131-1.061 1.061-1.131-1.131-1.768 1.768 2.192 2.192-1.061 1.061-2.192-2.192-1.768 1.768 1.131 1.131-1.061 1.061-1.131-1.131.001-.001zM.912 16.155a2.003 2.003 0 0 1-.002-2.823L12.939 1.303a1.997 1.997 0 0 1 2.823.002l3.539 3.539c.78.78.774 2.05.002 2.823L7.274 19.696a1.997 1.997 0 0 1-2.823-.002L.912 16.155z" })));


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var button_component_1 = __webpack_require__(15);
var utils_1 = __webpack_require__(1);
var tracking_1 = __webpack_require__(7);
var styles = __webpack_require__(79);
var PHONE_REGEX = /(\d)(\d{3})(\d{3})(\d{2})(\d{2})/;
var PhoneButton = /** @class */ (function (_super) {
    __extends(PhoneButton, _super);
    function PhoneButton() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isPhoneVisible: false,
        };
        _this.handlePhoneButtonClick = function () {
            var _a = _this.props, analyticsData = _a.analyticsData, isOfferCard = _a.isOfferCard;
            _this.setState({
                isPhoneVisible: true,
            });
            tracking_1.trackPhoneButtonClick(analyticsData, isOfferCard);
        };
        return _this;
    }
    PhoneButton.prototype.render = function () {
        var _a = this.props, containerStyle = _a.containerStyle, phone = _a.phone, hidePhoneOnButton = _a.hidePhoneOnButton, phoneStyle = _a.phoneStyle;
        var isPhoneVisible = this.state.isPhoneVisible;
        var prettyPhoneFormat = isPhoneVisible ? '$1 $2 $3-$4-$5' : '$1 $2 $3-$4-...';
        var prettyPhone = phone;
        if (phone.startsWith('+') && phone.length === 12) {
            prettyPhone = phone.replace(PHONE_REGEX, prettyPhoneFormat);
        }
        else if (phone.length === 11) {
            prettyPhone = phone.replace(PHONE_REGEX, "+" + prettyPhoneFormat);
        }
        var buttonText = hidePhoneOnButton ? 'Показать телефон' : prettyPhone;
        return (React.createElement("div", __assign({}, utils_1.mergeStyles(styles['container'], containerStyle)), isPhoneVisible
            ? React.createElement("div", __assign({}, utils_1.mergeStyles(styles['phone'], phoneStyle)), prettyPhone)
            : React.createElement(button_component_1.Button, { onClick: this.handlePhoneButtonClick }, buttonText)));
    };
    return PhoneButton;
}(React.Component));
exports.PhoneButton = PhoneButton;


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var react_redux_1 = __webpack_require__(3);
var redux_1 = __webpack_require__(10);
var mvk_data_1 = __webpack_require__(80);
var favorite_button_1 = __webpack_require__(83);
exports.FavoriteButtonContainer = react_redux_1.connect(null, function (dispatch) { return ({
    toggleFavorite: redux_1.bindActionCreators(mvk_data_1.toggleFavoriteAction, dispatch),
}); })(favorite_button_1.FavoriteButton);


/***/ }),
/* 28 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"mvk_widget-container-a1iwP7RjvG6","button":"mvk_widget-button-dSBalu52tqO","icon":"mvk_widget-icon-FkmtLKE3Ic","icon--active":"mvk_widget-icon--active-78lc4cBn2wE"};

/***/ }),
/* 29 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"mvk_widget-container-6B1qeraI4o6","compass":"mvk_widget-compass-lWuhc7AbZYM","polygons-container":"mvk_widget-polygons-container-58HdSOKSMU6"};

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/*
 Так как window.history не позволяет обращаться к следующим/предыдущим элементам истории
 Мы храним первое состояние нашего приложения здесь, которое по факту может находиться на N уровней ниже
*/
var isPrevRouteFirst = false;
function updateRouteState() {
    isPrevRouteFirst = Boolean(window) && !window.history.state.uri;
}
exports.updateRouteState = updateRouteState;
function isPreviousRouteFirst() {
    return isPrevRouteFirst;
}
exports.isPreviousRouteFirst = isPreviousRouteFirst;


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var mvk_state_1 = __webpack_require__(2);
var toggleValueInArray_1 = __webpack_require__(145);
var mvk_state_2 = __webpack_require__(32);
exports.defaultMVKState = {
    flat: {},
    house: {},
    isFullScreen: false,
    map: {
        infrastructureList: [],
        isNoPanorama: false,
        isPanoramaActive: false,
        isRulerActive: false,
        selectedInfrastructureTypes: [],
    },
    phase: mvk_state_1.MVKPhase.PREVIEW,
    section: {},
    sectionPhaseFilters: {},
    shouldIgnoreScroll: false,
    shouldShowFullScreenTip: false,
    isOfferCard: false,
};
function mvkStateReducer(state, action) {
    if (state === void 0) { state = exports.defaultMVKState; }
    switch (action.type) {
        case 'ISetInfrastructureListAction':
            return __assign({}, state, { map: __assign({}, state.map, { infrastructureList: action.infrastructureList }) });
        case 'IToggleSelectedInfrastructureTypeAction':
            return __assign({}, state, { map: __assign({}, state.map, { selectedInfrastructureTypes: toggleValueInArray_1.toggleValueInArray(action.infrastructureType, state.map.selectedInfrastructureTypes) }) });
        case 'IClearSelectedInfrastructureTypesAction':
            return __assign({}, state, { map: __assign({}, state.map, { selectedInfrastructureTypes: [] }) });
        case 'ISetRulerActiveAction':
            return __assign({}, state, { map: __assign({}, state.map, { isRulerActive: action.isRulerActive }) });
        case 'ISetPanoramaActiveAction':
            return __assign({}, state, { map: __assign({}, state.map, { isPanoramaActive: action.isActive }) });
        case 'ISetNoPanoramaAction':
            return __assign({}, state, { map: __assign({}, state.map, { isNoPanorama: action.state }) });
        case 'ISetMVKPhaseAction':
            var phase = action.phase;
            var isPreview = phase === mvk_state_1.MVKPhase.PREVIEW;
            return __assign({}, state, { flat: phase !== mvk_state_1.MVKPhase.FLAT ? {} : state.flat, house: isPreview ? {} : state.house, map: __assign({}, state.map, { isNoPanorama: false, isPanoramaActive: false }), phase: phase, section: isPreview ? {} : state.section, sectionPhaseFilters: isPreview ? {} : state.sectionPhaseFilters });
        case 'ISetHoveredHouseIdAction':
            return __assign({}, state, { house: __assign({}, state.house, { hoveredId: action.houseId }) });
        case 'ISetHoveredSectionIdAction':
            return __assign({}, state, { house: __assign({}, state.house, { hoveredId: action.houseId }), section: __assign({}, state.section, { hoveredId: action.sectionId }), shouldIgnoreScroll: Boolean(action.shouldIgnoreScroll) });
        case 'ISetHoveredFlatIdAction':
            return __assign({}, state, { flat: __assign({}, state.flat, { hoveredId: action.flatId }) });
        case 'ISetHouseIdAction':
            return __assign({}, state, { flat: {}, house: {
                    hoveredId: undefined,
                    id: action.houseId,
                }, map: __assign({}, state.map, { isNoPanorama: false, isPanoramaActive: false }), section: {} });
        case 'ISetSectionIdAction':
            return __assign({}, state, { flat: {}, map: __assign({}, state.map, { isNoPanorama: false, isPanoramaActive: false }), phase: mvk_state_1.MVKPhase.SECTION, section: {
                    hoveredId: undefined,
                    id: action.sectionId,
                } });
        case 'ISetFlatIdAction':
            return __assign({}, state, { flat: {
                    hoveredId: undefined,
                    id: action.flatId,
                }, phase: mvk_state_1.MVKPhase.FLAT });
        case 'IToggleFlatFilterAction':
            return __assign({}, state, { sectionPhaseFilters: __assign({}, state.sectionPhaseFilters, { selectedFlatTypes: toggleValueInArray_1.toggleValueInArray(action.flatType, state.sectionPhaseFilters.selectedFlatTypes) }) });
        case 'ISetFloorFilterAction':
            return __assign({}, state, { sectionPhaseFilters: __assign({}, state.sectionPhaseFilters, { selectedFloor: action.floor }) });
        case 'IToggleFullScreenAction':
            return __assign({}, state, { isFullScreen: action.state });
        case 'IChangeFullScreenTipVisiblityAction':
            return __assign({}, state, { shouldShowFullScreenTip: action.state });
        case 'IToggleRouteUpdateAction':
            if (action.isInitial) {
                return state;
            }
            return mvk_state_2.generateInitialState(exports.defaultMVKState, action.queryString);
        default:
            return state;
    }
}
exports.mvkStateReducer = mvkStateReducer;


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var mvk_state_1 = __webpack_require__(2);
var router_1 = __webpack_require__(33);
function generateInitialState(defaultState, queryString, usePlace) {
    var initialState = __assign({}, defaultState, { isOfferCard: isOfferCardUsePlace(usePlace) });
    if (!queryString) {
        return initialState;
    }
    var array = getArrayOfMvkParams(queryString);
    // Подставляем в initialState параметры из queryString
    array.forEach(function (item) {
        switch (item.key) {
            case 'gk_mvk_flat_card':
                initialState.flat = {
                    id: Number(item.value),
                };
                break;
            case 'gk_mvk_flat_plan_floor':
                initialState.sectionPhaseFilters = __assign({}, initialState.sectionPhaseFilters, { selectedFloor: Number(item.value) });
                break;
            case 'gk_mvk_flat_plan_types':
                initialState.sectionPhaseFilters = __assign({}, initialState.sectionPhaseFilters, { selectedFlatTypes: parseFlatTypes(item.value) });
                break;
            case 'gk_mvk_flat_popup':
                initialState.section = {
                    id: Number(item.value),
                };
                break;
            case 'gk_mvk_map_popup':
                initialState.isFullScreen = !!item.value;
                break;
            case 'gk_mvk_section_popup':
                initialState.house = {
                    id: Number(item.value),
                };
                break;
            default: break;
        }
    });
    // Нужная фаза
    if (initialState.section.id !== undefined) {
        initialState.phase = mvk_state_1.MVKPhase.SECTION;
    }
    if (initialState.flat.id !== undefined) {
        initialState.phase = mvk_state_1.MVKPhase.FLAT;
    }
    return initialState;
}
exports.generateInitialState = generateInitialState;
function getArrayOfMvkParams(queryString) {
    var paramsArray = queryString.replace('?', '').split('&');
    var result = [];
    for (var i = paramsArray.length - 1; i >= 0; i -= 1) {
        var _a = __read(paramsArray[i].split('='), 2), key = _a[0], value = _a[1];
        if (router_1.MVK_QUERY_STRING_PARAMS.includes(key)) {
            result.push({
                key: key,
                value: value,
            });
        }
    }
    return result;
}
function parseFlatTypes(rawFlatTypes) {
    if (!rawFlatTypes) {
        return [];
    }
    return rawFlatTypes
        .split(',')
        .map(Number)
        .filter(Number);
}
function isOfferCardUsePlace(usePlace) {
    return usePlace === 'offer-card';
}
exports.isOfferCardUsePlace = isOfferCardUsePlace;


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var mvk_state_1 = __webpack_require__(2);
var bodyClass_1 = __webpack_require__(19);
var url_1 = __webpack_require__(22);
var routerHelper_1 = __webpack_require__(30);
exports.MVK_QUERY_STRING_PARAMS = [
    'gk_mvk_map_popup',
    'gk_mvk_section_popup',
    'gk_mvk_flat_popup',
    'gk_mvk_flat_plan_floor',
    'gk_mvk_flat_plan_types',
    'gk_mvk_flat_card',
];
exports.ACTIONS_THAT_UPDATE_ROUTE = [
    'ISetMVKPhaseAction',
    'ISetFlatIdAction',
    'IToggleFlatFilterAction',
    'ISetFloorFilterAction',
    'IToggleFullScreenAction',
    'IToggleRouteUpdateAction',
];
// Экшены, которые в любом случае жестко обновлят window.history
exports.WHITE_LIST_ROUTE_ACTIONS = [
    'IToggleFullScreenAction',
    'ISetFlatIdAction',
];
var updateQueryStringByState = function (store, shouldReplaceState) {
    var state = store.MVKState;
    var queryString = document.location ? document.location.search : '';
    var pathname = document.location ? document.location.pathname : '';
    // Удаляем все МВКшные параметры из урла
    var newUrl = getUrlWithoutMvkParams(pathname + queryString);
    // Подготавливаем новые МВКшные параметры
    var mvkQueryStringParams = getMVKQueryStringParams(state);
    // Проставляем новый параметры в урл и пушим в хистори
    exports.MVK_QUERY_STRING_PARAMS.forEach(function (key) {
        var value = mvkQueryStringParams[key];
        if (value === undefined || Array.isArray(value) && !value.length) {
            return;
        }
        var prefix = newUrl.includes('?') ? '&' : '?';
        newUrl += "" + prefix + key + "=" + mvkQueryStringParams[key];
    });
    var uri = window.history.state && url_1.getURIWithoutHash(window.history.state.uri || '');
    if (uri !== newUrl) {
        newUrl += '#map';
        if (shouldReplaceState) {
            window.history.replaceState({ uri: newUrl, isInitState: false }, document.title, newUrl);
        }
        else {
            window.history.pushState({ uri: newUrl, isInitState: false }, document.title, newUrl);
        }
    }
};
exports.routerMiddleware = function (store) {
    return function (next) {
        return function (action) {
            var prevMVKPhase = store.getState().MVKState.phase;
            var result = next(action);
            var newState = store.getState();
            var newMVKPhase = newState.MVKState.phase;
            var isRouteUpdate = action.type === 'IToggleRouteUpdateAction';
            var shouldUpdateQS = exports.WHITE_LIST_ROUTE_ACTIONS.includes(action.type) ||
                newMVKPhase !== prevMVKPhase ||
                prevMVKPhase === mvk_state_1.MVKPhase.SECTION &&
                    !isSectionRouteBad(newState.MVKState);
            if (window &&
                exports.ACTIONS_THAT_UPDATE_ROUTE.includes(action.type) &&
                shouldUpdateQS &&
                !newState.MVKState.isOfferCard) {
                updateQueryStringByState(newState, isRouteUpdate);
                routerHelper_1.updateRouteState();
            }
            if (isRouteUpdate) {
                bodyClass_1.triggerBodyClass('mvk_full_screen', newState.MVKState.isFullScreen);
                // Если при смене роута открыт фулскрин фоторамы, то закрываем его
                setTimeout(function () {
                    try {
                        window.$('.fotorama--fullscreen').data('fotorama').cancelFullScreen();
                        document.body.className = document.body.className.replace('mvk_fotorama_fullscreen', '');
                    }
                    catch (e) { }
                }, 0);
            }
            return result;
        };
    };
};
function getUrlWithoutMvkParams(sourceURL) {
    var splittedSourceURL = sourceURL.split('?');
    var path = splittedSourceURL[0];
    var queryString = url_1.getURIWithoutHash(splittedSourceURL[1]);
    if (queryString) {
        var paramsArray = queryString.split('&');
        for (var i = paramsArray.length - 1; i >= 0; i -= 1) {
            var param = paramsArray[i].split('=')[0];
            if (exports.MVK_QUERY_STRING_PARAMS.includes(param)) {
                paramsArray.splice(i, 1);
            }
        }
        if (paramsArray.length) {
            path += '?';
        }
        path = "" + path + paramsArray.join('&');
    }
    return path;
}
function getMVKQueryStringParams(state) {
    return {
        gk_mvk_flat_card: state.flat ? state.flat.id : undefined,
        gk_mvk_flat_plan_floor: state.section && state.section.id ? state.sectionPhaseFilters.selectedFloor : undefined,
        gk_mvk_flat_plan_types: state.section && state.section.id ? state.sectionPhaseFilters.selectedFlatTypes : undefined,
        gk_mvk_flat_popup: state.section ? state.section.id : undefined,
        gk_mvk_map_popup: state.isFullScreen ? 1 : undefined,
        gk_mvk_section_popup: state.house ? state.house.id : undefined,
    };
}
function isSectionRouteBad(state) {
    return state.phase === mvk_state_1.MVKPhase.SECTION &&
        state.sectionPhaseFilters.selectedFloor === undefined;
}


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(35));
__export(__webpack_require__(36));
var mvk_data_1 = __webpack_require__(9);
exports.getColoredSectionPolygons = mvk_data_1.getColoredSectionPolygons;
exports.offerIsConnectedWithFloorPlan = mvk_data_1.offerIsConnectedWithFloorPlan;
exports.MVKIsValid = mvk_data_1.MVKIsValid;
var polygon_1 = __webpack_require__(8);
exports.getColoredNewbuildingPolygon = polygon_1.getColoredNewbuildingPolygon;
exports.setHoverOpacityToPolygon = polygon_1.setHoverOpacityToPolygon;
exports.getYmapsPolygonGeometryOptions = polygon_1.getYmapsPolygonGeometryOptions;
var get_floor_plan_image_1 = __webpack_require__(150);
exports.getFloorPlanImageUrlByOfferId = get_floor_plan_image_1.getFloorPlanImageUrlByOfferId;


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function loadFotoramaScript() {
    if (window) {
        var script = document.createElement('script');
        script.src = '//www.cian.ru/static/scripts/fotorama_4.6.4.1.js';
        document.body.appendChild(script);
    }
}
exports.loadFotoramaScript = loadFotoramaScript;
function loadScripts() {
    if (window && !window.$) {
        var script = document.createElement('script');
        script.src = '//www.cian.ru/static/scripts/jquery-1.11.1.min.js';
        script.onload = loadFotoramaScript;
        document.body.appendChild(script);
    }
    else {
        loadFotoramaScript();
    }
}
exports.loadScripts = loadScripts;


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var react_redux_1 = __webpack_require__(3);
var event_bus_1 = __webpack_require__(17);
var map_1 = __webpack_require__(18);
var mvk_state_1 = __webpack_require__(4);
var newbuilding_mvk_1 = __webpack_require__(43);
var mvk_state_2 = __webpack_require__(31);
var mvk_state_3 = __webpack_require__(2);
var mvk_state_4 = __webpack_require__(32);
var store_1 = __webpack_require__(146);
var sections_1 = __webpack_require__(6);
var NewbuildingMVKWidget = /** @class */ (function (_super) {
    __extends(NewbuildingMVKWidget, _super);
    function NewbuildingMVKWidget() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NewbuildingMVKWidget.prototype.render = function () {
        var _a = this.props, MVKData = _a.MVKData, httpApi = _a.httpApi, logger = _a.logger, queryString = _a.queryString, usePlace = _a.usePlace, containerStyles = _a.containerStyles, onClose = _a.onClose, offerId = _a.offerId, sectionId = _a.sectionId;
        var initialState = {
            MVKData: MVKData,
            MVKState: mvk_state_4.generateInitialState(mvk_state_2.defaultMVKState, queryString, usePlace),
        };
        var storeContext = {
            httpApi: httpApi,
            logger: logger,
        };
        var store = store_1.createAppStore(initialState, storeContext);
        if (sectionId) {
            var house = sections_1.getHouseBySectionId(MVKData, sectionId);
            if (house) {
                store.dispatch(mvk_state_1.setHouseIdAction(house.id));
                store.dispatch(mvk_state_1.setSectionIdAction(sectionId));
            }
        }
        else if (offerId) {
            var section = sections_1.getSectionByOfferId(MVKData, offerId);
            var offer = MVKData.offers.find(function (o) { return o.id === offerId; });
            if (section && offer) {
                store.dispatch(mvk_state_1.setHouseIdAction(offer.houseId));
                store.dispatch(mvk_state_1.setSectionIdAction(section.id));
                store.dispatch(mvk_state_1.setFloorFilterAction(offer.floor));
            }
        }
        if (window) {
            var eventBus = event_bus_1.getEventBusIfDefined();
            if (eventBus) {
                // Ловим внешние события
                eventBus.subscribe('open-panorama', function () {
                    var isPanoramaActive = store.getState().MVKState.map.isPanoramaActive;
                    // Если панорама уже открыта, то игнорируем событие
                    if (!isPanoramaActive) {
                        store.dispatch(mvk_state_1.setMVKPhaseAction(mvk_state_3.MVKPhase.PREVIEW));
                        store.dispatch(map_1.setPanoramaActiveAction(true));
                    }
                });
                eventBus.subscribe('close-panorama', function () {
                    store.dispatch(mvk_state_1.setMVKPhaseAction(mvk_state_3.MVKPhase.PREVIEW));
                    store.dispatch(map_1.setPanoramaActiveAction(false));
                });
            }
            // Сохраняем начальный роут для корректной работы роутера
            setTimeout(function () { return store.dispatch(mvk_state_1.toggleRouteUpdateAction(true)); }, 0);
        }
        return (React.createElement(react_redux_1.Provider, { store: store },
            React.createElement(newbuilding_mvk_1.NewbuildingMVKContainer, { containerStyles: containerStyles, onClose: onClose })));
    };
    return NewbuildingMVKWidget;
}(React.PureComponent));
exports.NewbuildingMVKWidget = NewbuildingMVKWidget;


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var get_infrastructure_1 = __webpack_require__(38);
function getMapInfrastructure(httpApi, bbox, logger) {
    return __awaiter(this, void 0, void 0, function () {
        var _a, _b, leftBottomLng, leftBottomLat, _c, topRightLng, topRightLat, parameters, _d, response, statusCode, error_1;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    _a = __read(bbox, 2), _b = __read(_a[0], 2), leftBottomLng = _b[0], leftBottomLat = _b[1], _c = __read(_a[1], 2), topRightLng = _c[0], topRightLat = _c[1];
                    parameters = {
                        bbox: leftBottomLng + "," + leftBottomLat + "~" + topRightLng + "," + topRightLat,
                    };
                    _e.label = 1;
                case 1:
                    _e.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, httpApi.fetch(get_infrastructure_1.createGetMapInfrastructureModel({ parameters: parameters }))];
                case 2:
                    _d = _e.sent(), response = _d.response, statusCode = _d.statusCode;
                    if (statusCode !== 200 || 'errors' in response) {
                        throw response;
                    }
                    return [2 /*return*/, response];
                case 3:
                    error_1 = _e.sent();
                    if (logger) {
                        logger.error(error_1, {
                            message: 'error in getMapInfrastructure',
                        });
                    }
                    throw error_1;
                case 4: return [2 /*return*/];
            }
        });
    });
}
exports.getMapInfrastructure = getMapInfrastructure;


/***/ }),
/* 38 */
/***/ (function(module, exports) {

module.exports = require("@cian/api-models/infrastructure-caching/v1/get-infrastructure");

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function toggleResizeEvent() {
    if (window) {
        // После выхода/входа в полноэкранный режим нужно рефрешнуть канвас и галерею
        setTimeout(function () {
            if (Event instanceof Function) {
                window.dispatchEvent(new Event('resize'));
            }
            else {
                // IE11
                var event_1 = document.createEvent('Event');
                event_1.initEvent('resize', true, true);
                document.dispatchEvent(event_1);
            }
        });
    }
}
exports.toggleResizeEvent = toggleResizeEvent;


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var styles = __webpack_require__(41);
exports.getSectionHintLayout = function (data) {
    var name = data.name, deadLine = data.deadLine, pricingInfo = data.pricingInfo;
    return ("\n    <div class=\"" + styles['container'] + "\">\n      <div class=\"" + styles['name'] + "\">" + name + "</div>\n      <div class=\"" + styles['status'] + "\">" + deadLine + "</div>\n      <div class=\"" + styles['pricing'] + "\">" + pricingInfo + "</div>\n    </div>\n  ");
};


/***/ }),
/* 41 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"mvk_widget-container-4Iiy0nDIIwy","name":"mvk_widget-name-ajzll6WZBCW","status":"mvk_widget-status-f17NsXnWRG2","pricing":"mvk_widget-pricing-lZrtHPHXIO"};

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.MVKPolygonType = {
    NEWBUILDING: 'newbuilding',
    SECTION: 'section',
};


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var react_redux_1 = __webpack_require__(3);
var mvk_state_1 = __webpack_require__(4);
var mvk_1 = __webpack_require__(44);
var mapStateToProps = function (state) {
    return {
        isFullScreen: state.MVKState.isFullScreen,
    };
};
var mapDispatchToProps = function (dispatch) {
    return {
        handleUndoRedoButtonClick: function () { return dispatch(mvk_state_1.toggleRouteUpdateAction()); },
    };
};
exports.NewbuildingMVKContainer = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(mvk_1.NewbuildingMVK);


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var utils_1 = __webpack_require__(1);
var main_block_1 = __webpack_require__(45);
var navigation_1 = __webpack_require__(117);
var side_block_1 = __webpack_require__(123);
var routerHelper_1 = __webpack_require__(30);
var styles = __webpack_require__(144);
var NewbuildingMVK = /** @class */ (function (_super) {
    __extends(NewbuildingMVK, _super);
    function NewbuildingMVK() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handlePopState = function () {
            if (routerHelper_1.isPreviousRouteFirst()) {
                window.history.back();
                return;
            }
            _this.props.handleUndoRedoButtonClick();
        };
        return _this;
    }
    NewbuildingMVK.prototype.componentDidMount = function () {
        window.onpopstate = this.handlePopState;
    };
    NewbuildingMVK.prototype.render = function () {
        var _a = this.props, isFullScreen = _a.isFullScreen, containerStyles = _a.containerStyles, onClose = _a.onClose;
        return (React.createElement(React.Fragment, null,
            React.createElement(navigation_1.NavigationContainer, { key: 1, onClose: onClose }),
            React.createElement("div", __assign({ key: 2 }, utils_1.mergeStyles(styles['content'], isFullScreen && styles['content--fullscreen'], containerStyles)),
                React.createElement(main_block_1.MainBlockContainer, null),
                React.createElement(side_block_1.SideBlockContainer, null))));
    };
    return NewbuildingMVK;
}(React.Component));
exports.NewbuildingMVK = NewbuildingMVK;


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var react_redux_1 = __webpack_require__(3);
var redux_1 = __webpack_require__(10);
var mvk_state_1 = __webpack_require__(4);
var main_block_1 = __webpack_require__(46);
function mapStateToProps(state) {
    return {
        isFullScreen: state.MVKState.isFullScreen,
        isPanoramaActive: state.MVKState.map.isPanoramaActive,
        isOfferCard: state.MVKState.isOfferCard,
    };
}
function mapDispatchToProps(dispatch) {
    return {
        changeFullScreenTipVisibility: redux_1.bindActionCreators(mvk_state_1.changeFullScreenTipVisibilityAction, dispatch),
        toggleFullScreen: redux_1.bindActionCreators(mvk_state_1.toggleFullScreenAction, dispatch),
    };
}
exports.MainBlockContainer = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(main_block_1.MainBlock);


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var map_1 = __webpack_require__(47);
var flat_phase_1 = __webpack_require__(75);
var floor_scheme_1 = __webpack_require__(99);
var info_tooltip_1 = __webpack_require__(109);
var full_screen_control_1 = __webpack_require__(112);
var styles = __webpack_require__(116);
var MainBlock = /** @class */ (function (_super) {
    __extends(MainBlock, _super);
    function MainBlock() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            shouldShowFullScreenTip: false,
        };
        _this.showFullscreenTip = function () {
            if (!window) {
                return;
            }
            var changeFullScreenTipVisibility = _this.props.changeFullScreenTipVisibility;
            changeFullScreenTipVisibility(true);
            _this.fullScreenTimer = window.setTimeout(function () {
                changeFullScreenTipVisibility(false);
            }, 5000);
        };
        _this.toggleFullScreen = function () {
            clearTimeout(_this.fullScreenTimer);
            _this.props.toggleFullScreen(!_this.props.isFullScreen);
        };
        _this.handleKeydown = function (event) {
            var isFullScreen = _this.props.isFullScreen;
            if (event.keyCode === 27 && isFullScreen) {
                _this.props.toggleFullScreen(!isFullScreen);
            }
        };
        return _this;
    }
    MainBlock.prototype.componentDidMount = function () {
        document.addEventListener('keydown', this.handleKeydown, false);
    };
    MainBlock.prototype.componentWillUnmount = function () {
        clearTimeout(this.fullScreenTimer);
        document.removeEventListener('keydown', this.handleKeydown, false);
    };
    MainBlock.prototype.componentWillReceiveProps = function (nextProps) {
        if (!this.props.isFullScreen && nextProps.isFullScreen) {
            this.showFullscreenTip();
        }
    };
    MainBlock.prototype.render = function () {
        var _a = this.props, isFullScreen = _a.isFullScreen, isOfferCard = _a.isOfferCard, isPanoramaActive = _a.isPanoramaActive;
        return (React.createElement("div", { className: styles['container'], id: "newbuilding_mvk_fragment-main_block" },
            !isOfferCard && !isPanoramaActive &&
                React.createElement(full_screen_control_1.FullScreenControl, { onToggle: this.toggleFullScreen, isActive: isFullScreen }),
            React.createElement(info_tooltip_1.InfoTooltipContainer, null),
            React.createElement(map_1.MVKMapContainer, null),
            React.createElement(floor_scheme_1.FloorSchemeContainer, null),
            React.createElement(flat_phase_1.FlatPhaseContainer, null)));
    };
    return MainBlock;
}(React.Component));
exports.MainBlock = MainBlock;


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var react_redux_1 = __webpack_require__(3);
var map_1 = __webpack_require__(18);
var mvk_state_1 = __webpack_require__(4);
var map_2 = __webpack_require__(48);
function mapStateToProps(state) {
    var _a = state.MVKState, phase = _a.phase, map = _a.map, house = _a.house, section = _a.section, isOfferCard = _a.isOfferCard;
    var infrastructureList = map.infrastructureList, selectedInfrastructureTypes = map.selectedInfrastructureTypes;
    return {
        currentMVKPhase: phase,
        hoveredHouseId: house.hoveredId,
        hoveredSectionId: section.hoveredId,
        infrastructureList: infrastructureList,
        isNoPanorama: map.isNoPanorama,
        isPanoramaActive: map.isPanoramaActive,
        isRulerActive: map.isRulerActive,
        MVKData: state.MVKData,
        selectedInfrastructureTypes: selectedInfrastructureTypes,
        isOfferCard: isOfferCard,
    };
}
function mapDispatchToProps(dispatch) {
    return {
        clearSelectedInfrastructureTypes: function () { return dispatch(map_1.clearSelectedInfrastructureTypesAction()); },
        searchInfrastructures: function (bbox) { return dispatch(map_1.searchMapInfrastructureAction(bbox)); },
        setHouseId: function (houseId) { return dispatch(mvk_state_1.setHouseIdAction(houseId)); },
        setHoveredHouseId: function (houseId) { return dispatch(mvk_state_1.setHoveredHouseIdAction(houseId)); },
        setHoveredSectionId: function (sectionId, houseId) {
            dispatch(mvk_state_1.setHoveredSectionIdAction(sectionId, houseId));
        },
        setMVKPhase: function (phase) { return dispatch(mvk_state_1.setMVKPhaseAction(phase)); },
        setNoPanorama: function (state) { return dispatch(map_1.setNoPanoramaAction(state)); },
        setPanoramaActive: function (isActive) { return dispatch(map_1.setPanoramaActiveAction(isActive)); },
        setRulerActive: function (isActive) { return dispatch(map_1.setRulerActiveAction(isActive)); },
        setSectionId: function (sectionId) { return dispatch(mvk_state_1.setSectionIdAction(sectionId)); },
        toggleSelectedInfrastructureType: function (type) {
            dispatch(map_1.toggleSelectedInfrastructureTypeAction(type));
        },
    };
}
exports.MVKMapContainer = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(map_2.MVKMap);


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
// tslint:disable:max-file-line-count
var React = __webpack_require__(0);
var mvk_state_1 = __webpack_require__(2);
var infrastructure_1 = __webpack_require__(49);
var polygon_1 = __webpack_require__(8);
var tracking_1 = __webpack_require__(7);
var ymaps_1 = __webpack_require__(53);
var icons_1 = __webpack_require__(13);
var infrastructure_2 = __webpack_require__(64);
var no_panorama_1 = __webpack_require__(66);
var panorama_1 = __webpack_require__(68);
var ruler_1 = __webpack_require__(70);
var zoom_1 = __webpack_require__(72);
var mvk_data_1 = __webpack_require__(9);
var styles = __webpack_require__(74);
var YMapsOptions = {
    require: [
        'Map',
        'GeoObject',
        'ObjectManager',
        'templateLayoutFactory',
        'geometry.pixel.Rectangle',
        'shape.Rectangle',
        'control.RulerControl',
        'objectManager.addon.objectsBalloon',
        'util.bounds',
        'geoObject.addon.hint',
        'objectManager.addon.objectsHint',
    ],
};
var MAX_ZOOM = 17;
var DEFAULT_ZOOM = 10;
var MOSCOW_COORDS = [37.61556, 55.75222];
var MVKMap = /** @class */ (function (_super) {
    __extends(MVKMap, _super);
    function MVKMap() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.mapContainer = null;
        _this.panoramaManager = null;
        _this.mapInfrastructureObjects = [];
        _this.newbuildingPolygon = null;
        _this.sectionPolygons = [];
        _this.hoveredSectionPolygon = undefined;
        _this.coordinates = MOSCOW_COORDS;
        _this.initialCenterAndZoom = null;
        _this.panoramaInProcess = false;
        _this.initMap = function (shouldTriggerPanorama) {
            if (_this.mapContainer) {
                var _a = _this.props, MVKData = _a.MVKData, searchInfrastructures = _a.searchInfrastructures;
                _this.map = new _this.ymaps.Map(_this.mapContainer, {
                    center: MOSCOW_COORDS,
                    zoom: DEFAULT_ZOOM,
                }, { autoFitToViewport: 'always' });
                searchInfrastructures(_this.map.getBounds());
                _this.mapObjectManager = new _this.ymaps.ObjectManager();
                _this.mapObjectManager.events.add('click', _this.handleInfrastructureObjectClick);
                _this.map.events.add('boundschange', _this.handleMapBoundsChange);
                _this.map.geoObjects.add(_this.mapObjectManager);
                _this.map.behaviors.disable('scrollZoom');
                _this.map.behaviors.disable('dblClickZoom');
                _this.ruler = _this.map.behaviors.get('ruler');
                if (!_this.newbuildingPolygon) {
                    var coloredNewbuildingPolygon = polygon_1.getColoredNewbuildingPolygon(MVKData.polygon);
                    _this.newbuildingPolygon = _this.createYmapsPolygon(coloredNewbuildingPolygon);
                }
                var coloredSectionPolygons = mvk_data_1.getColoredSectionPolygons(MVKData, _this.ymaps);
                _this.sectionPolygons = _this.createSectionYmapsPolygons(coloredSectionPolygons);
                _this.drawPolygons(__spread([
                    _this.newbuildingPolygon
                ], _this.sectionPolygons));
                if (!_this.initialCenterAndZoom) {
                    var _b = _this.mapContainer.getBoundingClientRect(), width = _b.width, height = _b.height;
                    var _c = _this.ymaps.util.bounds.getCenterAndZoom(_this.newbuildingPolygon.geometry.getBounds(), [width, height]), center = _c.center, zoom = _c.zoom;
                    _this.initialCenterAndZoom = { center: center, zoom: zoom };
                }
                _this.coordinates = MVKData.geoInfo
                    ? [MVKData.geoInfo.coordinates.lng, MVKData.geoInfo.coordinates.lat]
                    : _this.initialCenterAndZoom.center;
                _this.setCenterAndZoom(_this.initialCenterAndZoom.center, _this.initialCenterAndZoom.zoom);
                if (!!shouldTriggerPanorama) {
                    _this.handleClickPanorama();
                }
            }
        };
        // Переключаем типы инфраструктур на карте
        _this.handleInfrastructureSelect = function (type) {
            if (!_this.map) {
                return;
            }
            var _a = _this.props, selectedInfrastructureTypes = _a.selectedInfrastructureTypes, toggleSelectedInfrastructureType = _a.toggleSelectedInfrastructureType, isOfferCard = _a.isOfferCard;
            tracking_1.trackInfrastructureChange(type, isOfferCard);
            toggleSelectedInfrastructureType(type);
            _this.map.balloon.close().catch();
            if (selectedInfrastructureTypes.includes(type)) {
                _this.removeInfrastructures(type);
            }
        };
        // Добавляем новые пины инфраструктуры на карту
        _this.addInfrastructures = function (infrastructureList, selectedInfrastructureTypes) {
            var featureList = infrastructure_1.convertInfrastructureListToFeatureList(_this.ymaps, infrastructureList);
            // оставляем только инфраструктуры выбранных типов и которых еще нет на карте
            var uniqueFeatureList = featureList
                .filter(function (obj) { return selectedInfrastructureTypes.includes(obj.infrastructureType); });
            _this.mapInfrastructureObjects = _this.mapInfrastructureObjects.concat(uniqueFeatureList);
            _this.mapObjectManager.add(uniqueFeatureList);
        };
        // Показываем попап при клике на пин инфраструктуры на карте
        _this.handleInfrastructureObjectClick = function (event) {
            var id = event.get('objectId');
            var infrastructureObject = _this.mapInfrastructureObjects.find(function (obj) { return obj.id === id; });
            if (infrastructureObject) {
                _this.mapObjectManager.objects.balloon.open(id);
            }
        };
        // удаляет пины инфраструктуры с карты по типу
        _this.removeInfrastructures = function (type) {
            var objectsForRemove = _this.mapInfrastructureObjects.filter(function (obj) { return obj.infrastructureType === type; });
            _this.mapObjectManager.remove(objectsForRemove.map(function (obj) { return obj.id; }));
            _this.mapInfrastructureObjects = _this.mapInfrastructureObjects
                .filter(function (obj) { return !objectsForRemove.includes(obj); });
        };
        // удаляет все пины инфраструктуры с карты
        _this.removeAllInfrastructures = function () {
            _this.props.selectedInfrastructureTypes.forEach(_this.removeInfrastructures);
        };
        // при смене зуме делаем запрос за инфраструктурой
        _this.handleMapBoundsChange = function (event) {
            var _a = _this.props, searchInfrastructures = _a.searchInfrastructures, setMVKPhase = _a.setMVKPhase, isPanoramaActive = _a.isPanoramaActive;
            var oldZoom = event.get('oldZoom');
            var newZoom = event.get('newZoom');
            if (oldZoom !== newZoom) {
                searchInfrastructures(_this.map.getBounds());
            }
            if (newZoom < oldZoom && !isPanoramaActive) {
                setMVKPhase(mvk_state_1.MVKPhase.PREVIEW);
            }
        };
        // создает полигоны секций для карты
        // навешивает события клика и ховера
        _this.createSectionYmapsPolygons = function (sectionPolygons) {
            return sectionPolygons.map(function (polygon) {
                var ymapsPolygon = _this.createYmapsPolygon(polygon);
                ymapsPolygon.events.add('click', _this.handleSectionClick);
                ymapsPolygon.events.add('mouseenter', _this.handleSectionMouseEnter);
                ymapsPolygon.events.add('mouseleave', _this.handleSectionMouseLeave);
                return ymapsPolygon;
            });
        };
        // меняем прозрачность полигона при наведении мыши
        // ложим в стор id секции при наведении
        _this.handleSectionMouseEnter = function (event) {
            var target = event.get('target');
            _this.props.setHoveredSectionId(target.options.get('id'), target.options.get('houseId'));
        };
        // меняем прозрачность полигона при наведении мыши
        // очищаем в сторе id секции и дома
        _this.handleSectionMouseLeave = function () {
            _this.props.setHoveredSectionId();
        };
        // сохраняем id выбранной секции и дома
        _this.handleSectionClick = function (event) {
            var target = event.get('target');
            tracking_1.trackSectionClick(_this.props.isOfferCard);
            _this.props.setHouseId(target.options.get('houseId'));
            _this.props.setSectionId(target.options.get('id'));
        };
        // создает полигон для карты
        _this.createYmapsPolygon = function (polygon) {
            return new _this.ymaps.GeoObject(polygon_1.getYmapsPolygonGeometryOptions(polygon), polygon.props);
        };
        _this.drawPolygons = function (polygons) {
            polygons.forEach(function (polygon) {
                if (polygon) {
                    _this.map.geoObjects.add(polygon);
                }
            });
        };
        _this.setCenterAndZoom = function (center, zoom) {
            _this.map.setCenter(center, zoom > MAX_ZOOM ? MAX_ZOOM : zoom);
        };
        _this.onZoomIn = function () { return _this.map.setZoom(_this.map.getZoom() + 1); };
        _this.onZoomOut = function () { return _this.map.setZoom(_this.map.getZoom() - 1); };
        _this.toggleRuler = function () {
            if (_this.ruler.isEnabled()) {
                _this.ruler.close();
                _this.ruler.disable();
                _this.props.setRulerActive(false);
            }
            else {
                _this.ruler.enable();
                _this.props.setRulerActive(true);
            }
        };
        _this.handleClickPanorama = function () {
            var _a = _this.props, setPanoramaActive = _a.setPanoramaActive, setNoPanorama = _a.setNoPanorama;
            _this.panoramaInProcess = true;
            setPanoramaActive(true);
            _this.map.getPanoramaManager()
                .then(function (panoramaManager) {
                panoramaManager.openPlayer(_this.coordinates)
                    .then(function () {
                    _this.panoramaManager = panoramaManager;
                    var player = panoramaManager.getPlayer();
                    if (player) {
                        player.events.add('destroy', function () {
                            setPanoramaActive(false);
                            _this.panoramaInProcess = false;
                        });
                    }
                })
                    .catch(function () {
                    setNoPanorama(true);
                });
            })
                .catch();
        };
        _this.handleClickNoPanoramaLink = function () {
            _this.props.setPanoramaActive(false);
            _this.props.setNoPanorama(false);
            _this.panoramaInProcess = false;
        };
        return _this;
    }
    MVKMap.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, ymaps_1.loadYmapsApi(YMapsOptions)];
                    case 1:
                        _a.ymaps = _b.sent();
                        this.initMap();
                        return [2 /*return*/];
                }
            });
        });
    };
    MVKMap.prototype.componentWillReceiveProps = function (nextProps) {
        var _this = this;
        var _a = this.props, infrastructureList = _a.infrastructureList, selectedInfrastructureTypes = _a.selectedInfrastructureTypes, clearSelectedInfrastructureTypes = _a.clearSelectedInfrastructureTypes, currentMVKPhase = _a.currentMVKPhase;
        /*
          При маунте приложения из состояния без карты необходимо ее переинициализировать
        */
        var initMapWithPanorama = false;
        if (!this.panoramaInProcess && !this.props.isPanoramaActive && nextProps.isPanoramaActive) {
            if (!this.map) {
                initMapWithPanorama = true;
            }
            else {
                this.handleClickPanorama();
            }
        }
        if (!this.mapContainer) {
            setTimeout(function () { return _this.initMap(initMapWithPanorama); }, 0);
        }
        var phaseIsPreview = currentMVKPhase === mvk_state_1.MVKPhase.PREVIEW;
        var nextPhaseIsPreview = nextProps.currentMVKPhase === mvk_state_1.MVKPhase.PREVIEW;
        // добавляем инфраструктуру на карту
        if (nextProps.selectedInfrastructureTypes !== selectedInfrastructureTypes ||
            nextProps.infrastructureList !== infrastructureList) {
            this.addInfrastructures(nextProps.infrastructureList, nextProps.selectedInfrastructureTypes);
        }
        // очищаем инфраструктуру на карте
        if (!nextPhaseIsPreview && nextProps.selectedInfrastructureTypes.length) {
            this.removeAllInfrastructures();
            clearSelectedInfrastructureTypes();
        }
        // если возвращаемся на фазу превью, возвращаем на карту полигоны ЖК и выбранного корпуса, удаляем полигоны секций
        if (!phaseIsPreview && nextPhaseIsPreview && this.initialCenterAndZoom) {
            this.setCenterAndZoom(this.initialCenterAndZoom.center, this.initialCenterAndZoom.zoom);
        }
        // закрываем панораму
        if (!nextProps.isPanoramaActive && this.panoramaManager) {
            this.panoramaManager.closePlayer();
            this.panoramaManager = null;
        }
        if (nextProps.hoveredSectionId !== this.props.hoveredSectionId) {
            if (this.hoveredSectionPolygon) {
                polygon_1.setHoverOpacityToPolygon(this.hoveredSectionPolygon, false);
                this.hoveredSectionPolygon = undefined;
            }
            var hoveredHouseId_1 = nextProps.hoveredHouseId || this.props.hoveredHouseId;
            var hoveredSectionId_1 = nextProps.hoveredSectionId || this.props.hoveredSectionId;
            var sectionPolygon = this.sectionPolygons.find(function (polygon) {
                return polygon.options.get('houseId') === hoveredHouseId_1 && polygon.options.get('id') === hoveredSectionId_1;
            });
            if (sectionPolygon) {
                polygon_1.setHoverOpacityToPolygon(sectionPolygon, !!nextProps.hoveredSectionId);
                this.hoveredSectionPolygon = sectionPolygon;
            }
        }
    };
    MVKMap.prototype.render = function () {
        var _this = this;
        var _a = this.props, selectedInfrastructureTypes = _a.selectedInfrastructureTypes, currentMVKPhase = _a.currentMVKPhase, isPanoramaActive = _a.isPanoramaActive, isNoPanorama = _a.isNoPanorama, isRulerActive = _a.isRulerActive, isOfferCard = _a.isOfferCard;
        var phaseIsPreview = currentMVKPhase === mvk_state_1.MVKPhase.PREVIEW;
        if (!phaseIsPreview) {
            this.mapContainer = null;
            return null;
        }
        return (React.createElement("div", { className: styles['container'] },
            React.createElement("div", { ref: function (ref) { return _this.mapContainer = ref; }, className: styles['map'] }),
            isNoPanorama && React.createElement(no_panorama_1.NoPanorama, { onClick: this.handleClickNoPanoramaLink }),
            this.map && !isPanoramaActive &&
                React.createElement(React.Fragment, null,
                    phaseIsPreview &&
                        React.createElement(infrastructure_2.MVKMapInfrastructure, { key: "infrastructure", selected: selectedInfrastructureTypes, onSelect: this.handleInfrastructureSelect, isOfferCard: isOfferCard }),
                    React.createElement(zoom_1.ZoomControls, { key: "zoom-controls", onZoomIn: this.onZoomIn, onZoomOut: this.onZoomOut, zoomInDisabled: this.map.getZoom() === MAX_ZOOM }),
                    React.createElement(ruler_1.RulerControl, { key: "ruler-control", onToggle: this.toggleRuler, isActive: isRulerActive }),
                    React.createElement(panorama_1.PanoramaControl, { key: "panorama-control", onClick: this.handleClickPanorama }),
                    React.createElement("div", { className: styles['compass'], key: "compass" },
                        icons_1.compassIcon,
                        React.createElement("span", { className: styles['compass-text'] }, "\u0421\u0435\u0432\u0435\u0440")))));
    };
    return MVKMap;
}(React.Component));
exports.MVKMap = MVKMap;


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var infrastructure_balloon_1 = __webpack_require__(50);
var mvk_state_1 = __webpack_require__(2);
// tslint:disable:max-line-length
var createIcon = function (content) {
    return "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 54 61\" width=\"54\" height=\"61\">\n    <filter id=\"infrastructure-icon-layout\" width=\"134.8%\" height=\"129.6%\" x=\"-17.4%\" y=\"-7.4%\" filterUnits=\"objectBoundingBox\">\n      <feOffset dy=\"4\" in=\"SourceAlpha\" result=\"shadowOffsetOuter1\"/>\n      <feGaussianBlur in=\"shadowOffsetOuter1\" result=\"shadowBlurOuter1\" stdDeviation=\"2\"/>\n      <feColorMatrix in=\"shadowBlurOuter1\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0\"/>\n    </filter>\n    <ellipse cx=\"27\" cy=\"53.5\" fill-opacity=\".15\" rx=\"5\" ry=\"1.5\"/>\n    <path d=\"M24.28 45.84C12.86 44.496 4 34.783 4 23 4 10.297 14.297 0 27 0s23 10.297 23 23c0 11.782-8.86 21.495-20.28 22.84L27 54l-2.72-8.16z\" filter=\"url(#infrastructure-icon-layout)\"/>\n    <path fill=\"#FFF\" d=\"M27 0C14.297 0 4 10.297 4 23c0 11.783 8.86 21.496 20.28 22.84L27 54l2.72-8.16C41.14 44.495 50 34.782 50 23 50 10.297 39.703 0 27 0z\"/>\n    <circle cx=\"27\" cy=\"23\" r=\"18\" fill=\"none\" stroke=\"#999\" stroke-width=\"4\"/>\n    <g fill=\"#7A7A7A\" transform=\"translate(4, 0)\">\n      " + content + "\n    </g>\n  </svg>";
};
var IconSchools = createIcon("<path d=\"M31.9 17.9h-.2l-1.7 1V28s-.2.2-.3.2h-.3c-1.5 0-4.2.2-6 1.2l-.4.2-.3-.1c-1.8-1-4.5-1.2-6-1.2h-.4l-.2-.2V19l-1.8-1H14v11.5c0 .1 0 .1.1.1 0 0 .1.1.1 0 .5-.1 1.4-.1 2.4-.1 2.1 0 3.8.3 4.9.9.2.1 1.1.6 1.5.6.4 0 1.4-.5 1.5-.6 1.1-.6 2.8-.9 4.9-.9 1 0 1.8.1 2.4.1h.1l.1-.1V18.1c0-.1 0-.2-.1-.2zm-7.7 10.2h.2c1.2-.5 2.8-.8 4.6-.9.1 0 .2-.1.2-.2V16.1c0-.1 0-.1-.1-.1h-.2l-4.7 2c-.1 0-.1.1-.1.2v9.7c0 .1 0 .1.1.2zm-7-1c1.8 0 3.4.3 4.6.9h.2l.1-.1v-9.7c0-.1 0-.1-.1-.2l-4.7-2h-.2l-.1.1V27c.1 0 .2.1.2.1z\"/>");
var IconKindergarden = createIcon("<path d=\"M18.6 20.9c1.4 0 2.5-1 2.5-2.3 0-.8.3-1.5-.4-1.9-.4-.2-2.1-.4-2.6-.4-.6 0-1.4.5-1.8.8-.5.4-.1.8-.1 1.5-.1 1.3 1 2.3 2.4 2.3zm-1.8-2.5c.5-.1.8.1.8.1l.8-.3s-.4.5 0 .3c.8-.2 1.6-.1 2.1-.1v.3c0 .9-.8 1.7-1.8 1.7s-1.8-.8-1.8-1.7c-.1-.1-.1-.2-.1-.3zm7.5 2.7c-.1-1.2.5-2 .7-2.2.2 1.3 1.4 2.2 2.8 2.2 1.3 0 2.5-.9 2.8-2.1.2.4.6 1.2.5 2 2.4 0 1.2-2.6-.5-2.9 0-.1 0-.3-.1-.4 0-.6-.7-2.2-2.9-2.2-1.9 0-2.3 1.4-2.4 2.2-.1.2-.1.4-.1.6-2.7.4-2.4 2.8-.8 2.8zm2.2-3.4s.2.1.2.8c.4.1 1.2-1.2 1.2-1.2v1c.5.1 1.9 0 1.9 0h.1v.1c0 1.1-.9 1.9-2.1 1.9-1.1 0-2-.8-2.1-1.9.5 0 .8-.7.8-.7zm1.9 3.6h-2.2l-3 3.3-2.9-3.3H17l-3.4 3.5.7.7 2.4-1.9v3.8h.5v2.9h-.3v.2h1.6v-3.2h.5v3.2h1.4v-.3H20v-2.9h.6v-3.7l2 1.9.8-.2.4.1L26 23l.1.9-2.1 3.3h2.4v2.9h-.3v.4h1.4v-3.2h.5v3.2h1.4v-.3h-.3v-2.9H31L29.2 24l.1-1.2 2.2 2.7 1-1-2.9-3.2h-1.2z\"/>");
var IconPolyclinics = createIcon("<path d=\"M32 20h-6v-6h-6v6h-6v6h6v6h6v-6h6z\"/>");
var IconGroceryStores = createIcon("<path d=\"M32.2 16.3c-.1-.2-.4-.3-.7-.3H17.9l-.2-1.2c-.1-.5-.5-.8-1-.8h-2.2c-.5 0-1 .4-1 1s.4 1 1 1h1.4l1.8 11.2v.1c0 .1 0 .1.1.2 0 .1.1.1.1.2l.1.1c.1.1.1.1.2.1 0 0 .1 0 .1.1.1 0 .2.1.4.1h10.9c.5 0 1-.4 1-1s-.4-1-1-1H19.5l-.2-1h11.2c.5 0 .9-.4 1-.9l1-7c0-.3-.1-.6-.3-.9zM21.6 23H19l-.3-2h2.9v2zm0-3h-3.1l-.3-2h3.4v2zm4 3h-3v-2h3v2zm0-3h-3v-2h3v2zm4.1 3h-3.1v-2H30l-.3 2zm.4-3h-3.5v-2h3.8l-.3 2zM20 29c-.8 0-1.5.7-1.5 1.5S19.2 32 20 32s1.5-.7 1.5-1.5S20.8 29 20 29zm8 0c-.8 0-1.5.7-1.5 1.5S27.2 32 28 32s1.5-.7 1.5-1.5S28.8 29 28 29z\"/>");
var IconCafes = createIcon("<path d=\"M21.49 20c-1.198-2.3 6.29-7.9-1.498-8 4.493 1.9-2.396 7 1.498 8zm3.394 0c-.699-1.5 2.596-4.2.2-5 .599 1.4-2.596 4.2-.2 5zm7.688 3c-.5-.8-1.498-1.2-2.596-1.2v-.4c0-.2-.2-.3-.3-.3H15.3c-.2 0-.3.2-.3.3 0 2.1.4 4 1.198 5.7.799 1.8 1.997 3.1 3.395 3.9h5.69c.9-.5 1.698-1.2 2.397-2.2 2.596 0 4.493-1.6 4.992-3.1.499-.9.4-1.9-.1-2.7zm-1.398 2.2c-.3.8-1.198 1.6-2.496 1.9.5-1.1.899-2.4 1.098-3.7h.1c.6 0 .999.2 1.198.5.3.4.3.8.1 1.3z\"/>");
// tslint:enable:max-line-length
var schools;
var kindergarden;
var polyclinics;
var groceryStores;
var cafe;
function initIcons(ymaps) {
    if (!schools) {
        schools = ymaps.templateLayoutFactory.createClass(IconSchools);
    }
    if (!kindergarden) {
        kindergarden = ymaps.templateLayoutFactory.createClass(IconKindergarden);
    }
    if (!polyclinics) {
        polyclinics = ymaps.templateLayoutFactory.createClass(IconPolyclinics);
    }
    if (!groceryStores) {
        groceryStores = ymaps.templateLayoutFactory.createClass(IconGroceryStores);
    }
    if (!cafe) {
        cafe = ymaps.templateLayoutFactory.createClass(IconCafes);
    }
}
function getInfrastructureIconLayout(ymaps, type) {
    initIcons(ymaps);
    switch (type) {
        case 0 /* Schools */:
            return schools;
        case 1 /* Kindergarden */:
            return kindergarden;
        case 2 /* Polyclinics */:
            return polyclinics;
        case 3 /* GroceryStores */:
            return groceryStores;
        case 4 /* Cafes */:
            return cafe;
        default:
            return null;
    }
}
exports.getInfrastructureIconLayout = getInfrastructureIconLayout;
function convertInfrastructureListToFeatureList(ymaps, list) {
    return list.reduce(function (acc, item) {
        var featureType = getInfrastructureType(item.category);
        if (featureType !== undefined) {
            var features = item.companies.map(function (company) { return convertInfrastructureToFeature(ymaps, company, featureType); });
            return acc.concat(features);
        }
        return acc;
    }, []);
}
exports.convertInfrastructureListToFeatureList = convertInfrastructureListToFeatureList;
function convertInfrastructureToFeature(ymaps, item, type) {
    return {
        geometry: {
            coordinates: [item.coordinates.lon, item.coordinates.lat],
            type: 'Point',
        },
        id: String(item.id),
        infrastructureType: type,
        options: {
            balloonLayout: infrastructure_balloon_1.getBalloonLayout(ymaps),
            iconLayout: getInfrastructureIconLayout(ymaps, type),
            iconOffset: [-27, -61],
            iconShape: {
                coordinates: [27, 27],
                radius: 26.5,
                type: 'Circle',
            },
            iconSize: [54, 61],
            zIndex: 1,
        },
        properties: {
            objects: [{
                    name: item.name,
                    type: type,
                }],
        },
        type: 'Feature',
    };
}
function getInfrastructureType(item) {
    var keys = Object.keys(mvk_state_1.InfrastructureCategory).map(Number);
    return keys.find(function (key) { return mvk_state_1.InfrastructureCategory[key] === item; });
}
exports.getInfrastructureType = getInfrastructureType;


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var styles = __webpack_require__(51);
var balloonLayout;
function getBalloonLayout(ymaps) {
    if (!balloonLayout) {
        // tslint:disable:object-literal-shorthand no-any max-line-length no-invalid-this
        balloonLayout = ymaps.templateLayoutFactory.createClass("<div class=\"" + styles['container'] + "\">\n      <div class=\"" + styles['items'] + "\">\n        {% for object in properties.objects %}\n          <div class=\"" + styles['item'] + "\">\n            {% if object.type == " + 0 /* Schools */ + " %}\n              <svg xmlns=\"http://www.w3.org/2000/svg\" class=\"" + styles['icon'] + "\" viewBox=\"0 0 20 20\" width=\"20\" height=\"20\">\n                <path fill=\"currentColor\" d=\"M18.9 4.4h-.2l-1.7 1v9.1s-.2.2-.3.2h-.3c-1.5 0-4.2.2-6 1.2l-.4.2-.3-.1c-1.8-1-4.5-1.2-6-1.2h-.4l-.2-.2V5.5l-1.8-1H1V16c0 .1 0 .1.1.1 0 0 .1.1.1 0 .5-.1 1.4-.1 2.4-.1 2.1 0 3.8.3 4.9.9.2.1 1.1.6 1.5.6s1.4-.5 1.5-.6c1.1-.6 2.8-.9 4.9-.9 1 0 1.8.1 2.4.1h.1l.1-.1V4.6c0-.1 0-.2-.1-.2zm-7.7 10.2h.2c1.2-.5 2.8-.8 4.6-.9.1 0 .2-.1.2-.2V2.6c0-.1 0-.1-.1-.1h-.2l-4.7 2c-.1 0-.1.1-.1.2v9.7c0 .1 0 .1.1.2zm-7-1c1.8 0 3.4.3 4.6.9H9l.1-.1V4.7c0-.1 0-.1-.1-.2l-4.7-2h-.2l-.1.1v10.9c.1 0 .2.1.2.1z\"/>\n              </svg>\n            {% elseif object.type == " + 1 /* Kindergarden */ + " %}\n              <svg xmlns=\"http://www.w3.org/2000/svg\" class=\"" + styles['icon'] + "\" viewBox=\"0 0 20 20\" width=\"20\" height=\"20\">\n                <path fill=\"currentColor\" d=\"M5.6 7.9c1.4 0 2.5-1 2.5-2.3 0-.8.3-1.5-.4-1.9-.4-.2-2.1-.4-2.6-.4-.6 0-1.4.5-1.8.8-.5.4-.1.8-.1 1.5-.1 1.3 1 2.3 2.4 2.3zM3.8 5.4c.5-.1.8.1.8.1l.8-.3s-.4.5 0 .3c.8-.2 1.6-.1 2.1-.1v.3c0 .9-.8 1.7-1.8 1.7s-1.8-.8-1.8-1.7c-.1-.1-.1-.2-.1-.3zm7.5 2.7c-.1-1.2.5-2 .7-2.2.2 1.3 1.4 2.2 2.8 2.2 1.3 0 2.5-.9 2.8-2.1.2.4.6 1.2.5 2 2.4 0 1.2-2.6-.5-2.9 0-.1 0-.3-.1-.4 0-.6-.7-2.2-2.9-2.2-1.9 0-2.3 1.4-2.4 2.2-.1.2-.1.4-.1.6-2.7.4-2.4 2.8-.8 2.8zm2.2-3.4s.2.1.2.8c.4.1 1.2-1.2 1.2-1.2v1c.5.1 1.9 0 1.9 0h.1v.1c0 1.1-.9 1.9-2.1 1.9-1.1 0-2-.8-2.1-1.9.5 0 .8-.7.8-.7zm1.9 3.6h-2.2l-3 3.3-2.9-3.3H4L.6 11.8l.7.7 2.4-1.9v3.8h.5v2.9h-.3v.2h1.6v-3.2H6v3.2h1.4v-.3H7v-2.9h.6v-3.7l2 1.9.8-.2.4.1L13 10l.1.9-2.1 3.3h2.4v2.9h-.3v.4h1.4v-3.2h.5v3.2h1.4v-.3h-.3v-2.9H18L16.2 11l.1-1.2 2.2 2.7 1-1-2.9-3.2h-1.2z\"/>\n              </svg>\n            {% elseif object.type == " + 2 /* Polyclinics */ + " %}\n              <svg xmlns=\"http://www.w3.org/2000/svg\" class=\"" + styles['icon'] + "\" viewBox=\"0 0 20 20\" width=\"20\" height=\"20\">\n                <path fill=\"currentColor\" d=\"M19 7h-6V1H7v6H1v6h6v6h6v-6h6V7z\"/>\n              </svg>\n            {% elseif object.type == " + 3 /* GroceryStores */ + " %}\n              <svg xmlns=\"http://www.w3.org/2000/svg\" class=\"" + styles['icon'] + "\" viewBox=\"0 0 20 20\" width=\"20\" height=\"20\">\n                <path fill=\"currentColor\" d=\"M19.2 3.3c-.1-.2-.4-.3-.7-.3H4.9l-.2-1.2c-.1-.5-.5-.8-1-.8H1.5c-.5 0-1 .4-1 1s.4 1 1 1h1.4l1.8 11.2v.1c0 .1 0 .1.1.2 0 .1.1.1.1.2l.1.1c.1.1.1.1.2.1 0 0 .1 0 .1.1.1 0 .2.1.4.1h10.9c.5 0 1-.4 1-1s-.4-1-1-1H6.5l-.2-1h11.2c.5 0 .9-.4 1-.9l1-7c0-.3-.1-.6-.3-.9zM8.6 10H6l-.3-2h2.9v2zm0-3H5.5l-.3-2h3.4v2zm4 3h-3V8h3v2zm0-3h-3V5h3v2zm4.1 3h-3.1V8H17l-.3 2zm.4-3h-3.5V5h3.8l-.3 2zM7 16c-.8 0-1.5.7-1.5 1.5S6.2 19 7 19s1.5-.7 1.5-1.5S7.8 16 7 16zm8 0c-.8 0-1.5.7-1.5 1.5S14.2 19 15 19s1.5-.7 1.5-1.5S15.8 16 15 16z\"/>\n              </svg>\n            {% elseif object.type == " + 4 /* Cafes */ + " %}\n              <svg xmlns=\"http://www.w3.org/2000/svg\" class=\"" + styles['icon'] + "\" viewBox=\"0 0 20 20\" width=\"20\" height=\"20\">\n                <path fill=\"currentColor\" d=\"M7.49 8.5C6.292 6.2 13.78.6 5.992.5c4.493 1.9-2.396 7 1.498 8zm3.394 0c-.7-1.5 2.596-4.2.2-5 .6 1.4-2.596 4.2-.2 5zm7.688 3c-.5-.8-1.498-1.2-2.596-1.2v-.4c0-.2-.2-.3-.3-.3H1.3c-.2 0-.3.2-.3.3 0 2.1.4 4 1.198 5.7.8 1.8 1.997 3.1 3.395 3.9h5.69c.9-.5 1.698-1.2 2.397-2.2 2.596 0 4.493-1.6 4.992-3.1.5-.9.4-1.9-.1-2.7zm-1.398 2.2c-.3.8-1.198 1.6-2.496 1.9.5-1.1.9-2.4 1.098-3.7h.1c.6 0 1 .2 1.198.5.3.4.3.8.1 1.3z\"/>\n              </svg>\n            {% endif %}\n            {% if properties.objects.length == 1 %}<h4 class=\"" + styles['header'] + "\">{{object.name}}</h4>{% endif %}\n            {% if properties.objects.length > 1 %}<a class=\"" + styles['header'] + " " + styles['header--link'] + "\">{{object.name}}</a>{% endif %}\n            <p class=\"" + styles['type'] + "\">{{object.category}}</p>\n            {% if properties.objects.length == 1 && (object.phones || object.url) %}\n              <div class=\"" + styles['contacts'] + "\">\n                {% if object.phones %}<div class=\"" + styles['phones'] + "\">{{object.phones}}</div>{% endif %}\n                {% if object.url %}<a class=\"" + styles['url'] + "\" href=\"{{object.url}}\" target=\"_blank\" rel=\"nofollow noopener\">{{object.url}}</a>{% endif %}\n              </div>\n            {% endif %}\n          </div>\n        {% endfor %}\n      </div>\n      <button class=\"" + styles['close'] + "\">\n        <svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12.728 12.728\" width=\"13\" height=\"13\">\n          <path fill=\"currentColor\" d=\"M6.364 4.95L1.414 0 0 1.414l4.95 4.95L0 11.314l1.414 1.414 4.95-4.95 4.95 4.95 1.414-1.414-4.95-4.95 4.95-4.95L11.314 0l-4.95 4.95z\"/>\n        </svg>\n      </button>\n    </div>", {
            build: function () {
                var _this = this;
                this.constructor.superclass.build.call(this);
                this._balloon = document.querySelector("." + styles['container']);
                if (this._balloon) {
                    this._balloon.style.bottom = this._balloon.offsetHeight + 62 + "px";
                }
                var closeButton = document.querySelector("." + styles['close']);
                closeButton.addEventListener('click', function (event) { return _this.onCloseClick(event); });
                var links = document.querySelectorAll("." + styles['header--link']);
                if (links.length > 0) {
                    [].forEach.call(links, function (node, index) {
                        node.addEventListener('click', function () { return _this.onLinkClick(index); });
                    });
                }
            },
            getShape: function () {
                var balloon = this._balloon;
                if (!balloon) {
                    return this.constructor.superclass.getShape.call(this);
                }
                var offsetLeft = balloon.offsetLeft, offsetTop = balloon.offsetTop, offsetWidth = balloon.offsetWidth, offsetHeight = balloon.offsetHeight;
                var _a = ymaps, shape = _a.shape, geometry = _a.geometry;
                return new shape.Rectangle(new geometry.pixel.Rectangle([
                    [offsetLeft, offsetTop],
                    [offsetLeft + offsetWidth, offsetTop + offsetHeight],
                ]));
            },
            onCloseClick: function (event) {
                event.preventDefault();
                this.events.fire('userclose');
            },
            onLinkClick: function (index) {
                var data = this.getData();
                data.properties.set('objects', [data.properties.get('objects')[index]]);
            },
        });
    }
    return balloonLayout;
}
exports.getBalloonLayout = getBalloonLayout;


/***/ }),
/* 51 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"mvk_widget-container-6mq9KUGDAIy","close":"mvk_widget-close-dwjrJXcjHqc","items":"mvk_widget-items-67EowvbMRyk","item":"mvk_widget-item-auVFhzwxeSq","icon":"mvk_widget-icon-ltomUHNcCOK","header":"mvk_widget-header-8Hk6ulhZqoe","header--link":"mvk_widget-header--link-cHi0brRbfGa","type":"mvk_widget-type-hwNXalZoFaW","contacts":"mvk_widget-contacts-27ELhZErJ6g","phones":"mvk_widget-phones-bpMFwxIijKg","url":"mvk_widget-url-3LTfIkMsOk2"};

/***/ }),
/* 52 */
/***/ (function(module, exports) {

module.exports = require("@cian/analytics");

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ymapsPromise;
var YMAPS_API_KEY = 'ad7bd5e9-cdc2-47b7-8455-8d4800185ea7';
function loadYmapsApi(options) {
    if (!ymapsPromise) {
        ymapsPromise = new Promise(function (resolve, reject) {
            if (window.ymaps) {
                resolve(window.ymaps);
                return;
            }
            var e = window.document.createElement('script');
            e.src =
                "https://enterprise.api-maps.yandex.ru/2.1/?apikey=" + YMAPS_API_KEY + "&lang=ru-RU&load=Map&coordorder=longlat";
            e.async = true;
            e.defer = true;
            e.onload = function () {
                resolve(window.ymaps);
            };
            e.onerror = function () {
                reject(new Error('Unable to load Yandex Maps API'));
            };
            window.document.body.appendChild(e);
        });
    }
    return ymapsPromise.then(function (ymaps) { return ymaps.ready(options).then(function () { return ymaps; }); });
}
exports.loadYmapsApi = loadYmapsApi;


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable:max-line-length */
var React = __webpack_require__(0);
exports.infrastructureIcon = (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 8.025 12.95", width: "8", height: "14" },
    React.createElement("path", { fill: "currentColor", d: "M2 6.425l5.8-5.1c.3-.2.3-.8 0-1.1-.3-.3-.8-.3-1.1 0l-6.5 5.7c-.1 0-.2.2-.2.5 0 .2 0 .4.2.6l6.5 5.7c.3.3.8.3 1.1 0 .3-.2.3-.8 0-1.1L2 6.425z" })));


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable:max-line-length */
var React = __webpack_require__(0);
var styles = __webpack_require__(12);
exports.cafeIcon = (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", className: styles['icon-cafe'], viewBox: "0 0 20 20", width: "20", height: "20" },
    React.createElement("path", { fill: "currentColor", d: "M7.49 8.5C6.292 6.2 13.78.6 5.992.5c4.493 1.9-2.396 7 1.498 8zm3.394 0c-.7-1.5 2.596-4.2.2-5 .6 1.4-2.596 4.2-.2 5zm7.688 3c-.5-.8-1.498-1.2-2.596-1.2v-.4c0-.2-.2-.3-.3-.3H1.3c-.2 0-.3.2-.3.3 0 2.1.4 4 1.198 5.7.8 1.8 1.997 3.1 3.395 3.9h5.69c.9-.5 1.698-1.2 2.397-2.2 2.596 0 4.493-1.6 4.992-3.1.5-.9.4-1.9-.1-2.7zm-1.398 2.2c-.3.8-1.198 1.6-2.496 1.9.5-1.1.9-2.4 1.098-3.7h.1c.6 0 1 .2 1.198.5.3.4.3.8.1 1.3z" })));


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
exports.checkedCheckboxIcon = (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 9.222 7.463", width: "9", height: "7" },
    React.createElement("path", { fill: "#FFF", d: "M3.062 6.86l.745.603.633-.72 4.782-5.42L7.722 0 3.507 4.78 1.26 2.83 0 4.387 3.062 6.86z" })));


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable:max-line-length */
var React = __webpack_require__(0);
var styles = __webpack_require__(12);
exports.groceryStoresIcon = (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", className: styles['icon'], viewBox: "0 0 20 20", width: "20", height: "20" },
    React.createElement("path", { fill: "currentColor", d: "M19.2 3.3c-.1-.2-.4-.3-.7-.3H4.9l-.2-1.2c-.1-.5-.5-.8-1-.8H1.5c-.5 0-1 .4-1 1s.4 1 1 1h1.4l1.8 11.2v.1c0 .1 0 .1.1.2 0 .1.1.1.1.2l.1.1c.1.1.1.1.2.1 0 0 .1 0 .1.1.1 0 .2.1.4.1h10.9c.5 0 1-.4 1-1s-.4-1-1-1H6.5l-.2-1h11.2c.5 0 .9-.4 1-.9l1-7c0-.3-.1-.6-.3-.9zM8.6 10H6l-.3-2h2.9v2zm0-3H5.5l-.3-2h3.4v2zm4 3h-3V8h3v2zm0-3h-3V5h3v2zm4.1 3h-3.1V8H17l-.3 2zm.4-3h-3.5V5h3.8l-.3 2zM7 16c-.8 0-1.5.7-1.5 1.5S6.2 19 7 19s1.5-.7 1.5-1.5S7.8 16 7 16zm8 0c-.8 0-1.5.7-1.5 1.5S14.2 19 15 19s1.5-.7 1.5-1.5S15.8 16 15 16z" })));


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable:max-line-length */
var React = __webpack_require__(0);
var styles = __webpack_require__(12);
exports.kindergardenIcon = (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", className: styles['icon'], viewBox: "0 0 20 20", width: "20", height: "20" },
    React.createElement("path", { fill: "currentColor", d: "M5.6 7.9c1.4 0 2.5-1 2.5-2.3 0-.8.3-1.5-.4-1.9-.4-.2-2.1-.4-2.6-.4-.6 0-1.4.5-1.8.8-.5.4-.1.8-.1 1.5-.1 1.3 1 2.3 2.4 2.3zM3.8 5.4c.5-.1.8.1.8.1l.8-.3s-.4.5 0 .3c.8-.2 1.6-.1 2.1-.1v.3c0 .9-.8 1.7-1.8 1.7s-1.8-.8-1.8-1.7c-.1-.1-.1-.2-.1-.3zm7.5 2.7c-.1-1.2.5-2 .7-2.2.2 1.3 1.4 2.2 2.8 2.2 1.3 0 2.5-.9 2.8-2.1.2.4.6 1.2.5 2 2.4 0 1.2-2.6-.5-2.9 0-.1 0-.3-.1-.4 0-.6-.7-2.2-2.9-2.2-1.9 0-2.3 1.4-2.4 2.2-.1.2-.1.4-.1.6-2.7.4-2.4 2.8-.8 2.8zm2.2-3.4s.2.1.2.8c.4.1 1.2-1.2 1.2-1.2v1c.5.1 1.9 0 1.9 0h.1v.1c0 1.1-.9 1.9-2.1 1.9-1.1 0-2-.8-2.1-1.9.5 0 .8-.7.8-.7zm1.9 3.6h-2.2l-3 3.3-2.9-3.3H4L.6 11.8l.7.7 2.4-1.9v3.8h.5v2.9h-.3v.2h1.6v-3.2H6v3.2h1.4v-.3H7v-2.9h.6v-3.7l2 1.9.8-.2.4.1L13 10l.1.9-2.1 3.3h2.4v2.9h-.3v.4h1.4v-3.2h.5v3.2h1.4v-.3h-.3v-2.9H18L16.2 11l.1-1.2 2.2 2.7 1-1-2.9-3.2h-1.2z" })));


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var styles = __webpack_require__(12);
exports.polyclinicsIcon = (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", className: styles['icon'], viewBox: "0 0 20 20", width: "20", height: "20" },
    React.createElement("path", { fill: "currentColor", d: "M19 7h-6V1H7v6H1v6h6v6h6v-6h6V7z" })));


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable:max-line-length */
var React = __webpack_require__(0);
var styles = __webpack_require__(12);
exports.schoolIcon = (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", className: styles['icon'], viewBox: "0 0 20 20", width: "20", height: "20" },
    React.createElement("path", { fill: "currentColor", d: "M18.9 4.4h-.2l-1.7 1v9.1s-.2.2-.3.2h-.3c-1.5 0-4.2.2-6 1.2l-.4.2-.3-.1c-1.8-1-4.5-1.2-6-1.2h-.4l-.2-.2V5.5l-1.8-1H1V16c0 .1 0 .1.1.1 0 0 .1.1.1 0 .5-.1 1.4-.1 2.4-.1 2.1 0 3.8.3 4.9.9.2.1 1.1.6 1.5.6s1.4-.5 1.5-.6c1.1-.6 2.8-.9 4.9-.9 1 0 1.8.1 2.4.1h.1l.1-.1V4.6c0-.1 0-.2-.1-.2zm-7.7 10.2h.2c1.2-.5 2.8-.8 4.6-.9.1 0 .2-.1.2-.2V2.6c0-.1 0-.1-.1-.1h-.2l-4.7 2c-.1 0-.1.1-.1.2v9.7c0 .1 0 .1.1.2zm-7-1c1.8 0 3.4.3 4.6.9H9l.1-.1V4.7c0-.1 0-.1-.1-.2l-4.7-2h-.2l-.1.1v10.9c.1 0 .2.1.2.1z" })));


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
exports.compassIcon = (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "8", height: "19", viewBox: "0 0 8 19" },
    React.createElement("g", { fill: "none", fillRule: "evenodd" },
        React.createElement("path", { fill: "#7A7A7A", d: "M4 0l4 9H0z" }),
        React.createElement("path", { fill: "#E4E4E4", d: "M4 19l4-9H0z" }))));


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable:max-line-length */
var React = __webpack_require__(0);
exports.panoramaIcon = (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 23.27 15.41", width: "24", height: "16" },
    React.createElement("path", { fill: "currentColor", d: "M15.94 8.93h1.76c.083.01.167.01.25 0 .638-.19 1.07-.785 1.05-1.45v-6c.013-.11.013-.22 0-.33C18.878.5 18.32.022 17.66 0H16c-.288-.005-.57.086-.8.26-.374.283-.587.73-.57 1.2v6c-.01.247.046.49.16.71.212.448.655.74 1.15.76zm1.6-7.49v6.04c-.482.045-.968.045-1.45 0v-6l-.02-.04h1.47zm-4.75 11.03l-1-.86-1.58-1.43c-.066-.044-.136-.08-.21-.11v1.67h-.54c-.69-.034-1.378-.108-2.06-.22h-.25c-.35-.06-.72-.11-1-.17s-.56-.15-.84-.21c-.61-.145-1.21-.34-1.79-.58-.43-.167-.84-.375-1.23-.62-.412-.24-.773-.56-1.06-.94-.19-.246-.303-.54-.33-.85-.022-.448.14-.885.45-1.21.475-.52 1.06-.93 1.71-1.2l.547-.26c-.016-.073-.06-.09-.117-.09l-.31.13c-.644.254-1.252.59-1.81 1-.492.358-.893.828-1.17 1.37-.2.416-.27.883-.2 1.34.02.056.047.11.08.16.03.065.057.132.08.2.056.238.18.454.36.62.045.046.085.096.12.15.052.083.108.164.17.24.595.594 1.297 1.07 2.07 1.4.39.2.89.39 1.18.5s.47.17.88.29.88.23 1.23.31c.35.08.65.15 1.06.22.41.07.77.1 1.25.13.49.078.984.12 1.48.12h.1c.004.077.004.153 0 .23v1.55c.073-.034.144-.074.21-.12l.54-.49 1.49-1.34.58-.53c.026-.016.048-.037.063-.064.05-.086.022-.196-.063-.246l-.09-.09zm1.22-7.22c.008-.226-.033-.45-.12-.66-.218-.538-.75-.882-1.33-.86h-1.17l.75-1.82c.24-.6.51-1.19.74-1.83-.066-.037-.136-.064-.21-.08H11.5c-.106.007-.197.078-.23.18l-.77 1.88c-.19.46-.37.92-.56 1.38-.223.51-.34 1.062-.34 1.62v2.29c.003.22.04.44.11.65.19.512.656.87 1.2.92h1.8c.214-.007.42-.073.6-.19.45-.265.72-.757.7-1.28v-2.2zm-1.49 2.23c-.49.044-.98.044-1.47 0V5.2h1.47v2.28z" }),
    React.createElement("path", { fill: "currentColor", d: "M4.7 2.24h1.22c.102-.068.157-.188.14-.31v-.37h1.45c.054.76.054 1.52 0 2.28H6.39c-.114-.02-.23.03-.29.13-.054.418-.054.842 0 1.26.09.008.18.008.27 0h1.16V7.5H6.06c-.002-.017-.002-.033 0-.05V7.1c.007-.033.008-.067.002-.1-.026-.14-.16-.235-.302-.21h-.84c-.025-.004-.05-.003-.076 0-.13.025-.217.15-.194.28v.74c.093.65.626 1.145 1.28 1.19h1.59c.222-.007.44-.06.64-.16.496-.222.822-.707.84-1.25V5.28c-.014-.098-.044-.193-.09-.28-.095-.244-.292-.435-.54-.52l.11-.05c.342-.142.553-.49.52-.86V1.44C9.012.678 8.42.043 7.66 0H5.94c-.507.016-.96.318-1.17.78-.16.386-.21.807-.15 1.22.008.085.035.167.08.24zM23 7.71c-.272-.457-.632-.854-1.06-1.17-.533-.394-1.106-.73-1.71-1-.134-.06-.27-.114-.41-.16-.013-.005-.027-.01-.04-.01-.073-.005-.135.048-.14.12l.24.13c.382.155.75.343 1.1.56.443.25.828.59 1.13 1 .377.526.377 1.234 0 1.76-.295.408-.673.75-1.11 1-.458.283-.948.51-1.46.68-.46.16-.96.34-1.4.47s-.89.2-1.34.3c-.66.14-1.328.243-2 .31l-.69.076c-.08.077-.126.183-.12.294 0 .39-.01.91 0 1.16s.07.3.31.3h.23c.44-.06.78-.1 1.34-.19s1.08-.19 1.56-.29.95-.24 1.41-.39c.525-.172 1.04-.376 1.54-.61.737-.332 1.413-.785 2-1.34.406-.376.7-.857.85-1.39.135-.546.052-1.123-.23-1.61zm-1.61-4.94c.546-.255.88-.82.84-1.42h-.02c-.008-.22-.08-.432-.21-.61-.276-.47-.785-.753-1.33-.74-.703.027-1.298.53-1.44 1.22-.07.406.04.82.3 1.14.453.546 1.22.715 1.86.41zM20.73 1c.252.014.456.21.48.46l-.01.05c.01.267-.193.494-.46.51-.276-.005-.5-.224-.51-.5.014-.274.227-.495.5-.52z" })));


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable:max-line-length */
var React = __webpack_require__(0);
exports.noPanoramaIcon = (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "90", height: "66" },
    React.createElement("g", { fill: "none", fillRule: "evenodd" },
        React.createElement("path", { fill: "#203749", d: "M3.385 43.686l18.73-13.884 23.332 20.05c.67.576 1.65.544 2.283-.072l11.21-10.92 11.24 8.817c.61.477 1.464.48 2.08.007l14.352-11.1V61.39c-2.67-.448-7.776-1.275-13.818-2.105-11.837-1.625-21.19-2.45-27.795-2.45-6.62 0-15.97.826-27.8 2.45-6.05.83-11.15 1.657-13.82 2.105V43.686zm56.048-8.64c-.185-.072-.375-.11-.563-.117h-.068c-.2 0-.39.03-.568.1l-.063.03c-.18.07-.35.18-.47.3L46.48 46.27 23.296 26.35c-.318-.274-.71-.413-1.102-.413-.353 0-.707.112-1.01.336L3.384 39.47V3.7c2.706.452 7.857 1.285 13.82 2.103C29.04 7.428 38.39 8.253 45 8.253c6.617 0 15.97-.825 27.794-2.45 6.047-.83 11.15-1.657 13.82-2.105v28.606L71.232 44.2l-11.368-8.915c-.103-.08-.217-.148-.373-.217l-.06-.023zM89.393.396c-.385-.323-.886-.456-1.382-.37V.03l-.04.006c-.12.022-.52.092-1.16.2-2.68.454-9.78 1.624-17.86 2.67C62.01 3.8 52.23 4.87 45.02 4.87h-.03c-8.05 0-19.296-1.315-27.315-2.42-3.61-.493-7.363-1.054-11.16-1.666C5.103.556 3.97.367 3.19.234L1.988.024C1.493-.06.99.074.605.397.22.717 0 1.187 0 1.69v61.704c0 .5.22.973.604 1.296.31.26.697.398 1.072.398.09 0 .18-.008.268-.025l.073-.008c.11-.02.513-.09 1.173-.203 2.676-.454 9.774-1.623 17.864-2.67 6.94-.897 16.723-1.966 23.934-1.966h.03c8.05 0 19.295 1.315 27.314 2.42 4.592.63 8.6 1.254 11.154 1.667 1.41.227 2.54.416 3.32.55.665.112 1.07.183 1.203.207.49.086.99-.048 1.38-.37.38-.323.6-.795.6-1.296V1.692c0-.503-.22-.975-.61-1.297z" }),
        React.createElement("path", { fill: "#EC5F6F", d: "M66.482 23.956c0-1.156.452-2.246 1.27-3.067.82-.82 1.91-1.27 3.068-1.28 1.157 0 2.247.45 3.067 1.27.82.82 1.27 1.91 1.27 3.07 0 1.152-.45 2.242-1.27 3.062-.82.82-1.91 1.27-3.067 1.27-1.158 0-2.247-.45-3.067-1.27-.82-.82-1.27-1.91-1.27-3.067m4.338 7.723c4.26 0 7.73-3.465 7.73-7.72s-3.46-7.72-7.72-7.72c-4.253 0-7.72 3.464-7.72 7.72s3.466 7.72 7.72 7.723" }))));


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var utils_1 = __webpack_require__(1);
var tracking_1 = __webpack_require__(7);
var icons_1 = __webpack_require__(13);
var styles = __webpack_require__(65);
var MVKMapInfrastructure = /** @class */ (function (_super) {
    __extends(MVKMapInfrastructure, _super);
    function MVKMapInfrastructure() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isCollapsed: true,
        };
        _this.handleCollapseButtonClick = function () {
            var isCollapsed = _this.state.isCollapsed;
            if (isCollapsed) {
                tracking_1.trackInfrastructureShow(_this.props.isOfferCard);
            }
            _this.setState({
                isCollapsed: !isCollapsed,
            });
        };
        return _this;
    }
    MVKMapInfrastructure.prototype.render = function () {
        var selected = this.props.selected;
        var isCollapsed = this.state.isCollapsed;
        return (React.createElement("div", __assign({}, utils_1.mergeStyles(styles['container'], isCollapsed && styles['container--collapsed'])),
            React.createElement("div", { className: styles['header'] },
                "\u0418\u043D\u0444\u0440\u0430\u0441\u0442\u0440\u0443\u043A\u0442\u0443\u0440\u0430",
                React.createElement("button", { className: styles['button-toggle'], onClick: this.handleCollapseButtonClick }, icons_1.infrastructureIcon)),
            React.createElement("ul", { className: styles['list'] },
                this.createItem(0 /* Schools */, icons_1.schoolIcon, 'Школы', selected.includes(0 /* Schools */)),
                this.createItem(1 /* Kindergarden */, icons_1.kindergardenIcon, 'Детские сады', selected.includes(1 /* Kindergarden */)),
                this.createItem(2 /* Polyclinics */, icons_1.polyclinicsIcon, 'Поликлиники', selected.includes(2 /* Polyclinics */)),
                this.createItem(3 /* GroceryStores */, icons_1.groceryStoresIcon, 'Продукт. магазины', selected.includes(3 /* GroceryStores */)),
                this.createItem(4 /* Cafes */, icons_1.cafeIcon, 'Кафе', selected.includes(4 /* Cafes */)))));
    };
    MVKMapInfrastructure.prototype.createItem = function (infrastructureType, icon, title, isActive) {
        var _this = this;
        return (React.createElement("li", null,
            React.createElement("a", __assign({}, utils_1.mergeStyles(styles['item'], isActive && styles['item--active']), { onClick: function () { return _this.props.onSelect(infrastructureType); } }),
                React.createElement("span", null,
                    icon,
                    title),
                React.createElement("span", __assign({}, utils_1.mergeStyles(styles['checkbox'], isActive && styles['checkbox--active'])), isActive && icons_1.checkedCheckboxIcon))));
    };
    return MVKMapInfrastructure;
}(React.Component));
exports.MVKMapInfrastructure = MVKMapInfrastructure;


/***/ }),
/* 65 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"mvk_widget-container-lwtTLxPxQcg","container--collapsed":"mvk_widget-container--collapsed-dXBUKy6oBU0","button-toggle":"mvk_widget-button-toggle-gIkXBDHz5Ci","header":"mvk_widget-header-7rc5VKIizKo","list":"mvk_widget-list-b0SCRUk7EkU","item":"mvk_widget-item-fYtLHoM0j6C","item--active":"mvk_widget-item--active-bl9adssges0","checkbox":"mvk_widget-checkbox-4j5FI2XTEI4","checkbox--active":"mvk_widget-checkbox--active-hO6gMzDMPKy"};

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var button_component_1 = __webpack_require__(15);
var icons_1 = __webpack_require__(13);
var styles = __webpack_require__(67);
exports.NoPanorama = function (_a) {
    var onClick = _a.onClick;
    return (React.createElement("div", { className: styles['container'] },
        icons_1.noPanoramaIcon,
        React.createElement("div", { className: styles['title'] }, "\u041F\u0430\u043D\u043E\u0440\u0430\u043C\u044B \u043E\u0442\u0441\u0443\u0442\u0441\u0442\u0432\u0443\u044E\u0442"),
        React.createElement("div", { className: styles['text'] },
            "\u041A \u0441\u043E\u0436\u0430\u043B\u0435\u043D\u0438\u044E, \u043F\u0430\u043D\u043E\u0440\u0430\u043C\u044B \u0443\u043B\u0438\u0446 \u0434\u043B\u044F \u044D\u0442\u043E\u0439 \u043E\u0431\u043B\u0430\u0441\u0442\u0438 \u043A\u0430\u0440\u0442\u044B",
            React.createElement("br", null),
            "\u043F\u043E\u043A\u0430 \u0447\u0442\u043E \u043E\u0442\u0441\u0443\u0442\u0441\u0442\u0432\u0443\u044E\u0442"),
        React.createElement(button_component_1.Button, { onClick: onClick, theme: button_component_1.ButtonTheme.Default, size: button_component_1.ButtonSize.S }, "\u041F\u0435\u0440\u0435\u0439\u0442\u0438 \u043D\u0430 \u043A\u0430\u0440\u0442\u0443")));
};


/***/ }),
/* 67 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"mvk_widget-container-8vjLdp0nbaO","title":"mvk_widget-title-ezlxZEIxDGQ","text":"mvk_widget-text-bSDgOuHRcsE"};

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var icons_1 = __webpack_require__(13);
var styles = __webpack_require__(69);
exports.PanoramaControl = function (_a) {
    var onClick = _a.onClick;
    return (React.createElement("div", { className: styles['container'], onClick: onClick }, icons_1.panoramaIcon));
};


/***/ }),
/* 69 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"mvk_widget-container-6sDuKX5viMI"};

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var utils_1 = __webpack_require__(1);
var ruler_1 = __webpack_require__(25);
var styles = __webpack_require__(71);
exports.RulerControl = function (_a) {
    var onToggle = _a.onToggle, isActive = _a.isActive;
    return (React.createElement("div", __assign({}, utils_1.mergeStyles(styles['container'], isActive && styles['active']), { onClick: onToggle }), ruler_1.rulerIcon));
};


/***/ }),
/* 71 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"mvk_widget-container-iqT4ci5RXG4","active":"mvk_widget-active-1eHcNsZEAaQ"};

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var utils_1 = __webpack_require__(1);
var minus_1 = __webpack_require__(23);
var plus_1 = __webpack_require__(24);
var styles = __webpack_require__(73);
exports.ZoomControls = function (_a) {
    var onZoomIn = _a.onZoomIn, onZoomOut = _a.onZoomOut, zoomInDisabled = _a.zoomInDisabled;
    return (React.createElement("div", { className: styles['container'] },
        React.createElement("div", __assign({}, utils_1.mergeStyles(styles['zoom-in'], zoomInDisabled && styles['disabled']), { onClick: function () { return !zoomInDisabled && onZoomIn(); } }), plus_1.plusIcon),
        React.createElement("div", { className: styles['zoom-out'], onClick: onZoomOut }, minus_1.minusIcon)));
};


/***/ }),
/* 73 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"mvk_widget-container-jUPX4GDLy0M","zoom-in":"mvk_widget-zoom-in-hfa7SKGVAOM","zoom-out":"mvk_widget-zoom-out-4MHYu9v22A0","disabled":"mvk_widget-disabled-4Rz6Sx0l4Ic"};

/***/ }),
/* 74 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"mvk_widget-container-3W0vj3vq7us","map":"mvk_widget-map-8fbygEMX0Ag","compass":"mvk_widget-compass-5PCuzwkSVai","compass-text":"mvk_widget-compass-text-eQm6Fv2ipGs"};

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var react_redux_1 = __webpack_require__(3);
var flat_phase_1 = __webpack_require__(76);
function mapStateToProps(state) {
    var MVKData = state.MVKData, _a = state.MVKState, phase = _a.phase, flat = _a.flat;
    return {
        currentPhase: phase,
        flat: MVKData.offers.find(function (offer) { return offer.id === flat.id; }),
    };
}
exports.FlatPhaseContainer = react_redux_1.connect(mapStateToProps)(flat_phase_1.FlatPhase);


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var flat_info_1 = __webpack_require__(77);
var mvk_state_1 = __webpack_require__(2);
var flat_gallery_1 = __webpack_require__(88);
var styles = __webpack_require__(98);
var FlatPhase = /** @class */ (function (_super) {
    __extends(FlatPhase, _super);
    function FlatPhase() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FlatPhase.prototype.render = function () {
        var _a = this.props, flat = _a.flat, currentPhase = _a.currentPhase;
        if (!flat || currentPhase !== mvk_state_1.MVKPhase.FLAT) {
            return null;
        }
        return (React.createElement("div", { className: styles['container'] },
            React.createElement(flat_gallery_1.FlatGallery, { flat: flat }),
            React.createElement(flat_info_1.FlatInfoContainer, null)));
    };
    return FlatPhase;
}(React.Component));
exports.FlatPhase = FlatPhase;


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var react_redux_1 = __webpack_require__(3);
var flat_info_1 = __webpack_require__(78);
var helpers_1 = __webpack_require__(11);
var polygon_1 = __webpack_require__(8);
var mvk_data_1 = __webpack_require__(9);
var flats_1 = __webpack_require__(5);
var STATIC_MAP_IMAGE_SIZE = [160, 120];
function mapStateToProps(state) {
    var MVKData = state.MVKData, _a = state.MVKState, flat = _a.flat, isOfferCard = _a.isOfferCard;
    var currentFlat = MVKData.offers.find(function (offer) { return offer.id === flat.id; });
    var floor = currentFlat && currentFlat.floor;
    var selectedHouse = currentFlat && mvk_data_1.getMVKHouseById(MVKData, currentFlat.houseId);
    var selectedSection = currentFlat && selectedHouse &&
        selectedHouse.sections.find(function (section) { return section.number === currentFlat.sectionNumber; });
    var floorScheme = selectedSection && floor && selectedSection.floorPlans.find(function (floorPlan) { return (floorPlan.floors.includes(floor)); });
    var flatPolygons = currentFlat && floorScheme && selectedSection && helpers_1.getColoredPolygons(floorScheme.floorPlanFlats, flats_1.getFlatsInSectionFloor(MVKData, currentFlat.houseId, selectedSection.id, floor), undefined, currentFlat.flatNumber);
    return {
        builder: MVKData.builder,
        flat: currentFlat,
        floorFlatPolygons: flatPolygons || undefined,
        mapImageUrl: polygon_1.createStaticMapImageUrlOfferPhase(STATIC_MAP_IMAGE_SIZE, selectedHouse, selectedSection),
        isOfferCard: isOfferCard,
    };
}
exports.FlatInfoContainer = react_redux_1.connect(mapStateToProps)(flat_info_1.FlatInfo);


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var utils_1 = __webpack_require__(1);
var phone_button_1 = __webpack_require__(26);
var favorite_button_1 = __webpack_require__(27);
var polygon_1 = __webpack_require__(8);
var polygons_drawer_1 = __webpack_require__(16);
var styles = __webpack_require__(87);
var CANVAS_SIZE = [150, 110];
var FlatInfo = /** @class */ (function (_super) {
    __extends(FlatInfo, _super);
    function FlatInfo() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getDrawParams = function () {
            var floorFlatPolygons = _this.props.floorFlatPolygons;
            var points = floorFlatPolygons
                ? floorFlatPolygons.map(function (polygon) { return polygon.points; })
                : undefined;
            return polygon_1.getFloorPlanPolygonParams(CANVAS_SIZE, points);
        };
        _this.getPhone = function () {
            var _a = _this.props, flat = _a.flat, builder = _a.builder;
            try {
                return flat && flat.phone
                    ? flat.phone.countryCode + flat.phone.number
                    : builder.phone.countryCode + builder.phone.code + builder.phone.number;
            }
            catch (e) {
                return '';
            }
        };
        return _this;
    }
    FlatInfo.prototype.render = function () {
        var _a = this.props, flat = _a.flat, builder = _a.builder, floorFlatPolygons = _a.floorFlatPolygons, mapImageUrl = _a.mapImageUrl, isOfferCard = _a.isOfferCard;
        if (!flat) {
            return null;
        }
        var phone = this.getPhone();
        return (React.createElement("div", { id: "newbuilding_mvk_fragment-flat_info", className: styles['container'] },
            React.createElement("div", null,
                React.createElement("a", { target: "_blank", href: flat.url, className: styles['link'] },
                    flat.roomsTitle,
                    " ",
                    flat.area,
                    " \u043C",
                    React.createElement("sup", null, "2"),
                    " \u0437\u0430 ",
                    utils_1.numberToPrettyString(flat.price),
                    " \u20BD"),
                React.createElement("div", { className: styles['floor'] },
                    flat.floor,
                    " \u044D\u0442\u0430\u0436"),
                React.createElement("div", { className: styles['builder-name'] }, builder.name),
                React.createElement("div", { className: styles['buttons'] },
                    phone &&
                        React.createElement(phone_button_1.PhoneButton, { phone: phone, containerStyle: styles['phone-button'], analyticsData: flat.analyticsData, isOfferCard: isOfferCard }),
                    React.createElement(favorite_button_1.FavoriteButtonContainer, { offerId: flat.id, isActive: flat.isFavorite }))),
            React.createElement("div", { className: styles['images'] },
                floorFlatPolygons && floorFlatPolygons.length &&
                    React.createElement(polygons_drawer_1.PolygonsDrawer, { isSidebar: true, container: null, containerStyle: styles['floor-image'], polygons: floorFlatPolygons, defaultColor: "#e4e4e4", width: CANVAS_SIZE[0], height: CANVAS_SIZE[1], backgroundDrawingAlgorythm: this.getDrawParams }),
                mapImageUrl && React.createElement("div", { style: { backgroundImage: "url(" + mapImageUrl + ")" }, className: styles['map-image'] }))));
    };
    return FlatInfo;
}(React.Component));
exports.FlatInfo = FlatInfo;


/***/ }),
/* 79 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"mvk_widget-container-k6sMX8wJK8K","phone":"mvk_widget-phone-gNCnyUqnwOk"};

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var event_bus_1 = __webpack_require__(17);
var favorite_1 = __webpack_require__(81);
var tracking_1 = __webpack_require__(7);
function toggleFavoriteAction(offerId) {
    return function (dispatch, getState, _a) {
        var httpApi = _a.httpApi, logger = _a.logger;
        var MVKData = getState().MVKData;
        var currentOffer = MVKData.offers.find(function (offer) { return offer.id === offerId; });
        if (!currentOffer) {
            return;
        }
        // обновление счетчика в хедере
        var updateHeaderFavoritesCount = function (state) {
            if (window.__header_updateFavorites__) { // для микросервисов
                window.__header_updateFavorites__(state);
            }
            else if (window.__updateHeaderFavoritesCount) { // для монолита
                window.__updateHeaderFavoritesCount(state);
            }
        };
        var setFavorite = function (isFavorite) {
            dispatch(setFavoriteAction(currentOffer.id, isFavorite));
            updateHeaderFavoritesCount(isFavorite);
        };
        setFavorite(!currentOffer.isFavorite);
        var customUrl = currentOffer.analyticsData ? currentOffer.analyticsData.customUrl : '';
        tracking_1.trackFlatFavoriteButtonClick(!currentOffer.isFavorite, customUrl);
        var parsedOfferUrl = currentOffer.url.split('/');
        if (parsedOfferUrl.length < 4) {
            return;
        }
        var changeFavoriteParams = {
            action: !currentOffer.isFavorite ? 'assign' : 'remove',
            dealType: parsedOfferUrl[1],
            offerType: parsedOfferUrl[2],
            oid: String(currentOffer.id),
        };
        favorite_1.changeFavorite(httpApi, changeFavoriteParams, logger)
            .then(function (res) {
            // если был добавлен ЖК, обновляем счетчик в хедере и посылаем событие о добавлении ЖК
            if (res.newbuilding_id) {
                updateHeaderFavoritesCount(true);
                var eventBus = event_bus_1.getEventBusIfDefined();
                if (eventBus) {
                    eventBus.emit('newbuilding_added_to_favorite', {
                        type: String(res.newbuilding_id),
                    });
                }
            }
        })
            .catch(function () {
            setFavorite(currentOffer.isFavorite);
        });
    };
}
exports.toggleFavoriteAction = toggleFavoriteAction;
function setFavoriteAction(offerId, isFavorite) {
    return {
        isFavorite: isFavorite,
        offerId: offerId,
        type: 'ISetFavoriteAction',
    };
}
exports.setFavoriteAction = setFavoriteAction;


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var favorites_1 = __webpack_require__(82);
function changeFavorite(httpApi, params, logger) {
    return __awaiter(this, void 0, void 0, function () {
        var requestParams, _a, response, statusCode, error_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    requestParams = favorites_1.createFavoritesModel(params.dealType, params.offerType, {
                        parameters: {
                            action: params.action,
                            oid: params.oid,
                        },
                    });
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, httpApi.fetch(requestParams, {
                            bodyAsEncodeString: true,
                            requestConfig: {
                                headers: [['Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8']],
                            },
                        })];
                case 2:
                    _a = _b.sent(), response = _a.response, statusCode = _a.statusCode;
                    if (statusCode !== 200 || 'errors' in response) {
                        throw response;
                    }
                    return [2 /*return*/, response];
                case 3:
                    error_1 = _b.sent();
                    if (logger) {
                        logger.error(error_1, {
                            message: 'Error in change-favorite',
                        });
                    }
                    throw error_1;
                case 4: return [2 /*return*/];
            }
        });
    });
}
exports.changeFavorite = changeFavorite;


/***/ }),
/* 82 */
/***/ (function(module, exports) {

module.exports = require("@cian/api-models/monolith-python/ajax/favorites");

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var button_component_1 = __webpack_require__(15);
var heart_icon_1 = __webpack_require__(84);
var styles = __webpack_require__(28);
var FavoriteButton = /** @class */ (function (_super) {
    __extends(FavoriteButton, _super);
    function FavoriteButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FavoriteButton.prototype.render = function () {
        var _a = this.props, isActive = _a.isActive, toggleFavorite = _a.toggleFavorite, offerId = _a.offerId, textClassName = _a.textClassName;
        return (React.createElement("div", { className: styles['container'] },
            React.createElement(button_component_1.Button, { className: styles['button'], theme: button_component_1.ButtonTheme.Ghost, onClick: function () { return toggleFavorite(offerId); }, textClassName: textClassName },
                React.createElement(heart_icon_1.HeartIcon, { isActive: isActive }),
                isActive ? 'В избранном' : 'В избранное')));
    };
    return FavoriteButton;
}(React.Component));
exports.FavoriteButton = FavoriteButton;


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// tslint:disable:max-line-length
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var utils_1 = __webpack_require__(1);
var styles = __webpack_require__(28);
exports.HeartIcon = function (_a) {
    var isActive = _a.isActive;
    return (React.createElement("svg", __assign({}, utils_1.mergeStyles(styles['icon'], isActive && styles['icon--active']), { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 14.004 14", width: "14", height: "14" }),
        React.createElement("path", { stroke: "#E84260", strokeWidth: "2", d: "M6.99 11.72L1.825 6.677C.727 5.582.725 3.805 1.82 2.707l.015-.015c1.118-1.08 2.962-1.08 4.092.014l.36.35.67.648.694-.62.394-.35.03-.028c1.13-1.095 2.973-1.095 4.104 0 1.1 1.093 1.103 2.87.01 3.968l-.015.015-5.182 5.03z" })));
};


/***/ }),
/* 85 */
/***/ (function(module, exports) {

module.exports = require("@cian/preloader-component");

/***/ }),
/* 86 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"hidden":"mvk_widget-hidden-irUTQpD5aEk","container":"mvk_widget-container-uC3zBXxpDw","tooltip":"mvk_widget-tooltip-kanK4NJhQsw","preloader-container":"mvk_widget-preloader-container-lLirTt6OwSw"};

/***/ }),
/* 87 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"mvk_widget-container-fg4fgGYqU8C","link":"mvk_widget-link-dMuYliRxqoW","floor":"mvk_widget-floor-cerQ9x1qbCE","builder-name":"mvk_widget-builder-name-fI1Ex9U4CcS","buttons":"mvk_widget-buttons-kUvNHVjlG8e","phone-button":"mvk_widget-phone-button-1YjSdKgK4Qa","images":"mvk_widget-images-c5gXJXQpCoe","floor-image":"mvk_widget-floor-image-76basm5lfyI","map-image":"mvk_widget-map-image-jP5VgakmGsQ"};

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var fotorama_1 = __webpack_require__(89);
var styles = __webpack_require__(97);
exports.FlatGallery = function (_a) {
    var flat = _a.flat;
    return (React.createElement("div", { className: styles['container'], id: "photos" },
        React.createElement(fotorama_1.FotoramaContainer, { flat: flat })));
};


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var react_redux_1 = __webpack_require__(3);
var fotorama_1 = __webpack_require__(90);
exports.FotoramaContainer = react_redux_1.connect(function (state) { return ({
    builder: state.MVKData.builder,
    isMVKFullScreen: state.MVKState.isFullScreen,
    isOfferCard: state.MVKState.isOfferCard,
}); })(fotorama_1.Fotorama);


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var utils_1 = __webpack_require__(1);
var full_screen_controls_1 = __webpack_require__(91);
var icon_no_photo_1 = __webpack_require__(95);
var styles = __webpack_require__(96);
var START_SHOWED_ELEMENT = 0;
var createFotoramaData = function (_a) {
    var photos = _a.photos;
    return (photos || []).map(function (photo) { return ({
        img: photo.fullUrl,
        thumb: photo.thumbnailUrl,
    }); });
};
var Fotorama = /** @class */ (function (_super) {
    __extends(Fotorama, _super);
    function Fotorama(props) {
        var _this = _super.call(this, props) || this;
        _this.fotoramaRef = null;
        _this.fragmentContainer = null;
        _this.flatInfoContainer = null;
        // переопределение стилей галлереи в карточке ЖК для полноэкранного режима
        _this.onFullScreenEnter = function () {
            document.body.className += ' mvk_fotorama_fullscreen';
            _this.setState({ isFullScreen: true });
            _this.handleFotoramaResize();
        };
        _this.onFullScreenExit = function () {
            document.body.className = document.body.className.replace('mvk_fotorama_fullscreen', '');
            _this.fotorama.cancelFullScreen();
            _this.setState({ isFullScreen: false });
            _this.handleFotoramaResize();
        };
        _this.handleFotoramaResize = function () {
            if (_this.fotorama) {
                _this.fotorama.setOptions({
                    ratio: _this.getFotoramaRatio(),
                });
            }
        };
        _this.getFotoramaRatio = function () {
            if (!_this.fotoramaRef || !_this.flatInfoContainer || !_this.fragmentContainer) {
                return 1;
            }
            var isMVKFullScreen = _this.props.isMVKFullScreen;
            var flatInfoHeight = _this.flatInfoContainer.clientHeight;
            // Расчет высоты для фоторамы
            var clientHeight = isMVKFullScreen
                ? window.innerHeight - 240
                : _this.fragmentContainer.clientHeight - Math.max(130, flatInfoHeight) - 100;
            return _this.fotoramaRef.clientWidth / clientHeight;
        };
        _this.state = { isFullScreen: false };
        return _this;
    }
    Fotorama.prototype.componentDidMount = function () {
        if (window.$ && this.fotoramaRef) {
            this.initFotorama(this.props.flat);
        }
        this.fragmentContainer = document.getElementById('newbuilding_mvk_fragment-main_block');
        this.flatInfoContainer = document.getElementById('newbuilding_mvk_fragment-flat_info');
        window.addEventListener('resize', this.handleFotoramaResize);
    };
    Fotorama.prototype.componentWillReceiveProps = function (nextProps) {
        if (this.props.flat.id !== nextProps.flat.id) {
            if (this.fotorama) {
                this.fotorama.load(createFotoramaData(nextProps.flat));
                this.fotorama.show(START_SHOWED_ELEMENT);
            }
            else if (window.$ && this.fotoramaRef) {
                this.initFotorama(nextProps.flat);
            }
        }
    };
    Fotorama.prototype.componentWillUnmount = function () {
        if (this.$fotorama) {
            this.$fotorama.unbind();
        }
        window.removeEventListener('resize', this.handleFotoramaResize);
    };
    Fotorama.prototype.render = function () {
        var _this = this;
        var _a = this.props, flat = _a.flat, builder = _a.builder, isOfferCard = _a.isOfferCard;
        var withItems = (flat.photos || []).length > 0;
        return (React.createElement("div", { className: styles['fotorama_container'] },
            this.state.isFullScreen &&
                React.createElement(full_screen_controls_1.FullScreenControls, { flat: flat, exitFullscreen: this.onFullScreenExit, builder: builder, isOfferCard: isOfferCard }),
            React.createElement("div", __assign({}, utils_1.mergeStyles(!withItems && styles['hidden'])),
                React.createElement("div", __assign({}, utils_1.mergeStyles(styles['fotorama'], 'mvk_fotorama'), { "data-width": "100%", "data-nav": "thumbs", "data-fit": "contain", "data-keyboard": "true", "data-loop": "false", "data-thumbwidth": "85", "data-thumbheight": "60", "data-arrows": "true", "data-swipe": "false", "data-thumbmargin": "4", "data-auto": "false", "data-allowfullscreen": "true", ref: function (fotorama) { return _this.fotoramaRef = fotorama; } }))),
            !withItems && React.createElement("div", { className: styles['default_content'] }, icon_no_photo_1.iconNoPhoto)));
    };
    Fotorama.prototype.initFotorama = function (flat) {
        this.$fotorama = window.$(this.fotoramaRef).fotorama({
            data: createFotoramaData(flat),
            minheight: '200',
            ratio: this.getFotoramaRatio(),
            startindex: START_SHOWED_ELEMENT,
        });
        this.fotorama = this.$fotorama.data('fotorama');
        this.$fotorama.on('fotorama:fullscreenenter', this.onFullScreenEnter);
        this.$fotorama.on('fotorama:fullscreenexit', this.onFullScreenExit);
        // Выставление корректного ратио фоторамы после инициализации плагина
        setTimeout(this.handleFotoramaResize, 0);
    };
    return Fotorama;
}(React.Component));
exports.Fotorama = Fotorama;


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var number_helpers_1 = __webpack_require__(92);
var favorite_button_1 = __webpack_require__(27);
var phone_button_1 = __webpack_require__(26);
var icon_close_white_1 = __webpack_require__(93);
var styles = __webpack_require__(94);
var FullScreenControls = /** @class */ (function (_super) {
    __extends(FullScreenControls, _super);
    function FullScreenControls() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            showPhones: false,
        };
        _this.getPhone = function () {
            var _a = _this.props, flat = _a.flat, builder = _a.builder;
            try {
                return flat && flat.phone
                    ? flat.phone.countryCode + flat.phone.number
                    : builder.phone.countryCode + builder.phone.code + builder.phone.number;
            }
            catch (e) {
                return '';
            }
        };
        return _this;
    }
    FullScreenControls.prototype.render = function () {
        var _a = this.props, flat = _a.flat, exitFullscreen = _a.exitFullscreen, isOfferCard = _a.isOfferCard;
        var phone = this.getPhone();
        return (React.createElement("div", { className: styles['container'] },
            React.createElement("div", { className: styles['title'] },
                flat.roomsTitle,
                ", ",
                flat.area,
                " \u043C",
                React.createElement("sup", null, "2"),
                ", ",
                number_helpers_1.numberToPrettyString(flat.price),
                " \u20BD"),
            React.createElement("div", { className: styles['buttons'] },
                phone &&
                    React.createElement(phone_button_1.PhoneButton, { phone: phone, containerStyle: styles['phone-button'], phoneStyle: styles['phone-text'], analyticsData: flat.analyticsData, isOfferCard: isOfferCard, hidePhoneOnButton: true }),
                React.createElement(favorite_button_1.FavoriteButtonContainer, { offerId: flat.id, isActive: flat.isFavorite, textClassName: styles['favorite-text'] }),
                React.createElement("div", { className: styles['close'], onClick: exitFullscreen }, icon_close_white_1.iconCloseWhite))));
    };
    return FullScreenControls;
}(React.Component));
exports.FullScreenControls = FullScreenControls;


/***/ }),
/* 92 */
/***/ (function(module, exports) {

module.exports = require("@cian/utils/lib/shared/number_helpers");

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
exports.iconCloseWhite = (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "14", height: "14", viewBox: "0 0 14 14" },
    React.createElement("path", { fill: "#FFF", fillRule: "evenodd", d: "M7 5.586L2.05.636.636 2.05 5.586 7l-4.95 4.95 1.414 1.414L7 8.414l4.95 4.95 1.414-1.414L8.414 7l4.95-4.95L11.95.636 7 5.586z" })));


/***/ }),
/* 94 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"mvk_widget-container-dtqxIM0bZeW","title":"mvk_widget-title-lex41O9aJUO","buttons":"mvk_widget-buttons-66gVOFzjuoM","close":"mvk_widget-close-8zLjTpS91KI","phone-button":"mvk_widget-phone-button-3FOSgQhqbYk","phone-text":"mvk_widget-phone-text-lYhMYsreGO2","favorite-text":"mvk_widget-favorite-text-jqckYCJiCIM"};

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
exports.iconNoPhoto = (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", width: "53", height: "63", viewBox: "0 0 53 63" },
    React.createElement("defs", null,
        React.createElement("path", { id: "no-photo-a", d: "M.273.114h44.711v40.87H.273" })),
    React.createElement("g", { fill: "none", fillRule: "evenodd" },
        React.createElement("text", { fill: "#999", fontFamily: "Lato, Lato", fontSize: "12", fontWeight: "bold" },
            React.createElement("tspan", { x: "0", y: "59" }, "\u041D\u0435\u0442 \u0444\u043E\u0442\u043E")),
        React.createElement("g", { transform: "translate(5)" },
            React.createElement("mask", { id: "no-photo-b", fill: "#fff" },
                React.createElement("use", { xlinkHref: "#no-photo-a" })),
            React.createElement("path", { fill: "#999", d: "M30.073 26.1l1.264 5.4 6.775 1.485a.725.725 0 0 0 .866-.542L44.967 5.95a.714.714 0 0 0-.55-.852L21.762.131a.725.725 0 0 0-.865.542l-1.576 6.972 2.35-.534.876-3.88a.726.726 0 0 1 .866-.542L41.82 6.724c.39.086.637.467.55.852l-4.413 19.521a.725.725 0 0 1-.865.542l-7.019-1.538z", mask: "url(#no-photo-b)" }),
            React.createElement("path", { fill: "#999", d: "M30.427 14.603c1.046.185 2.08-.34 2.341-1.462.276-1.184-.454-2.107-1.446-2.323-1.148-.25-2.12.38-2.383 1.445-.256 1.034.436 2.103 1.488 2.34m-1.712 5.7l.248.787c.833-.907 1.612-1.753 2.389-2.601.832-.907 1.65-1.828 2.499-2.719.705-.738 1.151-1.575 1.29-2.59.133-.967-.053-1.86-.56-2.674-.828-1.327-2.05-2.033-3.644-2.083-1.105-.034-2.08.332-2.9 1.033-.7.598-1.153 1.314-1.361 2.138l2.04 8.71zM24.34 7.257c.33 0 .627.223.705.553l6.194 26.447a.714.714 0 0 1-.544.857L8.08 40.25a.723.723 0 0 1-.87-.536L1.018 13.269a.714.714 0 0 1 .544-.857l22.614-5.136a.721.721 0 0 1 .164-.018zm3.094 23.467a.714.714 0 0 0 .544-.857L23.414 10.38a.726.726 0 0 0-.87-.536L4.17 14.018a.715.715 0 0 0-.544.857L8.19 34.36c.09.385.48.625.87.536l18.374-4.173z", mask: "url(#no-photo-b)" }),
            React.createElement("path", { fill: "#999", d: "M14.418 16.445l3.744 2.295c-.06-.543-.2-.979-.297-1.422-.095-.438-.203-.874-.31-1.333l2.887-.655c.042.145.082.27.112.397.197.833.386 1.669.59 2.5.21.855.44 1.704.649 2.558.046.187.155.293.31.385.795.473 1.589.95 2.381 1.427.115.07.224.148.327.217-.074.293-1.751 2.998-2.328 3.767-.381-.181-.729-.433-1.094-.651-.371-.222-.737-.453-1.105-.68l-1.137-.7-1.104-.68-1.106-.68-1.131-.696c-.282.35-.483.727-.715 1.082-.235.36-.462.725-.692 1.088l-.71 1.12-.691 1.088-.69 1.088-.667 1.049-3.727-2.293 6.504-10.271", mask: "url(#no-photo-b)" })))));


/***/ }),
/* 96 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"fotorama":"mvk_widget-fotorama-hCgYCBJgjYK","hidden":"mvk_widget-hidden-bJyRtJbQtiK","default_content":"mvk_widget-default_content-jCDsCBDgUSE","fotorama_container":"mvk_widget-fotorama_container-cjhf7tF9gk0"};

/***/ }),
/* 97 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"mvk_widget-container-jjSYENcmtM0"};

/***/ }),
/* 98 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"mvk_widget-container-cmMLVyKVpYO"};

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var react_redux_1 = __webpack_require__(3);
var mvk_state_1 = __webpack_require__(4);
var floor_scheme_1 = __webpack_require__(100);
var flats_1 = __webpack_require__(5);
var sections_1 = __webpack_require__(6);
function mapStateToProps(state) {
    var MVKData = state.MVKData, _a = state.MVKState, flat = _a.flat, house = _a.house, isFullScreen = _a.isFullScreen, isOfferCard = _a.isOfferCard, phase = _a.phase, section = _a.section, sectionPhaseFilters = _a.sectionPhaseFilters;
    return {
        currentPhase: phase,
        floorFlats: flats_1.getFlatsBySectionFilters(MVKData, sectionPhaseFilters, house.id, section.id),
        floorScheme: sections_1.getFloorScheme(MVKData, house.id, section.id, sectionPhaseFilters.selectedFloor),
        hoveredFlatId: flat.hoveredId,
        isFullScreen: isFullScreen,
        isOfferCard: isOfferCard,
    };
}
function mapDispatchToProps(dispatch) {
    return {
        setFlatId: function (flatId) { return dispatch(mvk_state_1.setFlatIdAction(flatId)); },
        setHoveredFlatId: function (flatId) { return dispatch(mvk_state_1.setHoveredFlatIdAction(flatId)); },
    };
}
exports.FloorSchemeContainer = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(floor_scheme_1.FloorScheme);


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var flat_type_filter_1 = __webpack_require__(101);
var floor_filter_1 = __webpack_require__(104);
var mvk_state_1 = __webpack_require__(2);
var tracking_1 = __webpack_require__(7);
var polygons_drawer_1 = __webpack_require__(16);
var helpers_1 = __webpack_require__(11);
var compass_1 = __webpack_require__(108);
var styles = __webpack_require__(29);
var FloorScheme = /** @class */ (function (_super) {
    __extends(FloorScheme, _super);
    function FloorScheme(props) {
        var _this = _super.call(this, props) || this;
        _this.floorPlanContainer = null;
        _this.floorPlanContainerRef = function (container) {
            _this.floorPlanContainer = container;
            _this.setState({
                isFloorPlanContainerMounted: true,
            });
        };
        _this.handleFlatPolygonClick = function (flatId) {
            tracking_1.trackFlatInFloorPlanClick(_this.props.isOfferCard);
            _this.props.setFlatId(flatId);
        };
        _this.onBackgroundLoaded = function (size) {
            _this.backgroundImageSize = size;
        };
        _this.calculatePadding = function (canvasSize, scale) {
            var padding = [0, 0];
            if (_this.backgroundImageSize) {
                padding = padding.map(function (pad, index) {
                    var imageSize = Math.round(_this.backgroundImageSize[index] / scale);
                    return imageSize < canvasSize[index]
                        ? Math.round(canvasSize[index] - imageSize) / 2
                        : pad;
                });
            }
            return padding;
        };
        _this.calculateScale = function (canvasSize) {
            if (_this.backgroundImageSize) {
                return Math.max(_this.backgroundImageSize[0] / canvasSize[0], _this.backgroundImageSize[1] / canvasSize[1]);
            }
            return 1;
        };
        _this.getImageDrawParams = function (canvasWidth, canvasHeight) {
            var canvasSize = [canvasWidth, canvasHeight];
            var scale = _this.calculateScale(canvasSize);
            var padding = _this.calculatePadding(canvasSize, scale);
            var _a = __read(_this.backgroundImageSize || canvasSize, 2), drawnImageWidth = _a[0], drawnImageHeight = _a[1];
            if (scale !== _this.state.scale || padding[0] !== _this.state.padding[0] || padding[1] !== _this.state.padding[1]) {
                _this.setState({
                    padding: padding,
                    scale: scale,
                });
            }
            return {
                drawnImageHeight: drawnImageHeight,
                drawnImageWidth: drawnImageWidth,
                imageContainerHeight: drawnImageHeight / scale,
                imageContainerWidth: drawnImageWidth / scale,
                offsetLeft: padding[0],
                offsetTop: padding[1],
            };
        };
        _this.state = {
            isFloorPlanContainerMounted: false,
            padding: [0, 0],
            scale: 1,
        };
        return _this;
    }
    FloorScheme.prototype.render = function () {
        var _a = this.props, floorScheme = _a.floorScheme, floorFlats = _a.floorFlats, setHoveredFlatId = _a.setHoveredFlatId, hoveredFlatId = _a.hoveredFlatId, currentPhase = _a.currentPhase, isFullScreen = _a.isFullScreen;
        if (!floorScheme || currentPhase !== mvk_state_1.MVKPhase.SECTION) {
            return null;
        }
        var _b = this.state, padding = _b.padding, scale = _b.scale, isFloorPlanContainerMounted = _b.isFloorPlanContainerMounted;
        var drawParams = {
            padding: padding,
            scale: scale,
        };
        return (React.createElement("div", { className: styles['container'] },
            React.createElement(flat_type_filter_1.FlatTypeFilterContainer, null),
            React.createElement(floor_filter_1.FloorFilterContainer, null),
            React.createElement("div", { ref: this.floorPlanContainerRef, className: styles['polygons-container'] }, isFloorPlanContainerMounted &&
                React.createElement(polygons_drawer_1.PolygonsDrawer, { container: this.floorPlanContainer, polygons: helpers_1.getColoredPolygons(floorScheme.floorPlanFlats, floorFlats, hoveredFlatId), defaultColor: helpers_1.DEFAULT_FLAT_POLYGON_FILL_STYLE, background: floorScheme ? floorScheme.images.cianFull : '', backgroundDrawingAlgorythm: this.getImageDrawParams, onBackgroundLoaded: this.onBackgroundLoaded, drawParams: drawParams, onPolygonHover: setHoveredFlatId, onPolygonClick: this.handleFlatPolygonClick, isFullScreen: isFullScreen })),
            React.createElement(compass_1.FloorCompass, { azimuth: floorScheme.northDirection })));
    };
    return FloorScheme;
}(React.Component));
exports.FloorScheme = FloorScheme;


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var react_redux_1 = __webpack_require__(3);
var mvk_state_1 = __webpack_require__(4);
var flat_type_filter_1 = __webpack_require__(102);
var flats_1 = __webpack_require__(5);
exports.FlatTypeFilterContainer = react_redux_1.connect(function (state) {
    var MVKData = state.MVKData, _a = state.MVKState, house = _a.house, isOfferCard = _a.isOfferCard, section = _a.section, _b = _a.sectionPhaseFilters, selectedFlatTypes = _b.selectedFlatTypes, selectedFloor = _b.selectedFloor;
    return {
        floorFlatTypes: flats_1.getFlatTypesInFloor(MVKData, house.id, section.id, selectedFloor),
        selectedFlatTypes: selectedFlatTypes || [],
        isOfferCard: isOfferCard,
    };
}, function (dispatch) { return ({
    toggleFlatFilter: function (flatType) { return dispatch(mvk_state_1.toggleFlatFilterAction(flatType)); },
}); })(flat_type_filter_1.FlatTypeFilter);


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var utils_1 = __webpack_require__(1);
var mvk_state_1 = __webpack_require__(2);
var tracking_1 = __webpack_require__(7);
var styles = __webpack_require__(103);
var FlatTypeFilter = /** @class */ (function (_super) {
    __extends(FlatTypeFilter, _super);
    function FlatTypeFilter() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleFlatFilterChange = function (type) { return function () {
            tracking_1.trackRoomFilterChange(_this.props.isOfferCard);
            _this.props.toggleFlatFilter(type);
        }; };
        return _this;
    }
    FlatTypeFilter.prototype.render = function () {
        var _this = this;
        var _a = this.props, floorFlatTypes = _a.floorFlatTypes, selectedFlatTypes = _a.selectedFlatTypes;
        var internalFloorFlatTypes = floorFlatTypes.map(function (floorFlatType) { return mvk_state_1.MAP_FLAT_TYPE_TO_FLAT_TYPE_FOR_FILTER[floorFlatType]; });
        return (React.createElement("div", { className: styles['container'] }, mvk_state_1.FLAT_TYPES_FILTERS.map(function (flatTypeFilter) {
            var isDisabled = !internalFloorFlatTypes.includes(flatTypeFilter.type);
            var isSelected = selectedFlatTypes.includes(flatTypeFilter.type);
            return (React.createElement("div", __assign({ key: flatTypeFilter.title }, utils_1.mergeStyles(styles['button'], isDisabled && styles['disabled'], isSelected && styles['active']), { onClick: _this.handleFlatFilterChange(flatTypeFilter.type) }), flatTypeFilter.title));
        })));
    };
    return FlatTypeFilter;
}(React.Component));
exports.FlatTypeFilter = FlatTypeFilter;


/***/ }),
/* 103 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"mvk_widget-container-eh3nismCJiU","button":"mvk_widget-button-lCOrupcz3am","disabled":"mvk_widget-disabled-8jiuw7Uy3eS","active":"mvk_widget-active-1IoRWFHrNKy"};

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var react_redux_1 = __webpack_require__(3);
var redux_1 = __webpack_require__(10);
var mvk_state_1 = __webpack_require__(4);
var floor_filter_1 = __webpack_require__(105);
var flats_1 = __webpack_require__(5);
var sections_1 = __webpack_require__(6);
function mapStateToProps(state) {
    var MVKData = state.MVKData, MVKState = state.MVKState;
    var housId = MVKState.house.id;
    var sectionId = MVKState.section.id;
    var floors = sections_1.getFloorsInSection(MVKData, housId, sectionId);
    var floorsWithFlats = floors.filter(function (floor) { return flats_1.getFlatsInSectionFloor(MVKData, housId, sectionId, floor).length; });
    return {
        floors: floors.reverse(),
        floorsWithFlats: floorsWithFlats,
        selectedFloor: MVKState.sectionPhaseFilters.selectedFloor,
        isOfferCard: MVKState.isOfferCard,
    };
}
function mapDispatchToProps(dispatch) {
    return {
        setFloor: redux_1.bindActionCreators(mvk_state_1.setFloorFilterAction, dispatch),
    };
}
exports.FloorFilterContainer = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(floor_filter_1.FloorFilter);


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var utils_1 = __webpack_require__(1);
var tracking_1 = __webpack_require__(7);
var icon_arrow_down_1 = __webpack_require__(106);
var styles = __webpack_require__(107);
var FLOORS_LIMIT = 10;
var FloorFilter = /** @class */ (function (_super) {
    __extends(FloorFilter, _super);
    function FloorFilter(props) {
        var _this = _super.call(this, props) || this;
        _this.shouldRenderScrollTopButton = function (selectedFloor) {
            var floorsWithFlats = _this.props.floorsWithFlats;
            return floorsWithFlats.length > 0 && floorsWithFlats[floorsWithFlats.length - 1] !== selectedFloor;
        };
        _this.shouldRenderScrollDownButton = function (selectedFloor) {
            var floorsWithFlats = _this.props.floorsWithFlats;
            return floorsWithFlats.length > 0 && floorsWithFlats[0] !== selectedFloor;
        };
        _this.getFloorsLimit = function (selectedFloor) {
            if (_this.shouldRenderScrollDownButton(selectedFloor) && _this.shouldRenderScrollTopButton(selectedFloor)) {
                return FLOORS_LIMIT - 1;
            }
            return FLOORS_LIMIT;
        };
        _this.handleScrollFloor = function (increment) { return function () {
            var _a = _this.props, selectedFloor = _a.selectedFloor, floorsWithFlats = _a.floorsWithFlats;
            var currentFloorIndex = floorsWithFlats.findIndex(function (floor) { return selectedFloor === floor; });
            var nextFloor = floorsWithFlats[currentFloorIndex + increment];
            if (!nextFloor) {
                return;
            }
            _this.setState({
                visibleFloors: _this.getNextVisibleFloors(nextFloor, increment),
            });
            _this.setFloor(nextFloor);
        }; };
        _this.handleSelectFloor = function (nextFloor) {
            var selectedFloor = _this.props.selectedFloor;
            if (selectedFloor) {
                _this.setState({
                    visibleFloors: _this.getNextVisibleFloors(nextFloor, nextFloor > selectedFloor ? 1 : -1),
                });
            }
            _this.setFloor(nextFloor);
        };
        _this.getNextVisibleFloors = function (nextFloor, increment) {
            var _a = _this.props, floors = _a.floors, floorsWithFlats = _a.floorsWithFlats;
            // если increment === 0, то это этап инициализации в конструкторе и еще нет this.state
            var visibleFloors = increment === 0 ? [] : _this.state.visibleFloors;
            var floorsLimit = _this.getFloorsLimit(nextFloor);
            var nextFloorIndex = floors.findIndex(function (floor) { return nextFloor === floor; });
            var isLastFloorWithFlats = floorsWithFlats[floorsWithFlats.length - 1] === nextFloor;
            var isFirstFloorWithFlats = floorsWithFlats[0] === nextFloor;
            var minStart = Math.max(floors.length - floorsLimit, 0);
            if (isLastFloorWithFlats && nextFloorIndex < floorsLimit) {
                return floors.slice(0, floorsLimit);
            }
            else if (isFirstFloorWithFlats && nextFloorIndex > minStart) {
                return floors.slice(minStart);
            }
            else if (visibleFloors.includes(nextFloor) && floorsLimit === visibleFloors.length) {
                return visibleFloors;
            }
            var sliceParams = [0, 0];
            if (increment >= 0) {
                sliceParams = nextFloorIndex + floorsLimit >= floors.length
                    ? [Math.max(minStart - 1, 0), floors.length - 1]
                    : [nextFloorIndex, nextFloorIndex + floorsLimit];
            }
            else {
                sliceParams = nextFloorIndex - floorsLimit < 0
                    ? [1, floorsLimit + 1]
                    : [nextFloorIndex - floorsLimit + 1, nextFloorIndex + 1];
            }
            return floors.slice(sliceParams[0], sliceParams[1]);
        };
        _this.renderFloors = function () {
            var _a = _this.props, selectedFloor = _a.selectedFloor, floorsWithFlats = _a.floorsWithFlats;
            return _this.state.visibleFloors.map(function (floor) { return (React.createElement("div", __assign({}, utils_1.mergeStyles(styles['button'], !floorsWithFlats.includes(floor) && styles['disabled'], selectedFloor === floor && styles['selected']), { key: floor, onClick: function () { return _this.handleSelectFloor(floor); } }), floor)); });
        };
        _this.setFloor = function (floor) {
            tracking_1.trackFloorFilterChange(_this.props.isOfferCard);
            _this.props.setFloor(floor);
        };
        var selectedFloor = props.selectedFloor;
        _this.state = {
            visibleFloors: selectedFloor ? _this.getNextVisibleFloors(selectedFloor, 0) : [],
        };
        return _this;
    }
    FloorFilter.prototype.render = function () {
        var selectedFloor = this.props.selectedFloor;
        return (React.createElement("div", { className: styles['container'] },
            React.createElement("div", { className: styles['title'] }, "\u042D\u0442\u0430\u0436"),
            React.createElement("div", { className: styles['floors-container'] },
                React.createElement("div", { className: styles['floors'] },
                    this.shouldRenderScrollTopButton(selectedFloor) &&
                        React.createElement("div", __assign({}, utils_1.mergeStyles(styles['button'], styles['button-scroll-up']), { onClick: this.handleScrollFloor(1) }), icon_arrow_down_1.iconArrowDown),
                    this.renderFloors(),
                    this.shouldRenderScrollDownButton(selectedFloor) &&
                        React.createElement("div", { className: styles['button'], onClick: this.handleScrollFloor(-1) }, icon_arrow_down_1.iconArrowDown)))));
    };
    return FloorFilter;
}(React.Component));
exports.FloorFilter = FloorFilter;


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
exports.iconArrowDown = (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "10", height: "6", viewBox: "0 0 10 6" },
    React.createElement("path", { fill: "currentColor", 
        // tslint:disable-next-line:max-line-length
        d: "M4.3 5.7L.1 1.6C-.2 1.2-.1.6.2.3c.3-.4.9-.4 1.3-.2L5 3.4 8.4.1c.4-.3 1-.2 1.3.2.3.4.4.9.1 1.3L5.6 5.7c-.2.2-.4.3-.6.3-.2 0-.5-.1-.7-.3z" })));


/***/ }),
/* 107 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"mvk_widget-container-2GsFIYQL3ie","title":"mvk_widget-title-3WtpZfufyEW","button":"mvk_widget-button-d1MN6KIn7iM","selected":"mvk_widget-selected-97oM0hQtAAc","disabled":"mvk_widget-disabled-2lA3mPxNkUS","button-scroll-up":"mvk_widget-button-scroll-up-9fKFP3hbVKq","floors-container":"mvk_widget-floors-container-jIcBdXlzI4u","floors":"mvk_widget-floors-kdm8MYswO4o"};

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var styles = __webpack_require__(29);
exports.FloorCompass = function (_a) {
    var azimuth = _a.azimuth;
    return (React.createElement("div", { className: styles['compass'] },
        React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20", viewBox: "0 0 8 19" },
            React.createElement("g", { fill: "none", fillRule: "evenodd", transform: azimuth ? "rotate(" + azimuth + " 4 9)" : '' },
                React.createElement("path", { fill: "#7A7A7A", d: "M4 0l4 9H0z" }),
                React.createElement("path", { fill: "#E4E4E4", d: "M4 19l4-9H0z" }))),
        React.createElement("span", null, "\u0421\u0435\u0432\u0435\u0440")));
};


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var react_redux_1 = __webpack_require__(3);
var info_tooltip_1 = __webpack_require__(110);
function mapStateToProps(state) {
    return {
        currentPhase: state.MVKState.phase,
        isFullScreen: state.MVKState.isFullScreen,
        isPanoramaActive: state.MVKState.map.isPanoramaActive,
        shouldShowFullScreenTip: state.MVKState.shouldShowFullScreenTip,
    };
}
exports.InfoTooltipContainer = react_redux_1.connect(mapStateToProps)(info_tooltip_1.InfoTooltip);


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var mvk_state_1 = __webpack_require__(2);
var styles = __webpack_require__(111);
var InfoTooltip = /** @class */ (function (_super) {
    __extends(InfoTooltip, _super);
    function InfoTooltip() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getInfoTooltipText = function () {
            var _a = _this.props, shouldShowFullScreenTip = _a.shouldShowFullScreenTip, isFullScreen = _a.isFullScreen, currentPhase = _a.currentPhase, isPanoramaActive = _a.isPanoramaActive;
            var phaseText = currentPhase === mvk_state_1.MVKPhase.PREVIEW && !isPanoramaActive ? 'Выберите корпус' : undefined;
            return isFullScreen && shouldShowFullScreenTip
                ? 'Чтобы выйти из полноэкранного режима, нажмите Esc'
                : phaseText;
        };
        return _this;
    }
    InfoTooltip.prototype.render = function () {
        var title = this.getInfoTooltipText();
        if (!title) {
            return null;
        }
        return (React.createElement("div", { className: styles['info_tooltip'] },
            React.createElement("span", null, title)));
    };
    return InfoTooltip;
}(React.Component));
exports.InfoTooltip = InfoTooltip;


/***/ }),
/* 111 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"info_tooltip":"mvk_widget-info_tooltip-381IQTxWqQs"};

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var to_fullscreen_icon_1 = __webpack_require__(113);
var to_normal_icon_1 = __webpack_require__(114);
var styles = __webpack_require__(115);
exports.FullScreenControl = function (_a) {
    var onToggle = _a.onToggle, isActive = _a.isActive;
    return (React.createElement("div", { className: styles['container'], onClick: onToggle }, isActive ? to_normal_icon_1.toNormalModeIcon : to_fullscreen_icon_1.toFullscreenModeIcon));
};


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable:max-line-length */
var React = __webpack_require__(0);
exports.toFullscreenModeIcon = (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "18", height: "18", viewBox: "0 0 18 18" },
    React.createElement("g", { fill: "currentColor", fillRule: "evenodd" },
        React.createElement("path", { d: "M2 15.75V17a1 1 0 0 1-2 0v-5a1 1 0 0 1 2 0v1.5l-1 3 1-.75z" }),
        React.createElement("path", { d: "M4.5 16H6a1 1 0 0 1 0 2H1a1 1 0 0 1 0-2h1.25l-.75 1 3-1zM16 2.25V1a1 1 0 0 1 2 0v5a1 1 0 0 1-2 0V4.5l1-3-1 .75z" }),
        React.createElement("path", { d: "M13.5 2H12a1 1 0 0 1 0-2h5a1 1 0 0 1 0 2h-1.25l.75-1-3 1zM3.66 15.76l3.22-3.22a1.004 1.004 0 1 0-1.42-1.42l-3.22 3.22L1 16H.59l-.3.3a1 1 0 0 0 1.42 1.4l.29-.29V17l1.66-1.24z" }),
        React.createElement("path", { d: "M14.34 2.24l-3.22 3.22a1.004 1.004 0 1 0 1.42 1.42l3.22-3.22L17 2h.41l.3-.3A1 1 0 0 0 16.29.3L16 .59V1l-1.66 1.24z" }))));


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable:max-line-length */
var React = __webpack_require__(0);
exports.toNormalModeIcon = (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20", viewBox: "0 0 20 20" },
    React.createElement("g", { fill: "currentColor", fillRule: "evenodd" },
        React.createElement("path", { d: "M14 5.75V7a1 1 0 0 1-2 0V2a1 1 0 0 1 2 0v1.5l-1 3 1-.75z" }),
        React.createElement("path", { d: "M16.5 6H18a1 1 0 0 1 0 2h-5a1 1 0 0 1 0-2h1.25l-.75 1 3-1zM6 14.25V13a1 1 0 0 1 2 0v5a1 1 0 0 1-2 0v-1.5l1-3-1 .75z" }),
        React.createElement("path", { d: "M3.5 14H2a1 1 0 0 1 0-2h5a1 1 0 0 1 0 2H5.75l.75-1-3 1z" }),
        React.createElement("path", { d: "M4.34 14.24l-3.22 3.22a1.004 1.004 0 0 0 1.42 1.42l3.22-3.22L7 14h.41l.3-.3a1 1 0 0 0-1.42-1.4l-.29.29V13l-1.66 1.24zm11.32-8.48l3.22-3.22a1.004 1.004 0 1 0-1.42-1.42l-3.22 3.22L13 6h-.41l-.3.3a1 1 0 1 0 1.42 1.4l.29-.29V7l1.66-1.24z" }))));


/***/ }),
/* 115 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"mvk_widget-container-hHUyZwskjm0"};

/***/ }),
/* 116 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"mvk_widget-container-5gPle3JXYIm"};

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var react_redux_1 = __webpack_require__(3);
var redux_1 = __webpack_require__(10);
var mvk_state_1 = __webpack_require__(4);
var navigation_1 = __webpack_require__(118);
function mapStateToProps(state) {
    return {
        currentPhase: state.MVKState.phase,
        isOfferCard: state.MVKState.isOfferCard,
    };
}
function mapDispatchToProps(dispatch) {
    return {
        selectPhase: redux_1.bindActionCreators(mvk_state_1.setMVKPhaseAction, dispatch),
    };
}
exports.NavigationContainer = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(navigation_1.Navigation);


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var _a;
var React = __webpack_require__(0);
var utils_1 = __webpack_require__(1);
var mvk_state_1 = __webpack_require__(2);
var close_control_1 = __webpack_require__(119);
var styles = __webpack_require__(122);
exports.MVK_PHASE_VALUES = (_a = {},
    _a[mvk_state_1.MVKPhase.PREVIEW] = 3,
    _a[mvk_state_1.MVKPhase.SECTION] = 2,
    _a[mvk_state_1.MVKPhase.FLAT] = 1,
    _a);
var Navigation = /** @class */ (function (_super) {
    __extends(Navigation, _super);
    function Navigation() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderNavigation = function (phase, text) {
            var currentIndex = exports.MVK_PHASE_VALUES[phase];
            var selectedIndex = exports.MVK_PHASE_VALUES[_this.props.currentPhase];
            return (React.createElement("li", __assign({ key: phase, onClick: function () { return _this.props.selectPhase(phase); } }, utils_1.mergeStyles([
                styles['navigation-item'],
                (currentIndex < selectedIndex) && styles['navigation-item--disabled'],
                (currentIndex === selectedIndex) && styles['navigation-item--selected'],
            ])), text));
        };
        return _this;
    }
    Navigation.prototype.render = function () {
        var _a = this.props, isOfferCard = _a.isOfferCard, onClose = _a.onClose;
        return (React.createElement("div", __assign({}, utils_1.mergeStyles(isOfferCard && styles['container-with-close'])),
            React.createElement("ul", { className: styles['navigation'] },
                this.renderNavigation(mvk_state_1.MVKPhase.PREVIEW, 'Корпуса'),
                this.renderNavigation(mvk_state_1.MVKPhase.SECTION, 'Поэтажный план'),
                this.renderNavigation(mvk_state_1.MVKPhase.FLAT, 'Квартира')),
            isOfferCard && React.createElement(close_control_1.CloseControl, { onClick: onClose })));
    };
    return Navigation;
}(React.Component));
exports.Navigation = Navigation;


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var close_icon_1 = __webpack_require__(120);
var styles = __webpack_require__(121);
exports.CloseControl = function (_a) {
    var onClick = _a.onClick;
    return (React.createElement("div", { className: styles['container'], onClick: onClick }, close_icon_1.closeIcon));
};


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable:max-line-length */
var React = __webpack_require__(0);
exports.closeIcon = (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "14", height: "14", viewBox: "0 0 14 14" },
    React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M7 5.586L2.05.636.636 2.05 5.586 7l-4.95 4.95 1.414 1.414L7 8.414l4.95 4.95 1.414-1.414L8.414 7l4.95-4.95L11.95.636 7 5.586z" })));


/***/ }),
/* 121 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"mvk_widget-container-dcpSfqTlO8o"};

/***/ }),
/* 122 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container-with-close":"mvk_widget-container-with-close-9tXN1cFA52Y","navigation":"mvk_widget-navigation-kP9zg16LMy6","navigation-item":"mvk_widget-navigation-item-6MGG3MCQ7uo","navigation-item--disabled":"mvk_widget-navigation-item--disabled-i5sUp1vuRUk","navigation-item--selected":"mvk_widget-navigation-item--selected-54OOp4NHgcq"};

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var react_redux_1 = __webpack_require__(3);
var side_block_1 = __webpack_require__(124);
var mapStateToProps = function (state) {
    return {
        currentPhase: state.MVKState.phase,
    };
};
exports.SideBlockContainer = react_redux_1.connect(mapStateToProps)(side_block_1.SideBlock);


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var _a;
var React = __webpack_require__(0);
var side_block_house_picker_1 = __webpack_require__(125);
var mvk_state_1 = __webpack_require__(2);
var styles = __webpack_require__(143);
var SIDE_BLOCK_COMPONENTS = (_a = {},
    _a[mvk_state_1.MVKPhase.PREVIEW] = side_block_house_picker_1.SideBlockHousePickerContainer,
    _a[mvk_state_1.MVKPhase.SECTION] = side_block_house_picker_1.SideBlockHousePickerContainer,
    _a[mvk_state_1.MVKPhase.FLAT] = side_block_house_picker_1.SideBlockHousePickerContainer,
    _a);
var SideBlock = /** @class */ (function (_super) {
    __extends(SideBlock, _super);
    function SideBlock() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SideBlock.prototype.render = function () {
        var currentPhase = this.props.currentPhase;
        var CurrentSideBlockContainer = SIDE_BLOCK_COMPONENTS[currentPhase];
        return (React.createElement("div", { className: styles['container'] }, CurrentSideBlockContainer && React.createElement(CurrentSideBlockContainer, null)));
    };
    return SideBlock;
}(React.Component));
exports.SideBlock = SideBlock;


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var react_redux_1 = __webpack_require__(3);
var mvk_state_1 = __webpack_require__(4);
var side_block_house_picker_1 = __webpack_require__(126);
var mvk_state_2 = __webpack_require__(2);
var flats_1 = __webpack_require__(5);
var houses_1 = __webpack_require__(20);
function mapStateToProps(state) {
    var houseUtils = houses_1.HouseUtils.getInstance(state.MVKData);
    var selectedHouseId = state.MVKState.house.id;
    var selectedSectionId = state.MVKState.section.id;
    var isPreview = state.MVKState.phase === mvk_state_2.MVKPhase.PREVIEW;
    var isFlatPlanView = state.MVKState.phase === mvk_state_2.MVKPhase.SECTION;
    var isFlatView = state.MVKState.phase === mvk_state_2.MVKPhase.FLAT;
    var filters = state.MVKState.sectionPhaseFilters;
    var _a = state.MVKState, house = _a.house, section = _a.section, flat = _a.flat;
    var parsedSections = houseUtils.getSections();
    var selectedSection = parsedSections.find(function (item) { return item.id === selectedSectionId; });
    return {
        currentPhase: state.MVKState.phase,
        geoInfo: state.MVKData.geoInfo,
        hoveredId: flat.hoveredId || section.hoveredId || house.hoveredId,
        newbuildingName: state.MVKData.name,
        parsedOffers: (isFlatPlanView && selectedHouseId && selectedSectionId)
            ? flats_1.getOfferViewModels(state.MVKData, selectedHouseId, selectedSectionId, filters)
            : [],
        parsedSections: isPreview ? parsedSections : [],
        parsedSimilarOffers: isFlatView
            ? flats_1.getSimilarOffers(state.MVKData, state.MVKState.flat.id)
            : [],
        sectionPhaseFilters: state.MVKState.sectionPhaseFilters,
        selectedSection: selectedSection,
        shouldIgnoreScroll: state.MVKState.shouldIgnoreScroll,
        isOfferCard: state.MVKState.isOfferCard,
    };
}
function mapDispatchToProps(dispatch) {
    return {
        clearFlatId: function () { return dispatch(mvk_state_1.setMVKPhaseAction(mvk_state_2.MVKPhase.SECTION)); },
        clearSectionId: function () { return dispatch(mvk_state_1.setMVKPhaseAction(mvk_state_2.MVKPhase.PREVIEW)); },
        setFlatId: function (id) { return dispatch(mvk_state_1.setFlatIdAction(id)); },
        setHouseId: function (id) { return dispatch(mvk_state_1.setHouseIdAction(id)); },
        setHoveredFlatId: function (flatId) { return dispatch(mvk_state_1.setHoveredFlatIdAction(flatId)); },
        setHoveredSectionId: function (id, houseId, shouldIgnoreScroll) {
            return dispatch(mvk_state_1.setHoveredSectionIdAction(id, houseId, shouldIgnoreScroll));
        },
        setSectionId: function (id) { return dispatch(mvk_state_1.setSectionIdAction(id)); },
    };
}
exports.SideBlockHousePickerContainer = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(side_block_house_picker_1.SideBlockHousePicker);


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var utils_1 = __webpack_require__(1);
var mvk_state_1 = __webpack_require__(2);
var scroll_1 = __webpack_require__(127);
var scrollDirection_1 = __webpack_require__(128);
var helpers_1 = __webpack_require__(129);
var tracking_1 = __webpack_require__(7);
var no_offers_1 = __webpack_require__(130);
var picker_info_1 = __webpack_require__(133);
var side_block_house_card_1 = __webpack_require__(135);
var side_block_offer_card_1 = __webpack_require__(137);
var title_link_1 = __webpack_require__(139);
var styles = __webpack_require__(142);
var SideBlockHousePicker = /** @class */ (function (_super) {
    __extends(SideBlockHousePicker, _super);
    function SideBlockHousePicker() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.list = null;
        _this.state = {
            availableScrollDirection: scrollDirection_1.AvailableScrollDirection.Bottom,
        };
        _this.onSectionCardSelect = function (section) {
            tracking_1.trackSectionClick(_this.props.isOfferCard);
            _this.props.setHouseId(section.house.id);
            _this.props.setSectionId(section.id);
        };
        _this.onSideBlockOfferCardSelect = function (offer) {
            tracking_1.trackFlatInFloorPlanClick(_this.props.isOfferCard);
            _this.props.setFlatId(offer.id);
        };
        _this.onSideBlockSimilarOfferCardSelect = function (offer) {
            tracking_1.trackSimilarFlatClick(offer.analyticsData && offer.analyticsData.customUrl || '');
            _this.props.setFlatId(offer.id);
        };
        _this.handleElementScroll = function (e) {
            var availableScrollDirection = scrollDirection_1.getAvailableScrollDirection(e);
            if (_this.state.availableScrollDirection !== availableScrollDirection) {
                _this.setState({
                    availableScrollDirection: availableScrollDirection,
                });
            }
        };
        _this.getHeader = function () {
            var _a = _this.props, selectedSection = _a.selectedSection, currentPhase = _a.currentPhase, sectionPhaseFilters = _a.sectionPhaseFilters;
            var shouldRenderLink = [mvk_state_1.MVKPhase.SECTION, mvk_state_1.MVKPhase.FLAT].includes(currentPhase);
            if (shouldRenderLink) {
                return (React.createElement(React.Fragment, null,
                    currentPhase === mvk_state_1.MVKPhase.SECTION
                        ? _this.renderSectionTitleLink()
                        : _this.renderFlatTitleLink(),
                    React.createElement(picker_info_1.PickerInfo, { key: 2, selectedSection: selectedSection, floor: sectionPhaseFilters.selectedFloor, isFlatView: currentPhase === mvk_state_1.MVKPhase.FLAT })));
            }
            else {
                return _this.renderTitleText();
            }
        };
        _this.renderSectionTitleLink = function () {
            return (React.createElement(title_link_1.TitleLink, { key: 1, onClick: _this.onSectionTitleLinkClick }, "\u041A \u0432\u044B\u0431\u043E\u0440\u0443 \u043A\u043E\u0440\u043F\u0443\u0441\u0430"));
        };
        _this.renderFlatTitleLink = function () {
            return (React.createElement(title_link_1.TitleLink, { key: 1, onClick: _this.onFlatTitleLinkClick }, "\u041A \u0432\u044B\u0431\u043E\u0440\u0443 \u043A\u0432\u0430\u0440\u0442\u0438\u0440\u044B"));
        };
        _this.renderTitleText = function () {
            var _a = _this.props, newbuildingName = _a.newbuildingName, currentPhase = _a.currentPhase;
            var availableScrollDirection = _this.state.availableScrollDirection;
            var isOfferView = currentPhase === mvk_state_1.MVKPhase.FLAT;
            var text = isOfferView ? 'Похожие квартиры на других этажах' : "\u041A\u043E\u0440\u043F\u0443\u0441\u0430 \u0432 \u0416\u041A \u00AB" + newbuildingName + "\u00BB";
            return (React.createElement("h4", __assign({}, utils_1.mergeStyles([
                styles['title'],
                currentPhase === mvk_state_1.MVKPhase.FLAT && styles['title--small_margin'],
                [scrollDirection_1.AvailableScrollDirection.Top, scrollDirection_1.AvailableScrollDirection.Both]
                    .includes(availableScrollDirection) && styles['title--top-gradient'],
            ])), text));
        };
        _this.getSectionViewItems = function () {
            var _a = _this.props, _b = _a.parsedSections, parsedSections = _b === void 0 ? [] : _b, hoveredId = _a.hoveredId;
            return parsedSections.map(function (section) { return (React.createElement(side_block_house_card_1.SideBlockHouseCard, { titlePrefix: "\u0421\u0435\u043A\u0446\u0438\u044F ", isHovered: section.id === hoveredId, key: section.id, section: section, onSelect: _this.onSectionCardSelect, onMouseEnter: _this.onSideBlockHouseCardMouseEnter, onMouseLeave: _this.onSideBlockHouseCardMouseLeave })); });
        };
        _this.getOfferViewItems = function () {
            var _a = _this.props, _b = _a.parsedOffers, parsedOffers = _b === void 0 ? [] : _b, hoveredId = _a.hoveredId;
            return parsedOffers.map(function (offer, index) { return (React.createElement(side_block_offer_card_1.SideBlockOfferCard, { isHovered: offer.id === hoveredId, key: offer.flatNumber + offer.roomsTitle + index, offer: offer, onSelect: _this.onSideBlockOfferCardSelect, onHover: _this.props.setHoveredFlatId })); });
        };
        _this.onSectionTitleLinkClick = function () {
            _this.props.clearSectionId();
        };
        _this.onFlatTitleLinkClick = function () {
            _this.props.clearFlatId();
        };
        _this.getSimilarOffersViewItems = function () {
            var _a = _this.props.parsedSimilarOffers, parsedSimilarOffers = _a === void 0 ? [] : _a;
            return parsedSimilarOffers.map(function (offer, index) { return (React.createElement(side_block_offer_card_1.SideBlockOfferCard, { isSimilarPhase: true, key: offer.flatNumber + offer.roomsTitle + index, offer: offer, onSelect: _this.onSideBlockSimilarOfferCardSelect })); });
        };
        _this.onSideBlockHouseCardMouseEnter = function (section) {
            _this.props.setHoveredSectionId(section.id, section.house.id, true);
        };
        _this.onSideBlockHouseCardMouseLeave = function () {
            _this.props.setHoveredSectionId();
        };
        return _this;
    }
    SideBlockHousePicker.prototype.componentWillReceiveProps = function (nextProps) {
        var isViewTypeChanged = this.props.currentPhase !== nextProps.currentPhase;
        var isHoveredIdChanged = nextProps.hoveredId !== undefined && this.props.hoveredId !== nextProps.hoveredId;
        if (!nextProps.shouldIgnoreScroll && isHoveredIdChanged || isViewTypeChanged) {
            scroll_1.scrollToElement(this.list, isViewTypeChanged
                ? document.querySelector("[id^=house-card-]")
                : document.querySelector("#house-card-" + nextProps.hoveredId));
        }
    };
    SideBlockHousePicker.prototype.render = function () {
        var _this = this;
        var _a = this.props, currentPhase = _a.currentPhase, geoInfo = _a.geoInfo, isOfferCard = _a.isOfferCard;
        var availableScrollDirection = this.state.availableScrollDirection;
        var mapUrl = helpers_1.getMapLink(geoInfo);
        var items = null;
        switch (currentPhase) {
            case mvk_state_1.MVKPhase.PREVIEW:
                items = this.getSectionViewItems();
                break;
            case mvk_state_1.MVKPhase.SECTION:
                items = this.getOfferViewItems();
                break;
            case mvk_state_1.MVKPhase.FLAT:
                items = this.getSimilarOffersViewItems();
                break;
            default: break;
        }
        var body = currentPhase === mvk_state_1.MVKPhase.FLAT && Array.isArray(items) && !items.length
            ? React.createElement(no_offers_1.NoOffers, null)
            :
                React.createElement("ul", { ref: function (ref) { return _this.list = ref; }, className: styles['house_list'] }, items);
        return (React.createElement("div", { onScroll: this.handleElementScroll, className: styles['container'] },
            this.getHeader(),
            body,
            React.createElement("div", __assign({}, utils_1.mergeStyles([
                styles['link_wrapper'],
                [scrollDirection_1.AvailableScrollDirection.Bottom, scrollDirection_1.AvailableScrollDirection.Both]
                    .includes(availableScrollDirection) && styles['link_wrapper--top_gradient'],
            ])), currentPhase === mvk_state_1.MVKPhase.PREVIEW &&
                React.createElement("a", { className: styles['link'], target: "_blank", href: mapUrl, onClick: function () { return tracking_1.trackSimilarSuggestionsClick(isOfferCard); } }, "\u041F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u044F \u0440\u044F\u0434\u043E\u043C"))));
    };
    return SideBlockHousePicker;
}(React.Component));
exports.SideBlockHousePicker = SideBlockHousePicker;


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function scrollToElement(scrollableElement, node) {
    if (!scrollableElement || !node) {
        return;
    }
    var endLocation = node.offsetTop;
    var startLocation = scrollableElement.scrollTop;
    var distance = endLocation - startLocation - 15;
    var timeLapsed = 0;
    var start;
    var percentage;
    var position;
    var animationHandle;
    // tslint:disable-next-line:variable-name
    var stopAnimateScroll = function (loopPosition, loopEndLocation) {
        var currentLocation = scrollableElement.scrollTop;
        if (loopPosition === loopEndLocation ||
            currentLocation === loopEndLocation || timeLapsed > 500) {
            window.cancelAnimationFrame(animationHandle);
            start = null;
            return true;
        }
        return false;
    };
    var loopAnimateScroll = function (timestamp) {
        if (!start) {
            start = timestamp;
        }
        timeLapsed += timestamp - start;
        percentage = (timeLapsed / 250);
        percentage = (percentage > 1) ? 1 : percentage;
        position = startLocation + (distance * (percentage * percentage));
        scrollableElement.scrollTop = Math.floor(position);
        if (!stopAnimateScroll(position, endLocation)) {
            animationHandle = window.requestAnimationFrame(loopAnimateScroll);
            start = timestamp;
        }
    };
    animationHandle = window.requestAnimationFrame(loopAnimateScroll);
}
exports.scrollToElement = scrollToElement;


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var AvailableScrollDirection;
(function (AvailableScrollDirection) {
    AvailableScrollDirection[AvailableScrollDirection["Top"] = 0] = "Top";
    AvailableScrollDirection[AvailableScrollDirection["Bottom"] = 1] = "Bottom";
    AvailableScrollDirection[AvailableScrollDirection["Both"] = 2] = "Both";
})(AvailableScrollDirection = exports.AvailableScrollDirection || (exports.AvailableScrollDirection = {}));
function getAvailableScrollDirection(e) {
    var _a = e.target, scrollTop = _a.scrollTop, scrollHeight = _a.scrollHeight, offsetHeight = _a.offsetHeight;
    var scroll = scrollHeight - offsetHeight;
    var canScrollToTop = scrollTop !== 0;
    var canScrollToBottom = scrollTop !== scroll;
    var availableScrollDirection;
    if (canScrollToBottom) {
        availableScrollDirection = AvailableScrollDirection.Bottom;
    }
    if (canScrollToTop) {
        availableScrollDirection = AvailableScrollDirection.Top;
    }
    if (canScrollToTop && canScrollToBottom) {
        availableScrollDirection = AvailableScrollDirection.Both;
    }
    return availableScrollDirection;
}
exports.getAvailableScrollDirection = getAvailableScrollDirection;


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.getMapLink = function (geoInfo) {
    var query = "//cian.ru/map?deal_type=sale&engine_version=2&zoom=12&with_newobject=1&newbuildings_search=true";
    if (geoInfo) {
        var regionId = geoInfo.regionId, _a = geoInfo.coordinates, lat = _a.lat, lng = _a.lng;
        query += "&region=" + regionId + "&center=" + lat + "," + lng;
    }
    return query;
};


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var icon_cian_1 = __webpack_require__(131);
var styles = __webpack_require__(132);
exports.NoOffers = function () {
    return (React.createElement("div", { className: styles['no_offers'] },
        React.createElement("div", { className: styles['no_offers-content'] },
            icon_cian_1.cianIcon,
            React.createElement("span", { className: styles['no_offers-text'] }, "\u041D\u0435\u0442 \u043F\u043E\u0445\u043E\u0436\u0438\u0445 \u043A\u0432\u0430\u0440\u0442\u0438\u0440 \u043D\u0430 \u0434\u0440\u0443\u0433\u0438\u0445 \u044D\u0442\u0430\u0436\u0430\u0445"))));
};


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
// tslint:disable:max-line-length
var React = __webpack_require__(0);
exports.cianIcon = (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "38", height: "55", viewBox: "0 0 38 55" },
    React.createElement("path", { fill: "#C9C9C9", fillRule: "evenodd", d: "M21.507 12.962l.104.196 7.537 13.657 7.538-13.657.104-.214a9 9 0 0 0 1.054-4.041c0-3.689-2.208-6.995-5.552-8.314C28.948-.73 25.16.211 22.768 2.956 20.375 5.7 19.874 9.68 21.507 12.962zM29.2 4.985c1.573 0 2.989.98 3.584 2.48.595 1.499.251 3.22-.87 4.354a3.79 3.79 0 0 1-4.244.819c-1.445-.64-2.37-2.116-2.342-3.735.037-2.175 1.76-3.918 3.872-3.918zm3.268 37.23L38 47.915 31.12 55 19 42.5 6.88 55 0 47.914l19-19.55 6.95 7.14v-6.446h6.518v13.158z" })));


/***/ }),
/* 132 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"no_offers":"mvk_widget-no_offers-gpApNonFWEG","no_offers-content":"mvk_widget-no_offers-content-hIowoV02YwO","no_offers-text":"mvk_widget-no_offers-text-ljSxgB63NQk"};

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var styles = __webpack_require__(134);
var PickerInfo = /** @class */ (function (_super) {
    __extends(PickerInfo, _super);
    function PickerInfo() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderSectionInfo = function () {
            var selectedSection = _this.props.selectedSection;
            if (!selectedSection) {
                return null;
            }
            return (React.createElement(React.Fragment, null,
                _this.renderItem(selectedSection.house.name, 1),
                _this.renderItem("\u0421\u0435\u043A\u0446\u0438\u044F " + selectedSection.sectionData.number, 2)));
        };
        _this.renderItem = function (text, key) { return (React.createElement("li", { key: key, className: styles['item'] }, text)); };
        return _this;
    }
    PickerInfo.prototype.render = function () {
        var _a = this.props, selectedSection = _a.selectedSection, floor = _a.floor, isFlatView = _a.isFlatView;
        if (!selectedSection && !floor) {
            return null;
        }
        if (isFlatView) {
            return (React.createElement("div", { className: styles['container--simple'] }, "\u041F\u043E\u0445\u043E\u0436\u0438\u0435 \u043A\u0432\u0430\u0440\u0442\u0438\u0440\u044B \u043D\u0430 \u0434\u0440\u0443\u0433\u0438\u0445 \u044D\u0442\u0430\u0436\u0430\u0445"));
        }
        return (React.createElement("ul", { className: styles['container'] },
            floor && this.renderItem(floor + " \u044D\u0442\u0430\u0436", 0),
            this.renderSectionInfo()));
    };
    return PickerInfo;
}(React.Component));
exports.PickerInfo = PickerInfo;


/***/ }),
/* 134 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"mvk_widget-container-lLQnYCq7T2Q","item":"mvk_widget-item-f1y5CGh29MW","container--simple":"mvk_widget-container--simple-Am3AJh8n60"};

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var utils_1 = __webpack_require__(1);
var styles = __webpack_require__(136);
var SideBlockHouseCard = /** @class */ (function (_super) {
    __extends(SideBlockHouseCard, _super);
    function SideBlockHouseCard() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleMouseEnter = function () {
            var _a = _this.props, onMouseEnter = _a.onMouseEnter, section = _a.section;
            if (!!onMouseEnter) {
                onMouseEnter(section);
            }
        };
        _this.handleMouseLeave = function () {
            var onMouseLeave = _this.props.onMouseLeave;
            if (!!onMouseLeave) {
                onMouseLeave();
            }
        };
        return _this;
    }
    SideBlockHouseCard.prototype.render = function () {
        var _a = this.props, onSelect = _a.onSelect, isHovered = _a.isHovered, titlePrefix = _a.titlePrefix, section = _a.section;
        var sectionData = section.sectionData, offersInSaleCount = section.offersInSaleCount, houseInfo = section.houseInfo, constructionStatus = section.constructionStatus, id = section.id, deadlineData = section.deadlineData, house = section.house, flatTypeText = section.flatTypeText;
        var isDisabled = !houseInfo.length;
        var _b = getTipSettings(constructionStatus), isGray = _b.isGray, isYellow = _b.isYellow, isGreen = _b.isGreen;
        var titleSectionText = house.sections.length > 1 ? " \u00B7 " + titlePrefix + " " + sectionData.number : '';
        return (React.createElement("li", __assign({ id: "house-card-" + id, onClick: function () { return onSelect(section); }, onMouseEnter: this.handleMouseEnter, onMouseLeave: this.handleMouseLeave }, utils_1.mergeStyles([
            styles['container'],
            isHovered && styles['container--hovered'],
            isDisabled && styles['container--disabled'],
        ])),
            React.createElement("div", { className: styles['heading'] },
                React.createElement("div", { className: styles['tip_wrapper'] },
                    React.createElement("span", __assign({}, utils_1.mergeStyles(styles['tip'], isGreen && styles['tip--green'], isGray && styles['tip--gray'], isYellow && styles['tip--yellow'])), deadlineData.text)),
                React.createElement("strong", { className: styles['title'] },
                    house.name,
                    titleSectionText),
                React.createElement("span", { className: styles['info'] }, offersInSaleCount
                    ? offersInSaleCount + " " + flatTypeText + " \u0432 \u043F\u0440\u043E\u0434\u0430\u0436\u0435"
                    : 'Квартиры проданы')),
            React.createElement("ul", { className: styles['house_info_list'] }, houseInfo.map(function (item) { return (React.createElement("li", { key: item.roomCount, className: styles['house_info_list_item'] },
                getHouseInfoItemLeftText(item.roomCount, item.minArea),
                React.createElement("div", { className: styles['house_info_list_item_right'] },
                    "\u043E\u0442 ",
                    utils_1.numberToPrettyString(item.minPrice),
                    " \u20BD"))); }))));
    };
    return SideBlockHouseCard;
}(React.Component));
exports.SideBlockHouseCard = SideBlockHouseCard;
function getTipSettings(status) {
    var result = {
        isGray: false,
        isGreen: false,
        isYellow: false,
    };
    switch (status) {
        case 'finished':
            result.isGreen = true;
            break;
        case 'inProject':
            result.isGray = true;
            break;
        default:
            result.isYellow = true;
            break;
    }
    return result;
}
function getHouseInfoItemLeftText(rooms, minArea) {
    return (React.createElement("div", { className: styles['house_info_list_item_left'] },
        getHouseInfoRoomsTitle(rooms),
        " \u043E\u0442 ",
        minArea,
        " \u043C",
        React.createElement("sup", null, "2")));
}
function getHouseInfoRoomsTitle(rooms) {
    switch (rooms) {
        case 6:
            return "\u041C\u043D\u043E\u0433\u043E\u043A\u043E\u043C\u043D.";
        case 7:
            return "\u0421\u0432. \u043F\u043B\u0430\u043D.";
        case 9:
            return "\u0421\u0442\u0443\u0434\u0438\u044F";
        default:
            return rooms + "-\u043A\u043E\u043C\u043D.";
    }
}


/***/ }),
/* 136 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"mvk_widget-container-gkBpj1vFWSM","container--hovered":"mvk_widget-container--hovered-laYJkH8JBAs","title":"mvk_widget-title-6HRcZ9NZD2k","container--disabled":"mvk_widget-container--disabled-7ffjiQxG1OA","info":"mvk_widget-info-8I0qjOVFQsI","house_info_list":"mvk_widget-house_info_list-8ZOy9G2D04o","house_info_list_item":"mvk_widget-house_info_list_item-hCfBiKFfd68","tip":"mvk_widget-tip-dAgLIHUIneS","tip--green":"mvk_widget-tip--green-Ru2dcp6uic","tip--gray":"mvk_widget-tip--gray-a1L5qVNMaIY","tip--yellow":"mvk_widget-tip--yellow-TUdYJgUtsA","tip_wrapper":"mvk_widget-tip_wrapper-j6sPXolLtC2"};

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var utils_1 = __webpack_require__(1);
var polygon_1 = __webpack_require__(8);
var polygons_drawer_1 = __webpack_require__(16);
var styles = __webpack_require__(138);
var CANVAS_SIZE = [84, 37];
var SideBlockOfferCard = /** @class */ (function (_super) {
    __extends(SideBlockOfferCard, _super);
    function SideBlockOfferCard() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getDrawParams = function () { return (polygon_1.getFloorPlanPolygonParams(CANVAS_SIZE, _this.props.offer.polygons.map(function (polygon) { return polygon.points; }))); };
        return _this;
    }
    SideBlockOfferCard.prototype.render = function () {
        var _a = this.props, offer = _a.offer, onSelect = _a.onSelect, isHovered = _a.isHovered, isSimilarPhase = _a.isSimilarPhase, onHover = _a.onHover;
        var price = offer.price, roomsTitle = offer.roomsTitle, area = offer.area, flatNumber = offer.flatNumber, polygons = offer.polygons, _b = offer.floor, floor = _b === void 0 ? 1 : _b;
        return (React.createElement("li", __assign({ id: "offer-card-" + flatNumber, onClick: function () { return onSelect(offer); } }, utils_1.mergeStyles([
            styles['container'],
            isHovered && styles['container--hovered'],
            isSimilarPhase && styles['container--similar_phase'],
        ]), { onMouseEnter: function () { return onHover && onHover(offer.id); }, onMouseLeave: function () { return onHover && onHover(); } }),
            React.createElement("div", { className: styles['container-left'] },
                React.createElement("strong", { className: styles['title'] },
                    roomsTitle,
                    " ",
                    area,
                    " \u043C\u00B2"),
                isSimilarPhase &&
                    React.createElement("span", { className: styles['subtitle'] },
                        floor,
                        " \u044D\u0442\u0430\u0436"),
                React.createElement("span", { className: styles['price'] },
                    utils_1.numberToPrettyString(price),
                    " \u20BD")),
            React.createElement("div", { className: styles['container-right'] },
                React.createElement(polygons_drawer_1.PolygonsDrawer, { isSidebar: true, autoResize: false, container: null, containerStyle: styles['floor-preview'], polygons: polygons || [], defaultColor: "#e4e4e4", width: CANVAS_SIZE[0], height: CANVAS_SIZE[1], backgroundDrawingAlgorythm: this.getDrawParams }))));
    };
    return SideBlockOfferCard;
}(React.Component));
exports.SideBlockOfferCard = SideBlockOfferCard;


/***/ }),
/* 138 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"mvk_widget-container-53Wuy0G1ocs","container--hovered":"mvk_widget-container--hovered-4jWSQ39ffGu","title":"mvk_widget-title-kp6JWYox1Yc","container-left":"mvk_widget-container-left-fYmWLQxoxGm","container-right":"mvk_widget-container-right-8oegE2N5p6c","floor-preview":"mvk_widget-floor-preview-hD61jSsSlMy","price":"mvk_widget-price-gE09w70oNMI","subtitle":"mvk_widget-subtitle-hwXU1QGY0wQ","container--similar_phase":"mvk_widget-container--similar_phase-arN4EqV7YOK"};

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var arrow_icon_1 = __webpack_require__(140);
var styles = __webpack_require__(141);
var TitleLink = /** @class */ (function (_super) {
    __extends(TitleLink, _super);
    function TitleLink() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TitleLink.prototype.render = function () {
        return (React.createElement("span", { onClick: this.props.onClick, className: styles['title_link'] },
            React.createElement("i", { className: styles['arrow_icon'] }, arrow_icon_1.arrowIcon),
            this.props.children));
    };
    return TitleLink;
}(React.Component));
exports.TitleLink = TitleLink;


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
// Комментарий, говорящий о необходимости отключения линтера из-за длинного path в SVG
// tslint:disable:max-line-length
exports.arrowIcon = (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 10 6" },
    React.createElement("path", { fill: "#2b87db", d: "M4.3 5.7L.1 1.6C-.2 1.2-.1.6.2.3c.3-.4.9-.4 1.3-.2L5 3.4 8.4.1c.4-.3 1-.2 1.3.2.3.4.4.9.1 1.3L5.6 5.7c-.2.2-.4.3-.6.3-.2 0-.5-.1-.7-.3z" })));


/***/ }),
/* 141 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"title_link":"mvk_widget-title_link-9zVAmLMO4g0","arrow_icon":"mvk_widget-arrow_icon-5bJ3rT2FjGa"};

/***/ }),
/* 142 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"mvk_widget-container-l66O3xxUwou","title":"mvk_widget-title-lCNbivZb8sA","title--small_margin":"mvk_widget-title--small_margin-l2BaMxfu6sa","house_list":"mvk_widget-house_list-3CQazYRoA8Q","link_wrapper":"mvk_widget-link_wrapper-wxy3aAuLD2","link":"mvk_widget-link-9EKoSkxK8gy","title--top-gradient":"mvk_widget-title--top-gradient-8ggPqC3pnyY","link_wrapper--top_gradient":"mvk_widget-link_wrapper--top_gradient-jEXKt0LWMgC","container--disabled":"mvk_widget-container--disabled-bV5MGPpshak"};

/***/ }),
/* 143 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"mvk_widget-container-ax0J3JcP0ky"};

/***/ }),
/* 144 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"content":"mvk_widget-content-263iq5HTjqc","content--fullscreen":"mvk_widget-content--fullscreen-jw9tKTdoUEM","content--side_block_collapsed":"mvk_widget-content--side_block_collapsed-aNAL9BULraC"};

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
function toggleValueInArray(value, arr) {
    if (arr === void 0) { arr = []; }
    return arr.includes(value)
        ? arr.filter(function (v) { return v !== value; })
        : __spread(arr, [value]);
}
exports.toggleValueInArray = toggleValueInArray;


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var redux_1 = __webpack_require__(10);
var redux_thunk_1 = __webpack_require__(147);
var reducers_1 = __webpack_require__(148);
var router_1 = __webpack_require__(33);
function createAppStore(initialState, context) {
    var composeEnhancers = window && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || redux_1.compose;
    return redux_1.createStore(reducers_1.createMainReducer(), initialState, composeEnhancers(redux_1.applyMiddleware(router_1.routerMiddleware, redux_thunk_1.default.withExtraArgument(context))));
}
exports.createAppStore = createAppStore;


/***/ }),
/* 147 */
/***/ (function(module, exports) {

module.exports = require("redux-thunk");

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var redux_1 = __webpack_require__(10);
var mvk_data_1 = __webpack_require__(149);
var mvk_state_1 = __webpack_require__(31);
function createMainReducer() {
    return redux_1.combineReducers({
        MVKData: mvk_data_1.mvkDataReducer,
        MVKState: mvk_state_1.mvkStateReducer,
    });
}
exports.createMainReducer = createMainReducer;


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
function mvkDataReducer(state, action) {
    switch (action.type) {
        case 'ISetFavoriteAction':
            var offers = state.offers.map(function (offer) { return offer.id === action.offerId
                ? __assign({}, offer, { isFavorite: action.isFavorite }) : offer; });
            return __assign({}, state, { offers: offers });
        default:
            return state || {};
    }
}
exports.mvkDataReducer = mvkDataReducer;


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var sections_1 = __webpack_require__(6);
var helpers_1 = __webpack_require__(11);
function getFloorPlanImageUrlByOfferId(mvkData, offerId) {
    return new Promise(function (resolve, reject) {
        var offer = mvkData.offers.find(function (o) { return o.id === offerId; });
        var section = sections_1.getSectionByOfferId(mvkData, offerId);
        if (!offer || !section) {
            reject();
            return;
        }
        var floorPlan = section.floorPlans.find(function (fp) { return fp.floors.includes(offer.floor); });
        if (!floorPlan) {
            reject();
            return;
        }
        var floorPlanFlat = floorPlan.floorPlanFlats.find(function (fpf) { return fpf.flatNumber === offer.flatNumber; });
        if (!floorPlanFlat) {
            reject();
            return;
        }
        var canvas = document.createElement('canvas');
        var ctx = canvas.getContext('2d');
        if (!ctx) {
            reject();
            return;
        }
        var img = new Image();
        var onLoadImage = function () {
            var width = img.width, height = img.height;
            canvas.width = width;
            canvas.height = height;
            ctx.drawImage(img, 0, 0, width, height, 0, 0, width, height);
            var flatPolygon = floorPlanFlat.polygon.coordinates[0][0];
            ctx.beginPath();
            var firstPoint = helpers_1.polygonCoordsOperator(flatPolygon[0][0], flatPolygon[0][1]);
            ctx.moveTo(firstPoint[1], firstPoint[0]);
            flatPolygon.forEach(function (point) {
                var coords = helpers_1.polygonCoordsOperator(point[0], point[1]);
                ctx.lineTo(coords[1], coords[0]);
            });
            ctx.closePath();
            ctx.save();
            ctx.fillStyle = "rgba(" + helpers_1.MAP_FLAT_TYPE_TO_POLYGON_COLOR[offer.roomCount] + ", " + helpers_1.POLYGON_COLOR_OPACITY.HOVER + ")";
            ctx.fill();
            ctx.restore();
            var imageUrl = canvas.toDataURL();
            resolve(imageUrl);
        };
        img.crossOrigin = 'Anonymous';
        img.onload = onLoadImage;
        img.onerror = reject;
        img.src = floorPlan.images.cianFull;
    });
}
exports.getFloorPlanImageUrlByOfferId = getFloorPlanImageUrlByOfferId;


/***/ })
/******/ ]);
//# sourceMappingURL=frontend-mvk-widget.js.map